var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1700,
    height: 1609,
    viewBox: "0 0 1700 1609",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.784 828.522C252.784 833.626 248.688 837.756 243.643 837.756C238.599 837.756 234.503 833.626 234.503 828.522C234.503 823.419 238.599 819.288 243.643 819.288C248.688 819.288 252.784 823.419 252.784 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 804.436C294.096 809.54 290 813.67 284.956 813.67C279.911 813.67 275.815 809.54 275.815 804.436C275.815 799.333 279.911 795.202 284.956 795.202C290 795.202 294.096 799.333 294.096 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 852.606C294.096 857.71 290 861.84 284.956 861.84C279.911 861.84 275.815 857.71 275.815 852.606C275.815 847.503 279.911 843.372 284.956 843.372C290 843.372 294.096 847.503 294.096 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 828.522C307.868 833.626 303.772 837.756 298.727 837.756C293.683 837.756 289.587 833.626 289.587 828.522C289.587 823.419 293.683 819.288 298.727 819.288C303.772 819.288 307.868 823.419 307.868 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 780.352C307.868 785.456 303.772 789.586 298.727 789.586C293.683 789.586 289.587 785.456 289.587 780.352C289.587 775.249 293.683 771.118 298.727 771.118C303.772 771.118 307.868 775.249 307.868 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 756.268C294.096 761.371 290 765.502 284.956 765.502C279.911 765.502 275.815 761.371 275.815 756.268C275.815 751.164 279.911 747.034 284.956 747.034C290 747.034 294.096 751.164 294.096 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 756.268C266.555 761.371 262.459 765.502 257.415 765.502C252.37 765.502 248.274 761.371 248.274 756.268C248.274 751.164 252.37 747.034 257.415 747.034C262.459 747.034 266.555 751.164 266.555 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 756.268C239.013 761.371 234.917 765.502 229.873 765.502C224.828 765.502 220.732 761.371 220.732 756.268C220.732 751.164 224.828 747.034 229.873 747.034C234.917 747.034 239.013 751.164 239.013 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 780.352C225.242 785.456 221.146 789.586 216.101 789.586C211.057 789.586 206.961 785.456 206.961 780.352C206.961 775.249 211.057 771.118 216.101 771.118C221.146 771.118 225.242 775.249 225.242 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 876.691C225.242 881.794 221.146 885.925 216.101 885.925C211.057 885.925 206.961 881.794 206.961 876.691C206.961 871.587 211.057 867.457 216.101 867.457C221.146 867.457 225.242 871.587 225.242 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 876.691C252.784 881.794 248.688 885.925 243.643 885.925C238.599 885.925 234.503 881.794 234.503 876.691C234.503 871.587 238.599 867.457 243.643 867.457C248.688 867.457 252.784 871.587 252.784 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 804.436C349.181 809.54 345.084 813.67 340.04 813.67C334.995 813.67 330.899 809.54 330.899 804.436C330.899 799.333 334.995 795.202 340.04 795.202C345.084 795.202 349.181 799.333 349.181 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 780.352C335.41 785.456 331.314 789.586 326.269 789.586C321.225 789.586 317.129 785.456 317.129 780.352C317.129 775.249 321.225 771.118 326.269 771.118C331.314 771.118 335.41 775.249 335.41 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 756.268C321.639 761.371 317.543 765.502 312.499 765.502C307.454 765.502 303.358 761.371 303.358 756.268C303.358 751.164 307.454 747.034 312.499 747.034C317.543 747.034 321.639 751.164 321.639 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 732.181C307.868 737.285 303.772 741.415 298.727 741.415C293.683 741.415 289.587 737.285 289.587 732.181C289.587 727.078 293.683 722.947 298.727 722.947C303.772 722.947 307.868 727.078 307.868 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 732.181C280.326 737.285 276.23 741.415 271.185 741.415C266.141 741.415 262.045 737.285 262.045 732.181C262.045 727.078 266.141 722.947 271.185 722.947C276.23 722.947 280.326 727.078 280.326 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 732.181C252.784 737.285 248.688 741.415 243.643 741.415C238.599 741.415 234.503 737.285 234.503 732.181C234.503 727.078 238.599 722.947 243.643 722.947C248.688 722.947 252.784 727.078 252.784 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 732.181C225.242 737.285 221.146 741.415 216.101 741.415C211.057 741.415 206.961 737.285 206.961 732.181C206.961 727.078 211.057 722.947 216.101 722.947C221.146 722.947 225.242 727.078 225.242 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 756.268C211.473 761.371 207.377 765.502 202.333 765.502C197.288 765.502 193.192 761.371 193.192 756.268C193.192 751.164 197.288 747.034 202.333 747.034C207.377 747.034 211.473 751.164 211.473 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 780.352C197.703 785.456 193.607 789.586 188.562 789.586C183.518 789.586 179.421 785.456 179.421 780.352C179.421 775.249 183.518 771.118 188.562 771.118C193.607 771.118 197.703 775.249 197.703 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 804.436C183.93 809.54 179.834 813.67 174.79 813.67C169.745 813.67 165.649 809.54 165.649 804.436C165.649 799.333 169.745 795.202 174.79 795.202C179.834 795.202 183.93 799.333 183.93 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 900.777C211.473 905.881 207.377 910.011 202.333 910.011C197.288 910.011 193.192 905.881 193.192 900.777C193.192 895.674 197.288 891.543 202.333 891.543C207.377 891.543 211.473 895.674 211.473 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 900.777C239.013 905.881 234.917 910.011 229.873 910.011C224.828 910.011 220.732 905.881 220.732 900.777C220.732 895.674 224.828 891.543 229.873 891.543C234.917 891.543 239.013 895.674 239.013 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 900.777C266.555 905.881 262.459 910.011 257.415 910.011C252.37 910.011 248.274 905.881 248.274 900.777C248.274 895.674 252.37 891.543 257.415 891.543C262.459 891.543 266.555 895.674 266.555 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 900.777C294.096 905.881 290 910.011 284.956 910.011C279.911 910.011 275.815 905.881 275.815 900.777C275.815 895.674 279.911 891.543 284.956 891.543C290 891.543 294.096 895.674 294.096 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.712 828.522C357.712 830.704 355.961 832.467 353.809 832.467C351.658 832.467 349.907 830.704 349.907 828.522C349.907 826.34 351.658 824.577 353.809 824.577C355.961 824.577 357.712 826.34 357.712 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 804.436C376.72 809.54 372.624 813.67 367.58 813.67C362.535 813.67 358.439 809.54 358.439 804.436C358.439 799.333 362.535 795.202 367.58 795.202C372.624 795.202 376.72 799.333 376.72 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 780.352C362.951 785.456 358.855 789.586 353.81 789.586C348.766 789.586 344.67 785.456 344.67 780.352C344.67 775.249 348.766 771.118 353.81 771.118C358.855 771.118 362.951 775.249 362.951 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 756.268C349.181 761.371 345.084 765.502 340.04 765.502C334.995 765.502 330.899 761.371 330.899 756.268C330.899 751.164 334.995 747.034 340.04 747.034C345.084 747.034 349.181 751.164 349.181 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 732.181C335.41 737.285 331.314 741.415 326.269 741.415C321.225 741.415 317.129 737.285 317.129 732.181C317.129 727.078 321.225 722.947 326.269 722.947C331.314 722.947 335.41 727.078 335.41 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 708.097C321.639 713.201 317.543 717.331 312.499 717.331C307.454 717.331 303.358 713.201 303.358 708.097C303.358 702.994 307.454 698.863 312.499 698.863C317.543 698.863 321.639 702.994 321.639 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 708.097C294.096 713.201 290 717.331 284.956 717.331C279.911 717.331 275.815 713.201 275.815 708.097C275.815 702.994 279.911 698.863 284.956 698.863C290 698.863 294.096 702.994 294.096 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 708.097C266.555 713.201 262.459 717.331 257.415 717.331C252.37 717.331 248.274 713.201 248.274 708.097C248.274 702.994 252.37 698.863 257.415 698.863C262.459 698.863 266.555 702.994 266.555 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 708.097C239.013 713.201 234.917 717.331 229.873 717.331C224.828 717.331 220.732 713.201 220.732 708.097C220.732 702.994 224.828 698.863 229.873 698.863C234.917 698.863 239.013 702.994 239.013 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 708.097C211.473 713.201 207.377 717.331 202.333 717.331C197.288 717.331 193.192 713.201 193.192 708.097C193.192 702.994 197.288 698.863 202.333 698.863C207.377 698.863 211.473 702.994 211.473 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 732.181C197.703 737.285 193.607 741.415 188.562 741.415C183.518 741.415 179.421 737.285 179.421 732.181C179.421 727.078 183.518 722.947 188.562 722.947C193.607 722.947 197.703 727.078 197.703 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 756.268C183.93 761.371 179.834 765.502 174.79 765.502C169.745 765.502 165.649 761.371 165.649 756.268C165.649 751.164 169.745 747.034 174.79 747.034C179.834 747.034 183.93 751.164 183.93 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 804.436C156.388 809.54 152.292 813.67 147.248 813.67C142.203 813.67 138.107 809.54 138.107 804.436C138.107 799.333 142.203 795.202 147.248 795.202C152.292 795.202 156.388 799.333 156.388 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 828.522C170.16 833.626 166.064 837.756 161.019 837.756C155.975 837.756 151.879 833.626 151.879 828.522C151.879 823.419 155.975 819.288 161.019 819.288C166.064 819.288 170.16 823.419 170.16 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 876.691C197.703 881.794 193.607 885.925 188.562 885.925C183.518 885.925 179.421 881.794 179.421 876.691C179.421 871.587 183.518 867.457 188.562 867.457C193.607 867.457 197.703 871.587 197.703 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 924.861C197.703 929.965 193.607 934.095 188.562 934.095C183.518 934.095 179.421 929.965 179.421 924.861C179.421 919.758 183.518 915.628 188.562 915.628C193.607 915.628 197.703 919.758 197.703 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 924.861C225.242 929.965 221.146 934.095 216.101 934.095C211.057 934.095 206.961 929.965 206.961 924.861C206.961 919.758 211.057 915.628 216.101 915.628C221.146 915.628 225.242 919.758 225.242 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 924.861C252.784 929.965 248.688 934.095 243.643 934.095C238.599 934.095 234.503 929.965 234.503 924.861C234.503 919.758 238.599 915.628 243.643 915.628C248.688 915.628 252.784 919.758 252.784 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 924.861C280.326 929.965 276.23 934.095 271.185 934.095C266.141 934.095 262.045 929.965 262.045 924.861C262.045 919.758 266.141 915.628 271.185 915.628C276.23 915.628 280.326 919.758 280.326 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 924.861C307.868 929.965 303.772 934.095 298.727 934.095C293.683 934.095 289.587 929.965 289.587 924.861C289.587 919.758 293.683 915.628 298.727 915.628C303.772 915.628 307.868 919.758 307.868 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 924.861C335.41 929.965 331.314 934.095 326.269 934.095C321.225 934.095 317.129 929.965 317.129 924.861C317.129 919.758 321.225 915.628 326.269 915.628C331.314 915.628 335.41 919.758 335.41 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 900.777C349.181 905.881 345.084 910.011 340.04 910.011C334.995 910.011 330.899 905.881 330.899 900.777C330.899 895.674 334.995 891.543 340.04 891.543C345.084 891.543 349.181 895.674 349.181 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 804.436C404.262 809.54 400.166 813.67 395.122 813.67C390.077 813.67 385.981 809.54 385.981 804.436C385.981 799.333 390.077 795.202 395.122 795.202C400.166 795.202 404.262 799.333 404.262 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 780.352C390.493 785.456 386.397 789.586 381.352 789.586C376.308 789.586 372.212 785.456 372.212 780.352C372.212 775.249 376.308 771.118 381.352 771.118C386.397 771.118 390.493 775.249 390.493 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 756.268C376.72 761.371 372.624 765.502 367.58 765.502C362.535 765.502 358.439 761.371 358.439 756.268C358.439 751.164 362.535 747.034 367.58 747.034C372.624 747.034 376.72 751.164 376.72 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 732.181C362.951 737.285 358.855 741.415 353.81 741.415C348.766 741.415 344.67 737.285 344.67 732.181C344.67 727.078 348.766 722.947 353.81 722.947C358.855 722.947 362.951 727.078 362.951 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 708.097C349.181 713.201 345.084 717.331 340.04 717.331C334.995 717.331 330.899 713.201 330.899 708.097C330.899 702.994 334.995 698.863 340.04 698.863C345.084 698.863 349.181 702.994 349.181 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 684.013C335.41 689.116 331.314 693.247 326.269 693.247C321.225 693.247 317.129 689.116 317.129 684.013C317.129 678.909 321.225 674.779 326.269 674.779C331.314 674.779 335.41 678.909 335.41 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 684.013C307.868 689.116 303.772 693.247 298.727 693.247C293.683 693.247 289.587 689.116 289.587 684.013C289.587 678.909 293.683 674.779 298.727 674.779C303.772 674.779 307.868 678.909 307.868 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 684.013C280.326 689.116 276.23 693.247 271.185 693.247C266.141 693.247 262.045 689.116 262.045 684.013C262.045 678.909 266.141 674.779 271.185 674.779C276.23 674.779 280.326 678.909 280.326 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 684.013C252.784 689.116 248.688 693.247 243.643 693.247C238.599 693.247 234.503 689.116 234.503 684.013C234.503 678.909 238.599 674.779 243.643 674.779C248.688 674.779 252.784 678.909 252.784 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 684.013C225.242 689.116 221.146 693.247 216.101 693.247C211.057 693.247 206.961 689.116 206.961 684.013C206.961 678.909 211.057 674.779 216.101 674.779C221.146 674.779 225.242 678.909 225.242 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 732.181C170.16 737.285 166.064 741.415 161.019 741.415C155.975 741.415 151.879 737.285 151.879 732.181C151.879 727.078 155.975 722.947 161.019 722.947C166.064 722.947 170.16 727.078 170.16 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 804.436C128.847 809.54 124.751 813.67 119.707 813.67C114.662 813.67 110.566 809.54 110.566 804.436C110.566 799.333 114.662 795.202 119.707 795.202C124.751 795.202 128.847 799.333 128.847 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 828.522C142.618 833.626 138.522 837.756 133.477 837.756C128.433 837.756 124.337 833.626 124.337 828.522C124.337 823.419 128.433 819.288 133.477 819.288C138.522 819.288 142.618 823.419 142.618 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 852.606C156.388 857.71 152.292 861.84 147.248 861.84C142.203 861.84 138.107 857.71 138.107 852.606C138.107 847.503 142.203 843.372 147.248 843.372C152.292 843.372 156.388 847.503 156.388 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.411 876.691C169.411 881.377 165.65 885.17 161.019 885.17C156.388 885.17 152.627 881.377 152.627 876.691C152.627 872.005 156.388 868.213 161.019 868.213C165.65 868.213 169.411 872.005 169.411 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 900.777C183.93 905.881 179.834 910.011 174.79 910.011C169.745 910.011 165.649 905.881 165.649 900.777C165.649 895.674 169.745 891.543 174.79 891.543C179.834 891.543 183.93 895.674 183.93 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 948.945C183.93 954.049 179.834 958.179 174.79 958.179C169.745 958.179 165.649 954.049 165.649 948.945C165.649 943.842 169.745 939.712 174.79 939.712C179.834 939.712 183.93 943.842 183.93 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 948.945C211.473 954.049 207.377 958.179 202.333 958.179C197.288 958.179 193.192 954.049 193.192 948.945C193.192 943.842 197.288 939.712 202.333 939.712C207.377 939.712 211.473 943.842 211.473 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 948.945C239.013 954.049 234.917 958.179 229.873 958.179C224.828 958.179 220.732 954.049 220.732 948.945C220.732 943.842 224.828 939.712 229.873 939.712C234.917 939.712 239.013 943.842 239.013 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 948.945C266.555 954.049 262.459 958.179 257.415 958.179C252.37 958.179 248.274 954.049 248.274 948.945C248.274 943.842 252.37 939.712 257.415 939.712C262.459 939.712 266.555 943.842 266.555 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 948.945C294.096 954.049 290 958.179 284.956 958.179C279.911 958.179 275.815 954.049 275.815 948.945C275.815 943.842 279.911 939.712 284.956 939.712C290 939.712 294.096 943.842 294.096 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 948.945C321.639 954.049 317.543 958.179 312.499 958.179C307.454 958.179 303.358 954.049 303.358 948.945C303.358 943.842 307.454 939.712 312.499 939.712C317.543 939.712 321.639 943.842 321.639 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 948.945C349.181 954.049 345.084 958.179 340.04 958.179C334.995 958.179 330.899 954.049 330.899 948.945C330.899 943.842 334.995 939.712 340.04 939.712C345.084 939.712 349.181 943.842 349.181 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 924.861C362.951 929.965 358.855 934.095 353.81 934.095C348.766 934.095 344.67 929.965 344.67 924.861C344.67 919.758 348.766 915.628 353.81 915.628C358.855 915.628 362.951 919.758 362.951 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 852.606C404.262 857.71 400.166 861.84 395.122 861.84C390.077 861.84 385.981 857.71 385.981 852.606C385.981 847.503 390.077 843.372 395.122 843.372C400.166 843.372 404.262 847.503 404.262 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 828.522C418.035 833.626 413.939 837.756 408.894 837.756C403.85 837.756 399.754 833.626 399.754 828.522C399.754 823.419 403.85 819.288 408.894 819.288C413.939 819.288 418.035 823.419 418.035 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 756.268C404.262 761.371 400.166 765.502 395.122 765.502C390.077 765.502 385.981 761.371 385.981 756.268C385.981 751.164 390.077 747.034 395.122 747.034C400.166 747.034 404.262 751.164 404.262 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 732.181C390.493 737.285 386.397 741.415 381.352 741.415C376.308 741.415 372.212 737.285 372.212 732.181C372.212 727.078 376.308 722.947 381.352 722.947C386.397 722.947 390.493 727.078 390.493 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 708.097C376.72 713.201 372.624 717.331 367.58 717.331C362.535 717.331 358.439 713.201 358.439 708.097C358.439 702.994 362.535 698.863 367.58 698.863C372.624 698.863 376.72 702.994 376.72 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 684.013C362.951 689.116 358.855 693.247 353.81 693.247C348.766 693.247 344.67 689.116 344.67 684.013C344.67 678.909 348.766 674.779 353.81 674.779C358.855 674.779 362.951 678.909 362.951 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 659.927C349.181 665.03 345.084 669.161 340.04 669.161C334.995 669.161 330.899 665.03 330.899 659.927C330.899 654.823 334.995 650.693 340.04 650.693C345.084 650.693 349.181 654.823 349.181 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 659.927C321.639 665.03 317.543 669.161 312.499 669.161C307.454 669.161 303.358 665.03 303.358 659.927C303.358 654.823 307.454 650.693 312.499 650.693C317.543 650.693 321.639 654.823 321.639 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 684.013C170.16 689.116 166.064 693.247 161.019 693.247C155.975 693.247 151.879 689.116 151.879 684.013C151.879 678.909 155.975 674.779 161.019 674.779C166.064 674.779 170.16 678.909 170.16 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 828.522C115.076 833.626 110.98 837.756 105.935 837.756C100.891 837.756 96.7945 833.626 96.7945 828.522C96.7945 823.419 100.891 819.288 105.935 819.288C110.98 819.288 115.076 823.419 115.076 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 852.606C128.847 857.71 124.751 861.84 119.707 861.84C114.662 861.84 110.566 857.71 110.566 852.606C110.566 847.503 114.662 843.372 119.707 843.372C124.751 843.372 128.847 847.503 128.847 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 900.777C156.388 905.881 152.292 910.011 147.248 910.011C142.203 910.011 138.107 905.881 138.107 900.777C138.107 895.674 142.203 891.543 147.248 891.543C152.292 891.543 156.388 895.674 156.388 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 924.861C170.16 929.965 166.064 934.095 161.019 934.095C155.975 934.095 151.879 929.965 151.879 924.861C151.879 919.758 155.975 915.628 161.019 915.628C166.064 915.628 170.16 919.758 170.16 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 973.032C170.16 978.135 166.064 982.266 161.019 982.266C155.975 982.266 151.879 978.135 151.879 973.032C151.879 967.928 155.975 963.798 161.019 963.798C166.064 963.798 170.16 967.928 170.16 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 973.032C197.703 978.135 193.607 982.266 188.562 982.266C183.518 982.266 179.421 978.135 179.421 973.032C179.421 967.928 183.518 963.798 188.562 963.798C193.607 963.798 197.703 967.928 197.703 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 973.032C225.242 978.135 221.146 982.266 216.101 982.266C211.057 982.266 206.961 978.135 206.961 973.032C206.961 967.928 211.057 963.798 216.101 963.798C221.146 963.798 225.242 967.928 225.242 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 973.032C252.784 978.135 248.688 982.266 243.643 982.266C238.599 982.266 234.503 978.135 234.503 973.032C234.503 967.928 238.599 963.798 243.643 963.798C248.688 963.798 252.784 967.928 252.784 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 973.032C280.326 978.135 276.23 982.266 271.185 982.266C266.141 982.266 262.045 978.135 262.045 973.032C262.045 967.928 266.141 963.798 271.185 963.798C276.23 963.798 280.326 967.928 280.326 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 973.032C307.868 978.135 303.772 982.266 298.727 982.266C293.683 982.266 289.587 978.135 289.587 973.032C289.587 967.928 293.683 963.798 298.727 963.798C303.772 963.798 307.868 967.928 307.868 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 973.032C335.41 978.135 331.314 982.266 326.269 982.266C321.225 982.266 317.129 978.135 317.129 973.032C317.129 967.928 321.225 963.798 326.269 963.798C331.314 963.798 335.41 967.928 335.41 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 973.032C362.951 978.135 358.855 982.266 353.81 982.266C348.766 982.266 344.67 978.135 344.67 973.032C344.67 967.928 348.766 963.798 353.81 963.798C358.855 963.798 362.951 967.928 362.951 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 948.945C376.72 954.049 372.624 958.179 367.58 958.179C362.535 958.179 358.439 954.049 358.439 948.945C358.439 943.842 362.535 939.712 367.58 939.712C372.624 939.712 376.72 943.842 376.72 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 924.861C390.493 929.965 386.397 934.095 381.352 934.095C376.308 934.095 372.212 929.965 372.212 924.861C372.212 919.758 376.308 915.628 381.352 915.628C386.397 915.628 390.493 919.758 390.493 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 852.606C431.806 857.71 427.709 861.84 422.665 861.84C417.62 861.84 413.524 857.71 413.524 852.606C413.524 847.503 417.62 843.372 422.665 843.372C427.709 843.372 431.806 847.503 431.806 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 828.522C445.575 833.626 441.479 837.756 436.434 837.756C431.39 837.756 427.294 833.626 427.294 828.522C427.294 823.419 431.39 819.288 436.434 819.288C441.479 819.288 445.575 823.419 445.575 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 732.181C418.035 737.285 413.939 741.415 408.894 741.415C403.85 741.415 399.754 737.285 399.754 732.181C399.754 727.078 403.85 722.947 408.894 722.947C413.939 722.947 418.035 727.078 418.035 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 708.097C404.262 713.201 400.166 717.331 395.122 717.331C390.077 717.331 385.981 713.201 385.981 708.097C385.981 702.994 390.077 698.863 395.122 698.863C400.166 698.863 404.262 702.994 404.262 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 684.013C390.493 689.116 386.397 693.247 381.352 693.247C376.308 693.247 372.212 689.116 372.212 684.013C372.212 678.909 376.308 674.779 381.352 674.779C386.397 674.779 390.493 678.909 390.493 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 659.927C376.72 665.03 372.624 669.161 367.58 669.161C362.535 669.161 358.439 665.03 358.439 659.927C358.439 654.823 362.535 650.693 367.58 650.693C372.624 650.693 376.72 654.823 376.72 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 635.842C362.951 640.946 358.855 645.076 353.81 645.076C348.766 645.076 344.67 640.946 344.67 635.842C344.67 630.739 348.766 626.608 353.81 626.608C358.855 626.608 362.951 630.739 362.951 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 635.842C280.326 640.946 276.23 645.076 271.185 645.076C266.141 645.076 262.045 640.946 262.045 635.842C262.045 630.739 266.141 626.608 271.185 626.608C276.23 626.608 280.326 630.739 280.326 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 635.842C252.784 640.946 248.688 645.076 243.643 645.076C238.599 645.076 234.503 640.946 234.503 635.842C234.503 630.739 238.599 626.608 243.643 626.608C248.688 626.608 252.784 630.739 252.784 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 900.777C128.847 905.881 124.751 910.011 119.707 910.011C114.662 910.011 110.566 905.881 110.566 900.777C110.566 895.674 114.662 891.543 119.707 891.543C124.751 891.543 128.847 895.674 128.847 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 924.861C142.618 929.965 138.522 934.095 133.477 934.095C128.433 934.095 124.337 929.965 124.337 924.861C124.337 919.758 128.433 915.628 133.477 915.628C138.522 915.628 142.618 919.758 142.618 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 948.945C156.388 954.049 152.292 958.179 147.248 958.179C142.203 958.179 138.107 954.049 138.107 948.945C138.107 943.842 142.203 939.712 147.248 939.712C152.292 939.712 156.388 943.842 156.388 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 997.116C156.388 1002.22 152.292 1006.35 147.248 1006.35C142.203 1006.35 138.107 1002.22 138.107 997.116C138.107 992.013 142.203 987.882 147.248 987.882C152.292 987.882 156.388 992.013 156.388 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 997.116C183.93 1002.22 179.834 1006.35 174.79 1006.35C169.745 1006.35 165.649 1002.22 165.649 997.116C165.649 992.013 169.745 987.882 174.79 987.882C179.834 987.882 183.93 992.013 183.93 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 997.116C211.473 1002.22 207.377 1006.35 202.333 1006.35C197.288 1006.35 193.192 1002.22 193.192 997.116C193.192 992.013 197.288 987.882 202.333 987.882C207.377 987.882 211.473 992.013 211.473 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 997.116C239.013 1002.22 234.917 1006.35 229.873 1006.35C224.828 1006.35 220.732 1002.22 220.732 997.116C220.732 992.013 224.828 987.882 229.873 987.882C234.917 987.882 239.013 992.013 239.013 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 997.116C266.555 1002.22 262.459 1006.35 257.415 1006.35C252.37 1006.35 248.274 1002.22 248.274 997.116C248.274 992.013 252.37 987.882 257.415 987.882C262.459 987.882 266.555 992.013 266.555 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 997.116C294.096 1002.22 290 1006.35 284.956 1006.35C279.911 1006.35 275.815 1002.22 275.815 997.116C275.815 992.013 279.911 987.882 284.956 987.882C290 987.882 294.096 992.013 294.096 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 997.116C321.639 1002.22 317.543 1006.35 312.499 1006.35C307.454 1006.35 303.358 1002.22 303.358 997.116C303.358 992.013 307.454 987.882 312.499 987.882C317.543 987.882 321.639 992.013 321.639 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 997.116C349.181 1002.22 345.084 1006.35 340.04 1006.35C334.995 1006.35 330.899 1002.22 330.899 997.116C330.899 992.013 334.995 987.882 340.04 987.882C345.084 987.882 349.181 992.013 349.181 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 997.116C376.72 1002.22 372.624 1006.35 367.58 1006.35C362.535 1006.35 358.439 1002.22 358.439 997.116C358.439 992.013 362.535 987.882 367.58 987.882C372.624 987.882 376.72 992.013 376.72 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 973.032C390.493 978.135 386.397 982.266 381.352 982.266C376.308 982.266 372.212 978.135 372.212 973.032C372.212 967.928 376.308 963.798 381.352 963.798C386.397 963.798 390.493 967.928 390.493 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 948.945C404.262 954.049 400.166 958.179 395.122 958.179C390.077 958.179 385.981 954.049 385.981 948.945C385.981 943.842 390.077 939.712 395.122 939.712C400.166 939.712 404.262 943.842 404.262 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 924.861C418.035 929.965 413.939 934.095 408.894 934.095C403.85 934.095 399.754 929.965 399.754 924.861C399.754 919.758 403.85 915.628 408.894 915.628C413.939 915.628 418.035 919.758 418.035 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 852.606C459.346 857.71 455.25 861.84 450.206 861.84C445.161 861.84 441.065 857.71 441.065 852.606C441.065 847.503 445.161 843.372 450.206 843.372C455.25 843.372 459.346 847.503 459.346 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 828.522C473.117 833.626 469.021 837.756 463.976 837.756C458.932 837.756 454.836 833.626 454.836 828.522C454.836 823.419 458.932 819.288 463.976 819.288C469.021 819.288 473.117 823.419 473.117 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 756.268C459.346 761.371 455.25 765.502 450.206 765.502C445.161 765.502 441.065 761.371 441.065 756.268C441.065 751.164 445.161 747.034 450.206 747.034C455.25 747.034 459.346 751.164 459.346 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 732.181C445.575 737.285 441.479 741.415 436.434 741.415C431.39 741.415 427.294 737.285 427.294 732.181C427.294 727.078 431.39 722.947 436.434 722.947C441.479 722.947 445.575 727.078 445.575 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 708.097C431.806 713.201 427.709 717.331 422.665 717.331C417.62 717.331 413.524 713.201 413.524 708.097C413.524 702.994 417.62 698.863 422.665 698.863C427.709 698.863 431.806 702.994 431.806 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 684.013C418.035 689.116 413.939 693.247 408.894 693.247C403.85 693.247 399.754 689.116 399.754 684.013C399.754 678.909 403.85 674.779 408.894 674.779C413.939 674.779 418.035 678.909 418.035 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 659.927C404.262 665.03 400.166 669.161 395.122 669.161C390.077 669.161 385.981 665.03 385.981 659.927C385.981 654.823 390.077 650.693 395.122 650.693C400.166 650.693 404.262 654.823 404.262 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 635.842C390.493 640.946 386.397 645.076 381.352 645.076C376.308 645.076 372.212 640.946 372.212 635.842C372.212 630.739 376.308 626.608 381.352 626.608C386.397 626.608 390.493 630.739 390.493 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 611.758C376.72 616.862 372.624 620.992 367.58 620.992C362.535 620.992 358.439 616.862 358.439 611.758C358.439 606.655 362.535 602.525 367.58 602.525C372.624 602.525 376.72 606.655 376.72 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 611.758C294.096 616.862 290 620.992 284.956 620.992C279.911 620.992 275.815 616.862 275.815 611.758C275.815 606.655 279.911 602.525 284.956 602.525C290 602.525 294.096 606.655 294.096 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 611.758C156.388 616.862 152.292 620.992 147.248 620.992C142.203 620.992 138.107 616.862 138.107 611.758C138.107 606.655 142.203 602.525 147.248 602.525C152.292 602.525 156.388 606.655 156.388 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 635.842C142.618 640.946 138.522 645.076 133.477 645.076C128.433 645.076 124.337 640.946 124.337 635.842C124.337 630.739 128.433 626.608 133.477 626.608C138.522 626.608 142.618 630.739 142.618 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.351 659.926C127.351 664.195 123.925 667.649 119.707 667.649C115.489 667.649 112.063 664.195 112.063 659.926C112.063 655.657 115.489 652.203 119.707 652.203C123.925 652.203 127.351 655.657 127.351 659.926Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 684.013C115.076 689.116 110.98 693.247 105.935 693.247C100.891 693.247 96.7945 689.116 96.7945 684.013C96.7945 678.909 100.891 674.779 105.935 674.779C110.98 674.779 115.076 678.909 115.076 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 924.861C115.076 929.965 110.98 934.095 105.935 934.095C100.891 934.095 96.7945 929.965 96.7945 924.861C96.7945 919.758 100.891 915.628 105.935 915.628C110.98 915.628 115.076 919.758 115.076 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 948.945C128.847 954.049 124.751 958.179 119.707 958.179C114.662 958.179 110.566 954.049 110.566 948.945C110.566 943.842 114.662 939.712 119.707 939.712C124.751 939.712 128.847 943.842 128.847 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 973.032C142.618 978.135 138.522 982.266 133.477 982.266C128.433 982.266 124.337 978.135 124.337 973.032C124.337 967.928 128.433 963.798 133.477 963.798C138.522 963.798 142.618 967.928 142.618 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 1021.2C142.618 1026.3 138.522 1030.43 133.477 1030.43C128.433 1030.43 124.337 1026.3 124.337 1021.2C124.337 1016.1 128.433 1011.97 133.477 1011.97C138.522 1011.97 142.618 1016.1 142.618 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 1021.2C170.16 1026.3 166.064 1030.43 161.019 1030.43C155.975 1030.43 151.879 1026.3 151.879 1021.2C151.879 1016.1 155.975 1011.97 161.019 1011.97C166.064 1011.97 170.16 1016.1 170.16 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 1021.2C197.703 1026.3 193.607 1030.43 188.562 1030.43C183.518 1030.43 179.421 1026.3 179.421 1021.2C179.421 1016.1 183.518 1011.97 188.562 1011.97C193.607 1011.97 197.703 1016.1 197.703 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 1021.2C225.242 1026.3 221.146 1030.43 216.101 1030.43C211.057 1030.43 206.961 1026.3 206.961 1021.2C206.961 1016.1 211.057 1011.97 216.101 1011.97C221.146 1011.97 225.242 1016.1 225.242 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 1021.2C252.784 1026.3 248.688 1030.43 243.643 1030.43C238.599 1030.43 234.503 1026.3 234.503 1021.2C234.503 1016.1 238.599 1011.97 243.643 1011.97C248.688 1011.97 252.784 1016.1 252.784 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1021.2C280.326 1026.3 276.23 1030.43 271.185 1030.43C266.141 1030.43 262.045 1026.3 262.045 1021.2C262.045 1016.1 266.141 1011.97 271.185 1011.97C276.23 1011.97 280.326 1016.1 280.326 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1021.2C307.868 1026.3 303.772 1030.43 298.727 1030.43C293.683 1030.43 289.587 1026.3 289.587 1021.2C289.587 1016.1 293.683 1011.97 298.727 1011.97C303.772 1011.97 307.868 1016.1 307.868 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 1021.2C335.41 1026.3 331.314 1030.43 326.269 1030.43C321.225 1030.43 317.129 1026.3 317.129 1021.2C317.129 1016.1 321.225 1011.97 326.269 1011.97C331.314 1011.97 335.41 1016.1 335.41 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1021.2C362.951 1026.3 358.855 1030.43 353.81 1030.43C348.766 1030.43 344.67 1026.3 344.67 1021.2C344.67 1016.1 348.766 1011.97 353.81 1011.97C358.855 1011.97 362.951 1016.1 362.951 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1021.2C390.493 1026.3 386.397 1030.43 381.352 1030.43C376.308 1030.43 372.212 1026.3 372.212 1021.2C372.212 1016.1 376.308 1011.97 381.352 1011.97C386.397 1011.97 390.493 1016.1 390.493 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 997.116C404.262 1002.22 400.166 1006.35 395.122 1006.35C390.077 1006.35 385.981 1002.22 385.981 997.116C385.981 992.013 390.077 987.882 395.122 987.882C400.166 987.882 404.262 992.013 404.262 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 973.032C418.035 978.135 413.939 982.266 408.894 982.266C403.85 982.266 399.754 978.135 399.754 973.032C399.754 967.928 403.85 963.798 408.894 963.798C413.939 963.798 418.035 967.928 418.035 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 948.945C431.806 954.049 427.709 958.179 422.665 958.179C417.62 958.179 413.524 954.049 413.524 948.945C413.524 943.842 417.62 939.712 422.665 939.712C427.709 939.712 431.806 943.842 431.806 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 924.861C445.575 929.965 441.479 934.095 436.434 934.095C431.39 934.095 427.294 929.965 427.294 924.861C427.294 919.758 431.39 915.628 436.434 915.628C441.479 915.628 445.575 919.758 445.575 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 876.691C473.117 881.794 469.021 885.925 463.976 885.925C458.932 885.925 454.836 881.794 454.836 876.691C454.836 871.587 458.932 867.457 463.976 867.457C469.021 867.457 473.117 871.587 473.117 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 852.606C486.889 857.71 482.793 861.84 477.749 861.84C472.704 861.84 468.608 857.71 468.608 852.606C468.608 847.503 472.704 843.372 477.749 843.372C482.793 843.372 486.889 847.503 486.889 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 828.522C500.659 833.626 496.563 837.756 491.518 837.756C486.474 837.756 482.378 833.626 482.378 828.522C482.378 823.419 486.474 819.288 491.518 819.288C496.563 819.288 500.659 823.419 500.659 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 780.352C500.659 785.456 496.563 789.586 491.518 789.586C486.474 789.586 482.378 785.456 482.378 780.352C482.378 775.249 486.474 771.118 491.518 771.118C496.563 771.118 500.659 775.249 500.659 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.391 756.268C485.391 760.536 481.965 763.99 477.747 763.99C473.529 763.99 470.103 760.536 470.103 756.268C470.103 751.999 473.529 748.545 477.747 748.545C481.965 748.545 485.391 751.999 485.391 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 732.181C473.117 737.285 469.021 741.415 463.976 741.415C458.932 741.415 454.836 737.285 454.836 732.181C454.836 727.078 458.932 722.947 463.976 722.947C469.021 722.947 473.117 727.078 473.117 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 708.097C459.346 713.201 455.25 717.331 450.206 717.331C445.161 717.331 441.065 713.201 441.065 708.097C441.065 702.994 445.161 698.863 450.206 698.863C455.25 698.863 459.346 702.994 459.346 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 684.013C445.575 689.116 441.479 693.247 436.434 693.247C431.39 693.247 427.294 689.116 427.294 684.013C427.294 678.909 431.39 674.779 436.434 674.779C441.479 674.779 445.575 678.909 445.575 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 659.927C431.806 665.03 427.709 669.161 422.665 669.161C417.62 669.161 413.524 665.03 413.524 659.927C413.524 654.823 417.62 650.693 422.665 650.693C427.709 650.693 431.806 654.823 431.806 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 635.842C418.035 640.946 413.939 645.076 408.894 645.076C403.85 645.076 399.754 640.946 399.754 635.842C399.754 630.739 403.85 626.608 408.894 626.608C413.939 626.608 418.035 630.739 418.035 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 611.758C404.262 616.862 400.166 620.992 395.122 620.992C390.077 620.992 385.981 616.862 385.981 611.758C385.981 606.655 390.077 602.525 395.122 602.525C400.166 602.525 404.262 606.655 404.262 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 587.672C390.493 592.775 386.397 596.906 381.352 596.906C376.308 596.906 372.212 592.775 372.212 587.672C372.212 582.568 376.308 578.438 381.352 578.438C386.397 578.438 390.493 582.568 390.493 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 587.672C362.951 592.775 358.855 596.906 353.81 596.906C348.766 596.906 344.67 592.775 344.67 587.672C344.67 582.568 348.766 578.438 353.81 578.438C358.855 578.438 362.951 582.568 362.951 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 587.672C307.868 592.775 303.772 596.906 298.727 596.906C293.683 596.906 289.587 592.775 289.587 587.672C289.587 582.568 293.683 578.438 298.727 578.438C303.772 578.438 307.868 582.568 307.868 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 587.672C280.326 592.775 276.23 596.906 271.185 596.906C266.141 596.906 262.045 592.775 262.045 587.672C262.045 582.568 266.141 578.438 271.185 578.438C276.23 578.438 280.326 582.568 280.326 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 587.672C252.784 592.775 248.688 596.906 243.643 596.906C238.599 596.906 234.503 592.775 234.503 587.672C234.503 582.568 238.599 578.438 243.643 578.438C248.688 578.438 252.784 582.568 252.784 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.305 948.945C101.305 954.049 97.2093 958.179 92.1647 958.179C87.1201 958.179 83.024 954.049 83.024 948.945C83.024 943.842 87.1201 939.712 92.1647 939.712C97.2093 939.712 101.305 943.842 101.305 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 973.032C115.076 978.135 110.98 982.266 105.935 982.266C100.891 982.266 96.7945 978.135 96.7945 973.032C96.7945 967.928 100.891 963.798 105.935 963.798C110.98 963.798 115.076 967.928 115.076 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 997.116C128.847 1002.22 124.751 1006.35 119.707 1006.35C114.662 1006.35 110.566 1002.22 110.566 997.116C110.566 992.013 114.662 987.882 119.707 987.882C124.751 987.882 128.847 992.013 128.847 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 1045.29C128.847 1050.39 124.751 1054.52 119.707 1054.52C114.662 1054.52 110.566 1050.39 110.566 1045.29C110.566 1040.18 114.662 1036.05 119.707 1036.05C124.751 1036.05 128.847 1040.18 128.847 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 1045.29C156.388 1050.39 152.292 1054.52 147.248 1054.52C142.203 1054.52 138.107 1050.39 138.107 1045.29C138.107 1040.18 142.203 1036.05 147.248 1036.05C152.292 1036.05 156.388 1040.18 156.388 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 1045.29C183.93 1050.39 179.834 1054.52 174.79 1054.52C169.745 1054.52 165.649 1050.39 165.649 1045.29C165.649 1040.18 169.745 1036.05 174.79 1036.05C179.834 1036.05 183.93 1040.18 183.93 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.473 1045.29C211.473 1050.39 207.377 1054.52 202.333 1054.52C197.288 1054.52 193.192 1050.39 193.192 1045.29C193.192 1040.18 197.288 1036.05 202.333 1036.05C207.377 1036.05 211.473 1040.18 211.473 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 1045.29C239.013 1050.39 234.917 1054.52 229.873 1054.52C224.828 1054.52 220.732 1050.39 220.732 1045.29C220.732 1040.18 224.828 1036.05 229.873 1036.05C234.917 1036.05 239.013 1040.18 239.013 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 1045.29C266.555 1050.39 262.459 1054.52 257.415 1054.52C252.37 1054.52 248.274 1050.39 248.274 1045.29C248.274 1040.18 252.37 1036.05 257.415 1036.05C262.459 1036.05 266.555 1040.18 266.555 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1045.29C294.096 1050.39 290 1054.52 284.956 1054.52C279.911 1054.52 275.815 1050.39 275.815 1045.29C275.815 1040.18 279.911 1036.05 284.956 1036.05C290 1036.05 294.096 1040.18 294.096 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1045.29C321.639 1050.39 317.543 1054.52 312.499 1054.52C307.454 1054.52 303.358 1050.39 303.358 1045.29C303.358 1040.18 307.454 1036.05 312.499 1036.05C317.543 1036.05 321.639 1040.18 321.639 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 1045.29C349.181 1050.39 345.084 1054.52 340.04 1054.52C334.995 1054.52 330.899 1050.39 330.899 1045.29C330.899 1040.18 334.995 1036.05 340.04 1036.05C345.084 1036.05 349.181 1040.18 349.181 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1045.29C376.72 1050.39 372.624 1054.52 367.58 1054.52C362.535 1054.52 358.439 1050.39 358.439 1045.29C358.439 1040.18 362.535 1036.05 367.58 1036.05C372.624 1036.05 376.72 1040.18 376.72 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1045.29C404.262 1050.39 400.166 1054.52 395.122 1054.52C390.077 1054.52 385.981 1050.39 385.981 1045.29C385.981 1040.18 390.077 1036.05 395.122 1036.05C400.166 1036.05 404.262 1040.18 404.262 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 1021.2C418.035 1026.3 413.939 1030.43 408.894 1030.43C403.85 1030.43 399.754 1026.3 399.754 1021.2C399.754 1016.1 403.85 1011.97 408.894 1011.97C413.939 1011.97 418.035 1016.1 418.035 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 997.116C431.806 1002.22 427.709 1006.35 422.665 1006.35C417.62 1006.35 413.524 1002.22 413.524 997.116C413.524 992.013 417.62 987.882 422.665 987.882C427.709 987.882 431.806 992.013 431.806 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 973.032C445.575 978.135 441.479 982.266 436.434 982.266C431.39 982.266 427.294 978.135 427.294 973.032C427.294 967.928 431.39 963.798 436.434 963.798C441.479 963.798 445.575 967.928 445.575 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 924.861C473.117 929.965 469.021 934.095 463.976 934.095C458.932 934.095 454.836 929.965 454.836 924.861C454.836 919.758 458.932 915.628 463.976 915.628C469.021 915.628 473.117 919.758 473.117 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 900.777C486.889 905.881 482.793 910.011 477.749 910.011C472.704 910.011 468.608 905.881 468.608 900.777C468.608 895.674 472.704 891.543 477.749 891.543C482.793 891.543 486.889 895.674 486.889 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 876.691C500.659 881.794 496.563 885.925 491.518 885.925C486.474 885.925 482.378 881.794 482.378 876.691C482.378 871.587 486.474 867.457 491.518 867.457C496.563 867.457 500.659 871.587 500.659 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 852.606C514.43 857.71 510.334 861.84 505.29 861.84C500.245 861.84 496.149 857.71 496.149 852.606C496.149 847.503 500.245 843.372 505.29 843.372C510.334 843.372 514.43 847.503 514.43 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 828.522C528.2 833.626 524.104 837.756 519.059 837.756C514.015 837.756 509.919 833.626 509.919 828.522C509.919 823.419 514.015 819.288 519.059 819.288C524.104 819.288 528.2 823.419 528.2 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 804.436C541.971 809.54 537.874 813.67 532.83 813.67C527.785 813.67 523.689 809.54 523.689 804.436C523.689 799.333 527.785 795.202 532.83 795.202C537.874 795.202 541.971 799.333 541.971 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 780.352C528.2 785.456 524.104 789.586 519.059 789.586C514.015 789.586 509.919 785.456 509.919 780.352C509.919 775.249 514.015 771.118 519.059 771.118C524.104 771.118 528.2 775.249 528.2 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 756.268C514.43 761.371 510.334 765.502 505.29 765.502C500.245 765.502 496.149 761.371 496.149 756.268C496.149 751.164 500.245 747.034 505.29 747.034C510.334 747.034 514.43 751.164 514.43 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 732.181C500.659 737.285 496.563 741.415 491.518 741.415C486.474 741.415 482.378 737.285 482.378 732.181C482.378 727.078 486.474 722.947 491.518 722.947C496.563 722.947 500.659 727.078 500.659 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 708.097C486.889 713.201 482.793 717.331 477.749 717.331C472.704 717.331 468.608 713.201 468.608 708.097C468.608 702.994 472.704 698.863 477.749 698.863C482.793 698.863 486.889 702.994 486.889 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 684.013C473.117 689.116 469.021 693.247 463.976 693.247C458.932 693.247 454.836 689.116 454.836 684.013C454.836 678.909 458.932 674.779 463.976 674.779C469.021 674.779 473.117 678.909 473.117 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 659.927C459.346 665.03 455.25 669.161 450.206 669.161C445.161 669.161 441.065 665.03 441.065 659.927C441.065 654.823 445.161 650.693 450.206 650.693C455.25 650.693 459.346 654.823 459.346 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 635.842C445.575 640.946 441.479 645.076 436.434 645.076C431.39 645.076 427.294 640.946 427.294 635.842C427.294 630.739 431.39 626.608 436.434 626.608C441.479 626.608 445.575 630.739 445.575 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 611.758C431.806 616.862 427.709 620.992 422.665 620.992C417.62 620.992 413.524 616.862 413.524 611.758C413.524 606.655 417.62 602.525 422.665 602.525C427.709 602.525 431.806 606.655 431.806 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 587.672C418.035 592.775 413.939 596.906 408.894 596.906C403.85 596.906 399.754 592.775 399.754 587.672C399.754 582.568 403.85 578.438 408.894 578.438C413.939 578.438 418.035 582.568 418.035 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 563.588C376.72 568.691 372.624 572.822 367.58 572.822C362.535 572.822 358.439 568.691 358.439 563.588C358.439 558.484 362.535 554.354 367.58 554.354C372.624 554.354 376.72 558.484 376.72 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 563.588C321.639 568.691 317.543 572.822 312.499 572.822C307.454 572.822 303.358 568.691 303.358 563.588C303.358 558.484 307.454 554.354 312.499 554.354C317.543 554.354 321.639 558.484 321.639 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 563.588C294.096 568.691 290 572.822 284.956 572.822C279.911 572.822 275.815 568.691 275.815 563.588C275.815 558.484 279.911 554.354 284.956 554.354C290 554.354 294.096 558.484 294.096 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 563.588C266.555 568.691 262.459 572.822 257.415 572.822C252.37 572.822 248.274 568.691 248.274 563.588C248.274 558.484 252.37 554.354 257.415 554.354C262.459 554.354 266.555 558.484 266.555 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 563.588C239.013 568.691 234.917 572.822 229.873 572.822C224.828 572.822 220.732 568.691 220.732 563.588C220.732 558.484 224.828 554.354 229.873 554.354C234.917 554.354 239.013 558.484 239.013 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5349 973.032C87.5349 978.135 83.4389 982.266 78.3943 982.266C73.3496 982.266 69.2535 978.135 69.2535 973.032C69.2535 967.928 73.3496 963.798 78.3943 963.798C83.4389 963.798 87.5349 967.928 87.5349 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.305 997.116C101.305 1002.22 97.2093 1006.35 92.1647 1006.35C87.1201 1006.35 83.024 1002.22 83.024 997.116C83.024 992.013 87.1201 987.882 92.1647 987.882C97.2093 987.882 101.305 992.013 101.305 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 1021.2C115.076 1026.3 110.98 1030.43 105.935 1030.43C100.891 1030.43 96.7945 1026.3 96.7945 1021.2C96.7945 1016.1 100.891 1011.97 105.935 1011.97C110.98 1011.97 115.076 1016.1 115.076 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 1069.37C115.076 1074.47 110.98 1078.6 105.935 1078.6C100.891 1078.6 96.7945 1074.47 96.7945 1069.37C96.7945 1064.27 100.891 1060.14 105.935 1060.14C110.98 1060.14 115.076 1064.27 115.076 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 1069.37C142.618 1074.47 138.522 1078.6 133.477 1078.6C128.433 1078.6 124.337 1074.47 124.337 1069.37C124.337 1064.27 128.433 1060.14 133.477 1060.14C138.522 1060.14 142.618 1064.27 142.618 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 1069.37C170.16 1074.47 166.064 1078.6 161.019 1078.6C155.975 1078.6 151.879 1074.47 151.879 1069.37C151.879 1064.27 155.975 1060.14 161.019 1060.14C166.064 1060.14 170.16 1064.27 170.16 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 1069.37C197.703 1074.47 193.607 1078.6 188.562 1078.6C183.518 1078.6 179.421 1074.47 179.421 1069.37C179.421 1064.27 183.518 1060.14 188.562 1060.14C193.607 1060.14 197.703 1064.27 197.703 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 1069.37C225.242 1074.47 221.146 1078.6 216.101 1078.6C211.057 1078.6 206.961 1074.47 206.961 1069.37C206.961 1064.27 211.057 1060.14 216.101 1060.14C221.146 1060.14 225.242 1064.27 225.242 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 1069.37C252.784 1074.47 248.688 1078.6 243.643 1078.6C238.599 1078.6 234.503 1074.47 234.503 1069.37C234.503 1064.27 238.599 1060.14 243.643 1060.14C248.688 1060.14 252.784 1064.27 252.784 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1069.37C280.326 1074.47 276.23 1078.6 271.185 1078.6C266.141 1078.6 262.045 1074.47 262.045 1069.37C262.045 1064.27 266.141 1060.14 271.185 1060.14C276.23 1060.14 280.326 1064.27 280.326 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1069.37C307.868 1074.47 303.772 1078.6 298.727 1078.6C293.683 1078.6 289.587 1074.47 289.587 1069.37C289.587 1064.27 293.683 1060.14 298.727 1060.14C303.772 1060.14 307.868 1064.27 307.868 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1069.37C335.409 1074.47 331.313 1078.6 326.268 1078.6C321.224 1078.6 317.128 1074.47 317.128 1069.37C317.128 1064.27 321.224 1060.14 326.268 1060.14C331.313 1060.14 335.409 1064.27 335.409 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1069.37C362.951 1074.47 358.855 1078.6 353.81 1078.6C348.766 1078.6 344.67 1074.47 344.67 1069.37C344.67 1064.27 348.766 1060.14 353.81 1060.14C358.855 1060.14 362.951 1064.27 362.951 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1069.37C390.493 1074.47 386.397 1078.6 381.352 1078.6C376.308 1078.6 372.212 1074.47 372.212 1069.37C372.212 1064.27 376.308 1060.14 381.352 1060.14C386.397 1060.14 390.493 1064.27 390.493 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1069.37C418.034 1074.47 413.938 1078.6 408.893 1078.6C403.849 1078.6 399.753 1074.47 399.753 1069.37C399.753 1064.27 403.849 1060.14 408.893 1060.14C413.938 1060.14 418.034 1064.27 418.034 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 1045.29C431.806 1050.39 427.709 1054.52 422.665 1054.52C417.62 1054.52 413.524 1050.39 413.524 1045.29C413.524 1040.18 417.62 1036.05 422.665 1036.05C427.709 1036.05 431.806 1040.18 431.806 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1021.2C445.575 1026.3 441.479 1030.43 436.434 1030.43C431.39 1030.43 427.294 1026.3 427.294 1021.2C427.294 1016.1 431.39 1011.97 436.434 1011.97C441.479 1011.97 445.575 1016.1 445.575 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 997.116C459.346 1002.22 455.25 1006.35 450.206 1006.35C445.161 1006.35 441.065 1002.22 441.065 997.116C441.065 992.013 445.161 987.882 450.206 987.882C455.25 987.882 459.346 992.013 459.346 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 948.945C486.889 954.049 482.793 958.179 477.749 958.179C472.704 958.179 468.608 954.049 468.608 948.945C468.608 943.842 472.704 939.712 477.749 939.712C482.793 939.712 486.889 943.842 486.889 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 924.861C500.659 929.965 496.563 934.095 491.518 934.095C486.474 934.095 482.378 929.965 482.378 924.861C482.378 919.758 486.474 915.628 491.518 915.628C496.563 915.628 500.659 919.758 500.659 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 900.777C514.43 905.881 510.334 910.011 505.29 910.011C500.245 910.011 496.149 905.881 496.149 900.777C496.149 895.674 500.245 891.543 505.29 891.543C510.334 891.543 514.43 895.674 514.43 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 876.691C528.2 881.794 524.104 885.925 519.059 885.925C514.015 885.925 509.919 881.794 509.919 876.691C509.919 871.587 514.015 867.457 519.059 867.457C524.104 867.457 528.2 871.587 528.2 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 852.606C541.971 857.71 537.874 861.84 532.83 861.84C527.785 861.84 523.689 857.71 523.689 852.606C523.689 847.503 527.785 843.372 532.83 843.372C537.874 843.372 541.971 847.503 541.971 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 828.522C555.742 833.626 551.646 837.756 546.601 837.756C541.557 837.756 537.461 833.626 537.461 828.522C537.461 823.419 541.557 819.288 546.601 819.288C551.646 819.288 555.742 823.419 555.742 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.521 804.437C566.521 807.871 563.765 810.649 560.374 810.649C556.982 810.649 554.226 807.871 554.226 804.437C554.226 801.003 556.982 798.226 560.374 798.226C563.765 798.226 566.521 801.003 566.521 804.437Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 756.268C541.971 761.371 537.874 765.502 532.83 765.502C527.785 765.502 523.689 761.371 523.689 756.268C523.689 751.164 527.785 747.034 532.83 747.034C537.874 747.034 541.971 751.164 541.971 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 732.181C528.2 737.285 524.104 741.415 519.059 741.415C514.015 741.415 509.919 737.285 509.919 732.181C509.919 727.078 514.015 722.947 519.059 722.947C524.104 722.947 528.2 727.078 528.2 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 708.097C514.43 713.201 510.334 717.331 505.29 717.331C500.245 717.331 496.149 713.201 496.149 708.097C496.149 702.994 500.245 698.863 505.29 698.863C510.334 698.863 514.43 702.994 514.43 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 684.013C500.659 689.116 496.563 693.247 491.518 693.247C486.474 693.247 482.378 689.116 482.378 684.013C482.378 678.909 486.474 674.779 491.518 674.779C496.563 674.779 500.659 678.909 500.659 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 659.927C486.889 665.03 482.793 669.161 477.749 669.161C472.704 669.161 468.608 665.03 468.608 659.927C468.608 654.823 472.704 650.693 477.749 650.693C482.793 650.693 486.889 654.823 486.889 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 635.842C473.117 640.946 469.021 645.076 463.976 645.076C458.932 645.076 454.836 640.946 454.836 635.842C454.836 630.739 458.932 626.608 463.976 626.608C469.021 626.608 473.117 630.739 473.117 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 611.758C459.346 616.862 455.25 620.992 450.206 620.992C445.161 620.992 441.065 616.862 441.065 611.758C441.065 606.655 445.161 602.525 450.206 602.525C455.25 602.525 459.346 606.655 459.346 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 587.672C445.575 592.775 441.479 596.906 436.434 596.906C431.39 596.906 427.294 592.775 427.294 587.672C427.294 582.568 431.39 578.438 436.434 578.438C441.479 578.438 445.575 582.568 445.575 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 563.588C431.806 568.691 427.709 572.822 422.665 572.822C417.62 572.822 413.524 568.691 413.524 563.588C413.524 558.484 417.62 554.354 422.665 554.354C427.709 554.354 431.806 558.484 431.806 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 539.504C418.035 544.608 413.939 548.738 408.894 548.738C403.85 548.738 399.754 544.608 399.754 539.504C399.754 534.401 403.85 530.27 408.894 530.27C413.939 530.27 418.035 534.401 418.035 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 539.504C390.493 544.608 386.397 548.738 381.352 548.738C376.308 548.738 372.212 544.608 372.212 539.504C372.212 534.401 376.308 530.27 381.352 530.27C386.397 530.27 390.493 534.401 390.493 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 539.504C362.951 544.608 358.855 548.738 353.81 548.738C348.766 548.738 344.67 544.608 344.67 539.504C344.67 534.401 348.766 530.27 353.81 530.27C358.855 530.27 362.951 534.401 362.951 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 539.504C307.868 544.608 303.772 548.738 298.727 548.738C293.683 548.738 289.587 544.608 289.587 539.504C289.587 534.401 293.683 530.27 298.727 530.27C303.772 530.27 307.868 534.401 307.868 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 539.504C280.326 544.608 276.23 548.738 271.185 548.738C266.141 548.738 262.045 544.608 262.045 539.504C262.045 534.401 266.141 530.27 271.185 530.27C276.23 530.27 280.326 534.401 280.326 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 539.504C252.784 544.608 248.688 548.738 243.643 548.738C238.599 548.738 234.503 544.608 234.503 539.504C234.503 534.401 238.599 530.27 243.643 530.27C248.688 530.27 252.784 534.401 252.784 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 539.504C225.242 544.608 221.146 548.738 216.101 548.738C211.057 548.738 206.961 544.608 206.961 539.504C206.961 534.401 211.057 530.27 216.101 530.27C221.146 530.27 225.242 534.401 225.242 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7634 997.116C73.7634 1002.22 69.6673 1006.35 64.6227 1006.35C59.5781 1006.35 55.482 1002.22 55.482 997.116C55.482 992.013 59.5781 987.882 64.6227 987.882C69.6673 987.882 73.7634 992.013 73.7634 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5349 1021.2C87.5349 1026.3 83.4389 1030.43 78.3943 1030.43C73.3496 1030.43 69.2535 1026.3 69.2535 1021.2C69.2535 1016.1 73.3496 1011.97 78.3943 1011.97C83.4389 1011.97 87.5349 1016.1 87.5349 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.305 1045.29C101.305 1050.39 97.2093 1054.52 92.1647 1054.52C87.1201 1054.52 83.024 1050.39 83.024 1045.29C83.024 1040.18 87.1201 1036.05 92.1647 1036.05C97.2093 1036.05 101.305 1040.18 101.305 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.304 1093.46C101.304 1098.56 97.2083 1102.69 92.1637 1102.69C87.1191 1102.69 83.023 1098.56 83.023 1093.46C83.023 1088.35 87.1191 1084.22 92.1637 1084.22C97.2083 1084.22 101.304 1088.35 101.304 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.847 1093.46C128.847 1098.56 124.751 1102.69 119.707 1102.69C114.662 1102.69 110.566 1098.56 110.566 1093.46C110.566 1088.35 114.662 1084.22 119.707 1084.22C124.751 1084.22 128.847 1088.35 128.847 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.388 1093.46C156.388 1098.56 152.292 1102.69 147.248 1102.69C142.203 1102.69 138.107 1098.56 138.107 1093.46C138.107 1088.35 142.203 1084.22 147.248 1084.22C152.292 1084.22 156.388 1088.35 156.388 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 1093.46C183.93 1098.56 179.834 1102.69 174.79 1102.69C169.745 1102.69 165.649 1098.56 165.649 1093.46C165.649 1088.35 169.745 1084.22 174.79 1084.22C179.834 1084.22 183.93 1088.35 183.93 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.472 1093.46C211.472 1098.56 207.376 1102.69 202.332 1102.69C197.287 1102.69 193.191 1098.56 193.191 1093.46C193.191 1088.35 197.287 1084.22 202.332 1084.22C207.376 1084.22 211.472 1088.35 211.472 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 1093.46C239.013 1098.56 234.917 1102.69 229.873 1102.69C224.828 1102.69 220.732 1098.56 220.732 1093.46C220.732 1088.35 224.828 1084.22 229.873 1084.22C234.917 1084.22 239.013 1088.35 239.013 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 1093.46C266.555 1098.56 262.459 1102.69 257.415 1102.69C252.37 1102.69 248.274 1098.56 248.274 1093.46C248.274 1088.35 252.37 1084.22 257.415 1084.22C262.459 1084.22 266.555 1088.35 266.555 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1093.46C294.096 1098.56 290 1102.69 284.956 1102.69C279.911 1102.69 275.815 1098.56 275.815 1093.46C275.815 1088.35 279.911 1084.22 284.956 1084.22C290 1084.22 294.096 1088.35 294.096 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1093.46C321.639 1098.56 317.543 1102.69 312.499 1102.69C307.454 1102.69 303.358 1098.56 303.358 1093.46C303.358 1088.35 307.454 1084.22 312.499 1084.22C317.543 1084.22 321.639 1088.35 321.639 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1093.46C349.18 1098.56 345.083 1102.69 340.039 1102.69C334.994 1102.69 330.898 1098.56 330.898 1093.46C330.898 1088.35 334.994 1084.22 340.039 1084.22C345.083 1084.22 349.18 1088.35 349.18 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1093.46C376.72 1098.56 372.624 1102.69 367.58 1102.69C362.535 1102.69 358.439 1098.56 358.439 1093.46C358.439 1088.35 362.535 1084.22 367.58 1084.22C372.624 1084.22 376.72 1088.35 376.72 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1093.46C404.262 1098.56 400.166 1102.69 395.122 1102.69C390.077 1102.69 385.981 1098.56 385.981 1093.46C385.981 1088.35 390.077 1084.22 395.122 1084.22C400.166 1084.22 404.262 1088.35 404.262 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1093.46C431.805 1098.56 427.708 1102.69 422.664 1102.69C417.619 1102.69 413.523 1098.56 413.523 1093.46C413.523 1088.35 417.619 1084.22 422.664 1084.22C427.708 1084.22 431.805 1088.35 431.805 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1069.37C445.575 1074.47 441.479 1078.6 436.434 1078.6C431.39 1078.6 427.294 1074.47 427.294 1069.37C427.294 1064.27 431.39 1060.14 436.434 1060.14C441.479 1060.14 445.575 1064.27 445.575 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1045.29C459.346 1050.39 455.25 1054.52 450.206 1054.52C445.161 1054.52 441.065 1050.39 441.065 1045.29C441.065 1040.18 445.161 1036.05 450.206 1036.05C455.25 1036.05 459.346 1040.18 459.346 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1021.2C473.117 1026.3 469.021 1030.43 463.976 1030.43C458.932 1030.43 454.836 1026.3 454.836 1021.2C454.836 1016.1 458.932 1011.97 463.976 1011.97C469.021 1011.97 473.117 1016.1 473.117 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 973.032C500.659 978.135 496.563 982.266 491.518 982.266C486.474 982.266 482.378 978.135 482.378 973.032C482.378 967.928 486.474 963.798 491.518 963.798C496.563 963.798 500.659 967.928 500.659 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 948.945C514.43 954.049 510.334 958.179 505.29 958.179C500.245 958.179 496.149 954.049 496.149 948.945C496.149 943.842 500.245 939.712 505.29 939.712C510.334 939.712 514.43 943.842 514.43 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 924.861C528.2 929.965 524.104 934.095 519.059 934.095C514.015 934.095 509.919 929.965 509.919 924.861C509.919 919.758 514.015 915.628 519.059 915.628C524.104 915.628 528.2 919.758 528.2 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 900.777C541.971 905.881 537.874 910.011 532.83 910.011C527.785 910.011 523.689 905.881 523.689 900.777C523.689 895.674 527.785 891.543 532.83 891.543C537.874 891.543 541.971 895.674 541.971 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 876.691C555.742 881.794 551.646 885.925 546.601 885.925C541.557 885.925 537.461 881.794 537.461 876.691C537.461 871.587 541.557 867.457 546.601 867.457C551.646 867.457 555.742 871.587 555.742 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 852.606C569.512 857.71 565.416 861.84 560.372 861.84C555.327 861.84 551.231 857.71 551.231 852.606C551.231 847.503 555.327 843.372 560.372 843.372C565.416 843.372 569.512 847.503 569.512 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 756.268C569.512 761.371 565.416 765.502 560.372 765.502C555.327 765.502 551.231 761.371 551.231 756.268C551.231 751.164 555.327 747.034 560.372 747.034C565.416 747.034 569.512 751.164 569.512 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 732.181C555.742 737.285 551.646 741.415 546.601 741.415C541.557 741.415 537.461 737.285 537.461 732.181C537.461 727.078 541.557 722.947 546.601 722.947C551.646 722.947 555.742 727.078 555.742 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 708.097C541.971 713.201 537.874 717.331 532.83 717.331C527.785 717.331 523.689 713.201 523.689 708.097C523.689 702.994 527.785 698.863 532.83 698.863C537.874 698.863 541.971 702.994 541.971 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 684.013C528.2 689.116 524.104 693.247 519.059 693.247C514.015 693.247 509.919 689.116 509.919 684.013C509.919 678.909 514.015 674.779 519.059 674.779C524.104 674.779 528.2 678.909 528.2 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 659.927C514.43 665.03 510.334 669.161 505.29 669.161C500.245 669.161 496.149 665.03 496.149 659.927C496.149 654.823 500.245 650.693 505.29 650.693C510.334 650.693 514.43 654.823 514.43 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 635.842C500.659 640.946 496.563 645.076 491.518 645.076C486.474 645.076 482.378 640.946 482.378 635.842C482.378 630.739 486.474 626.608 491.518 626.608C496.563 626.608 500.659 630.739 500.659 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 611.758C486.889 616.862 482.793 620.992 477.749 620.992C472.704 620.992 468.608 616.862 468.608 611.758C468.608 606.655 472.704 602.525 477.749 602.525C482.793 602.525 486.889 606.655 486.889 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 587.672C473.117 592.775 469.021 596.906 463.976 596.906C458.932 596.906 454.836 592.775 454.836 587.672C454.836 582.568 458.932 578.438 463.976 578.438C469.021 578.438 473.117 582.568 473.117 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 563.588C459.346 568.691 455.25 572.822 450.206 572.822C445.161 572.822 441.065 568.691 441.065 563.588C441.065 558.484 445.161 554.354 450.206 554.354C455.25 554.354 459.346 558.484 459.346 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 539.504C445.575 544.608 441.479 548.738 436.434 548.738C431.39 548.738 427.294 544.608 427.294 539.504C427.294 534.401 431.39 530.27 436.434 530.27C441.479 530.27 445.575 534.401 445.575 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 515.417C431.806 520.52 427.709 524.651 422.665 524.651C417.62 524.651 413.524 520.52 413.524 515.417C413.524 510.313 417.62 506.183 422.665 506.183C427.709 506.183 431.806 510.313 431.806 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 515.417C404.262 520.52 400.166 524.651 395.122 524.651C390.077 524.651 385.981 520.52 385.981 515.417C385.981 510.313 390.077 506.183 395.122 506.183C400.166 506.183 404.262 510.313 404.262 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 515.417C376.72 520.52 372.624 524.651 367.58 524.651C362.535 524.651 358.439 520.52 358.439 515.417C358.439 510.313 362.535 506.183 367.58 506.183C372.624 506.183 376.72 510.313 376.72 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 515.417C321.639 520.52 317.543 524.651 312.499 524.651C307.454 524.651 303.358 520.52 303.358 515.417C303.358 510.313 307.454 506.183 312.499 506.183C317.543 506.183 321.639 510.313 321.639 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 515.417C294.096 520.52 290 524.651 284.956 524.651C279.911 524.651 275.815 520.52 275.815 515.417C275.815 510.313 279.911 506.183 284.956 506.183C290 506.183 294.096 510.313 294.096 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 515.417C266.555 520.52 262.459 524.651 257.415 524.651C252.37 524.651 248.274 520.52 248.274 515.417C248.274 510.313 252.37 506.183 257.415 506.183C262.459 506.183 266.555 510.313 266.555 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9939 1021.2C59.9939 1026.3 55.8978 1030.43 50.8532 1030.43C45.8086 1030.43 41.7125 1026.3 41.7125 1021.2C41.7125 1016.1 45.8086 1011.97 50.8532 1011.97C55.8978 1011.97 59.9939 1016.1 59.9939 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7634 1045.29C73.7634 1050.39 69.6673 1054.52 64.6227 1054.52C59.5781 1054.52 55.482 1050.39 55.482 1045.29C55.482 1040.18 59.5781 1036.05 64.6227 1036.05C69.6673 1036.05 73.7634 1040.18 73.7634 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5349 1069.37C87.5349 1074.47 83.4389 1078.6 78.3943 1078.6C73.3496 1078.6 69.2535 1074.47 69.2535 1069.37C69.2535 1064.27 73.3496 1060.14 78.3943 1060.14C83.4389 1060.14 87.5349 1064.27 87.5349 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5349 1117.54C87.5349 1122.64 83.4389 1126.78 78.3943 1126.78C73.3496 1126.78 69.2535 1122.64 69.2535 1117.54C69.2535 1112.44 73.3496 1108.31 78.3943 1108.31C83.4389 1108.31 87.5349 1112.44 87.5349 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.076 1117.54C115.076 1122.64 110.98 1126.78 105.935 1126.78C100.891 1126.78 96.7945 1122.64 96.7945 1117.54C96.7945 1112.44 100.891 1108.31 105.935 1108.31C110.98 1108.31 115.076 1112.44 115.076 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.618 1117.54C142.618 1122.64 138.522 1126.78 133.477 1126.78C128.433 1126.78 124.337 1122.64 124.337 1117.54C124.337 1112.44 128.433 1108.31 133.477 1108.31C138.522 1108.31 142.618 1112.44 142.618 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16 1117.54C170.16 1122.64 166.064 1126.78 161.019 1126.78C155.975 1126.78 151.879 1122.64 151.879 1117.54C151.879 1112.44 155.975 1108.31 161.019 1108.31C166.064 1108.31 170.16 1112.44 170.16 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.703 1117.54C197.703 1122.64 193.607 1126.78 188.562 1126.78C183.518 1126.78 179.421 1122.64 179.421 1117.54C179.421 1112.44 183.518 1108.31 188.562 1108.31C193.607 1108.31 197.703 1112.44 197.703 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.242 1117.54C225.242 1122.64 221.146 1126.78 216.101 1126.78C211.057 1126.78 206.961 1122.64 206.961 1117.54C206.961 1112.44 211.057 1108.31 216.101 1108.31C221.146 1108.31 225.242 1112.44 225.242 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.784 1117.54C252.784 1122.64 248.688 1126.78 243.643 1126.78C238.599 1126.78 234.503 1122.64 234.503 1117.54C234.503 1112.44 238.599 1108.31 243.643 1108.31C248.688 1108.31 252.784 1112.44 252.784 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1117.54C280.326 1122.64 276.23 1126.78 271.185 1126.78C266.141 1126.78 262.045 1122.64 262.045 1117.54C262.045 1112.44 266.141 1108.31 271.185 1108.31C276.23 1108.31 280.326 1112.44 280.326 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1117.54C307.868 1122.64 303.772 1126.78 298.727 1126.78C293.683 1126.78 289.587 1122.64 289.587 1117.54C289.587 1112.44 293.683 1108.31 298.727 1108.31C303.772 1108.31 307.868 1112.44 307.868 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1117.54C335.409 1122.64 331.313 1126.78 326.268 1126.78C321.224 1126.78 317.128 1122.64 317.128 1117.54C317.128 1112.44 321.224 1108.31 326.268 1108.31C331.313 1108.31 335.409 1112.44 335.409 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1117.54C362.951 1122.64 358.855 1126.78 353.81 1126.78C348.766 1126.78 344.67 1122.64 344.67 1117.54C344.67 1112.44 348.766 1108.31 353.81 1108.31C358.855 1108.31 362.951 1112.44 362.951 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1117.54C390.493 1122.64 386.397 1126.78 381.352 1126.78C376.308 1126.78 372.212 1122.64 372.212 1117.54C372.212 1112.44 376.308 1108.31 381.352 1108.31C386.397 1108.31 390.493 1112.44 390.493 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1117.54C418.034 1122.64 413.938 1126.78 408.893 1126.78C403.849 1126.78 399.753 1122.64 399.753 1117.54C399.753 1112.44 403.849 1108.31 408.893 1108.31C413.938 1108.31 418.034 1112.44 418.034 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1117.54C445.575 1122.64 441.479 1126.78 436.434 1126.78C431.39 1126.78 427.294 1122.64 427.294 1117.54C427.294 1112.44 431.39 1108.31 436.434 1108.31C441.479 1108.31 445.575 1112.44 445.575 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1093.46C459.346 1098.56 455.25 1102.69 450.206 1102.69C445.161 1102.69 441.065 1098.56 441.065 1093.46C441.065 1088.35 445.161 1084.22 450.206 1084.22C455.25 1084.22 459.346 1088.35 459.346 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1069.37C473.117 1074.47 469.021 1078.6 463.976 1078.6C458.932 1078.6 454.836 1074.47 454.836 1069.37C454.836 1064.27 458.932 1060.14 463.976 1060.14C469.021 1060.14 473.117 1064.27 473.117 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1045.29C486.889 1050.39 482.793 1054.52 477.749 1054.52C472.704 1054.52 468.608 1050.39 468.608 1045.29C468.608 1040.18 472.704 1036.05 477.749 1036.05C482.793 1036.05 486.889 1040.18 486.889 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 997.116C514.43 1002.22 510.334 1006.35 505.29 1006.35C500.245 1006.35 496.149 1002.22 496.149 997.116C496.149 992.013 500.245 987.882 505.29 987.882C510.334 987.882 514.43 992.013 514.43 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 973.032C528.2 978.135 524.104 982.266 519.059 982.266C514.015 982.266 509.919 978.135 509.919 973.032C509.919 967.928 514.015 963.798 519.059 963.798C524.104 963.798 528.2 967.928 528.2 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 948.945C541.971 954.049 537.874 958.179 532.83 958.179C527.785 958.179 523.689 954.049 523.689 948.945C523.689 943.842 527.785 939.712 532.83 939.712C537.874 939.712 541.971 943.842 541.971 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 924.861C555.742 929.965 551.646 934.095 546.601 934.095C541.557 934.095 537.461 929.965 537.461 924.861C537.461 919.758 541.557 915.628 546.601 915.628C551.646 915.628 555.742 919.758 555.742 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 900.777C569.512 905.881 565.416 910.011 560.372 910.011C555.327 910.011 551.231 905.881 551.231 900.777C551.231 895.674 555.327 891.543 560.372 891.543C565.416 891.543 569.512 895.674 569.512 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 876.691C583.284 881.794 579.188 885.925 574.143 885.925C569.099 885.925 565.003 881.794 565.003 876.691C565.003 871.587 569.099 867.457 574.143 867.457C579.188 867.457 583.284 871.587 583.284 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 828.522C610.825 833.626 606.729 837.756 601.684 837.756C596.64 837.756 592.544 833.626 592.544 828.522C592.544 823.419 596.64 819.288 601.684 819.288C606.729 819.288 610.825 823.419 610.825 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 804.436C624.597 809.54 620.5 813.67 615.456 813.67C610.411 813.67 606.315 809.54 606.315 804.436C606.315 799.333 610.411 795.202 615.456 795.202C620.5 795.202 624.597 799.333 624.597 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 780.352C610.825 785.456 606.729 789.586 601.684 789.586C596.64 789.586 592.544 785.456 592.544 780.352C592.544 775.249 596.64 771.118 601.684 771.118C606.729 771.118 610.825 775.249 610.825 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 732.181C583.284 737.285 579.188 741.415 574.143 741.415C569.099 741.415 565.003 737.285 565.003 732.181C565.003 727.078 569.099 722.947 574.143 722.947C579.188 722.947 583.284 727.078 583.284 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 708.097C569.512 713.201 565.416 717.331 560.372 717.331C555.327 717.331 551.231 713.201 551.231 708.097C551.231 702.994 555.327 698.863 560.372 698.863C565.416 698.863 569.512 702.994 569.512 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 684.013C555.742 689.116 551.646 693.247 546.601 693.247C541.557 693.247 537.461 689.116 537.461 684.013C537.461 678.909 541.557 674.779 546.601 674.779C551.646 674.779 555.742 678.909 555.742 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 659.927C541.971 665.03 537.874 669.161 532.83 669.161C527.785 669.161 523.689 665.03 523.689 659.927C523.689 654.823 527.785 650.693 532.83 650.693C537.874 650.693 541.971 654.823 541.971 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 635.842C528.2 640.946 524.104 645.076 519.059 645.076C514.015 645.076 509.919 640.946 509.919 635.842C509.919 630.739 514.015 626.608 519.059 626.608C524.104 626.608 528.2 630.739 528.2 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 611.758C514.43 616.862 510.334 620.992 505.29 620.992C500.245 620.992 496.149 616.862 496.149 611.758C496.149 606.655 500.245 602.525 505.29 602.525C510.334 602.525 514.43 606.655 514.43 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 587.672C500.659 592.775 496.563 596.906 491.518 596.906C486.474 596.906 482.378 592.775 482.378 587.672C482.378 582.568 486.474 578.438 491.518 578.438C496.563 578.438 500.659 582.568 500.659 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 563.588C486.889 568.691 482.793 572.822 477.749 572.822C472.704 572.822 468.608 568.691 468.608 563.588C468.608 558.484 472.704 554.354 477.749 554.354C482.793 554.354 486.889 558.484 486.889 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 539.504C473.117 544.608 469.021 548.738 463.976 548.738C458.932 548.738 454.836 544.608 454.836 539.504C454.836 534.401 458.932 530.27 463.976 530.27C469.021 530.27 473.117 534.401 473.117 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 515.417C459.346 520.52 455.25 524.651 450.206 524.651C445.161 524.651 441.065 520.52 441.065 515.417C441.065 510.313 445.161 506.183 450.206 506.183C455.25 506.183 459.346 510.313 459.346 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 491.333C445.575 496.436 441.479 500.567 436.434 500.567C431.39 500.567 427.294 496.436 427.294 491.333C427.294 486.229 431.39 482.099 436.434 482.099C441.479 482.099 445.575 486.229 445.575 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 491.333C418.035 496.436 413.939 500.567 408.894 500.567C403.85 500.567 399.754 496.436 399.754 491.333C399.754 486.229 403.85 482.099 408.894 482.099C413.939 482.099 418.035 486.229 418.035 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 491.333C390.493 496.436 386.397 500.567 381.352 500.567C376.308 500.567 372.212 496.436 372.212 491.333C372.212 486.229 376.308 482.099 381.352 482.099C386.397 482.099 390.493 486.229 390.493 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 491.333C335.41 496.436 331.314 500.567 326.269 500.567C321.225 500.567 317.129 496.436 317.129 491.333C317.129 486.229 321.225 482.099 326.269 482.099C331.314 482.099 335.41 486.229 335.41 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 491.333C307.868 496.436 303.772 500.567 298.727 500.567C293.683 500.567 289.587 496.436 289.587 491.333C289.587 486.229 293.683 482.099 298.727 482.099C303.772 482.099 307.868 486.229 307.868 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 491.333C280.326 496.436 276.23 500.567 271.185 500.567C266.141 500.567 262.045 496.436 262.045 491.333C262.045 486.229 266.141 482.099 271.185 482.099C276.23 482.099 280.326 486.229 280.326 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9929 1069.37C59.9929 1074.47 55.8969 1078.6 50.8523 1078.6C45.8077 1078.6 41.7115 1074.47 41.7115 1069.37C41.7115 1064.27 45.8077 1060.14 50.8523 1060.14C55.8969 1060.14 59.9929 1064.27 59.9929 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7634 1093.46C73.7634 1098.56 69.6673 1102.69 64.6227 1102.69C59.5781 1102.69 55.482 1098.56 55.482 1093.46C55.482 1088.35 59.5781 1084.22 64.6227 1084.22C69.6673 1084.22 73.7634 1088.35 73.7634 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.013 1141.62C239.013 1146.73 234.917 1150.86 229.873 1150.86C224.828 1150.86 220.732 1146.73 220.732 1141.62C220.732 1136.52 224.828 1132.39 229.873 1132.39C234.917 1132.39 239.013 1136.52 239.013 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 1141.62C266.555 1146.73 262.459 1150.86 257.415 1150.86C252.37 1150.86 248.274 1146.73 248.274 1141.62C248.274 1136.52 252.37 1132.39 257.415 1132.39C262.459 1132.39 266.555 1136.52 266.555 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1141.62C294.096 1146.73 290 1150.86 284.956 1150.86C279.911 1150.86 275.815 1146.73 275.815 1141.62C275.815 1136.52 279.911 1132.39 284.956 1132.39C290 1132.39 294.096 1136.52 294.096 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1141.62C321.639 1146.73 317.543 1150.86 312.499 1150.86C307.454 1150.86 303.358 1146.73 303.358 1141.62C303.358 1136.52 307.454 1132.39 312.499 1132.39C317.543 1132.39 321.639 1136.52 321.639 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1141.62C349.18 1146.73 345.083 1150.86 340.039 1150.86C334.994 1150.86 330.898 1146.73 330.898 1141.62C330.898 1136.52 334.994 1132.39 340.039 1132.39C345.083 1132.39 349.18 1136.52 349.18 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1141.62C376.72 1146.73 372.624 1150.86 367.58 1150.86C362.535 1150.86 358.439 1146.73 358.439 1141.62C358.439 1136.52 362.535 1132.39 367.58 1132.39C372.624 1132.39 376.72 1136.52 376.72 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1141.62C404.262 1146.73 400.166 1150.86 395.122 1150.86C390.077 1150.86 385.981 1146.73 385.981 1141.62C385.981 1136.52 390.077 1132.39 395.122 1132.39C400.166 1132.39 404.262 1136.52 404.262 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1141.62C431.805 1146.73 427.708 1150.86 422.664 1150.86C417.619 1150.86 413.523 1146.73 413.523 1141.62C413.523 1136.52 417.619 1132.39 422.664 1132.39C427.708 1132.39 431.805 1136.52 431.805 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1141.62C459.346 1146.73 455.25 1150.86 450.206 1150.86C445.161 1150.86 441.065 1146.73 441.065 1141.62C441.065 1136.52 445.161 1132.39 450.206 1132.39C455.25 1132.39 459.346 1136.52 459.346 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1117.54C473.117 1122.64 469.021 1126.78 463.976 1126.78C458.932 1126.78 454.836 1122.64 454.836 1117.54C454.836 1112.44 458.932 1108.31 463.976 1108.31C469.021 1108.31 473.117 1112.44 473.117 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1093.46C486.889 1098.56 482.792 1102.69 477.748 1102.69C472.703 1102.69 468.607 1098.56 468.607 1093.46C468.607 1088.35 472.703 1084.22 477.748 1084.22C482.792 1084.22 486.889 1088.35 486.889 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 1069.37C500.659 1074.47 496.563 1078.6 491.518 1078.6C486.474 1078.6 482.378 1074.47 482.378 1069.37C482.378 1064.27 486.474 1060.14 491.518 1060.14C496.563 1060.14 500.659 1064.27 500.659 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 1021.2C528.2 1026.3 524.104 1030.43 519.059 1030.43C514.015 1030.43 509.919 1026.3 509.919 1021.2C509.919 1016.1 514.015 1011.97 519.059 1011.97C524.104 1011.97 528.2 1016.1 528.2 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 997.116C541.971 1002.22 537.874 1006.35 532.83 1006.35C527.785 1006.35 523.689 1002.22 523.689 997.116C523.689 992.013 527.785 987.882 532.83 987.882C537.874 987.882 541.971 992.013 541.971 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 973.032C555.742 978.135 551.646 982.266 546.601 982.266C541.557 982.266 537.461 978.135 537.461 973.032C537.461 967.928 541.557 963.798 546.601 963.798C551.646 963.798 555.742 967.928 555.742 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 948.945C569.512 954.049 565.416 958.179 560.372 958.179C555.327 958.179 551.231 954.049 551.231 948.945C551.231 943.842 555.327 939.712 560.372 939.712C565.416 939.712 569.512 943.842 569.512 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 900.777C597.054 905.881 592.958 910.011 587.914 910.011C582.869 910.011 578.773 905.881 578.773 900.777C578.773 895.674 582.869 891.543 587.914 891.543C592.958 891.543 597.054 895.674 597.054 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 876.691C610.825 881.794 606.729 885.925 601.684 885.925C596.64 885.925 592.544 881.794 592.544 876.691C592.544 871.587 596.64 867.457 601.684 867.457C606.729 867.457 610.825 871.587 610.825 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 852.606C624.597 857.71 620.5 861.84 615.456 861.84C610.411 861.84 606.315 857.71 606.315 852.606C606.315 847.503 610.411 843.372 615.456 843.372C620.5 843.372 624.597 847.503 624.597 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 828.522C638.368 833.626 634.272 837.756 629.227 837.756C624.183 837.756 620.087 833.626 620.087 828.522C620.087 823.419 624.183 819.288 629.227 819.288C634.272 819.288 638.368 823.419 638.368 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 804.436C652.138 809.54 648.042 813.67 642.998 813.67C637.953 813.67 633.857 809.54 633.857 804.436C633.857 799.333 637.953 795.202 642.998 795.202C648.042 795.202 652.138 799.333 652.138 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 780.352C638.368 785.456 634.272 789.586 629.227 789.586C624.183 789.586 620.087 785.456 620.087 780.352C620.087 775.249 624.183 771.118 629.227 771.118C634.272 771.118 638.368 775.249 638.368 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 756.268C624.597 761.371 620.5 765.502 615.456 765.502C610.411 765.502 606.315 761.371 606.315 756.268C606.315 751.164 610.411 747.034 615.456 747.034C620.5 747.034 624.597 751.164 624.597 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 732.181C610.825 737.285 606.729 741.415 601.684 741.415C596.64 741.415 592.544 737.285 592.544 732.181C592.544 727.078 596.64 722.947 601.684 722.947C606.729 722.947 610.825 727.078 610.825 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 708.097C597.054 713.201 592.958 717.331 587.914 717.331C582.869 717.331 578.773 713.201 578.773 708.097C578.773 702.994 582.869 698.863 587.914 698.863C592.958 698.863 597.054 702.994 597.054 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 684.013C583.284 689.116 579.188 693.247 574.143 693.247C569.099 693.247 565.003 689.116 565.003 684.013C565.003 678.909 569.099 674.779 574.143 674.779C579.188 674.779 583.284 678.909 583.284 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 659.927C569.512 665.03 565.416 669.161 560.372 669.161C555.327 669.161 551.231 665.03 551.231 659.927C551.231 654.823 555.327 650.693 560.372 650.693C565.416 650.693 569.512 654.823 569.512 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 635.842C555.742 640.946 551.646 645.076 546.601 645.076C541.557 645.076 537.461 640.946 537.461 635.842C537.461 630.739 541.557 626.608 546.601 626.608C551.646 626.608 555.742 630.739 555.742 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 611.758C541.971 616.862 537.874 620.992 532.83 620.992C527.785 620.992 523.689 616.862 523.689 611.758C523.689 606.655 527.785 602.525 532.83 602.525C537.874 602.525 541.971 606.655 541.971 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 587.672C528.2 592.775 524.104 596.906 519.059 596.906C514.015 596.906 509.919 592.775 509.919 587.672C509.919 582.568 514.015 578.438 519.059 578.438C524.104 578.438 528.2 582.568 528.2 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 563.588C514.43 568.691 510.334 572.822 505.29 572.822C500.245 572.822 496.149 568.691 496.149 563.588C496.149 558.484 500.245 554.354 505.29 554.354C510.334 554.354 514.43 558.484 514.43 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 539.504C500.659 544.608 496.563 548.738 491.518 548.738C486.474 548.738 482.378 544.608 482.378 539.504C482.378 534.401 486.474 530.27 491.518 530.27C496.563 530.27 500.659 534.401 500.659 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 515.417C486.889 520.52 482.793 524.651 477.749 524.651C472.704 524.651 468.608 520.52 468.608 515.417C468.608 510.313 472.704 506.183 477.749 506.183C482.793 506.183 486.889 510.313 486.889 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 467.249C459.346 472.352 455.25 476.483 450.206 476.483C445.161 476.483 441.065 472.352 441.065 467.249C441.065 462.145 445.161 458.015 450.206 458.015C455.25 458.015 459.346 462.145 459.346 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 467.249C431.806 472.352 427.709 476.483 422.665 476.483C417.62 476.483 413.524 472.352 413.524 467.249C413.524 462.145 417.62 458.015 422.665 458.015C427.709 458.015 431.806 462.145 431.806 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 467.249C404.262 472.352 400.166 476.483 395.122 476.483C390.077 476.483 385.981 472.352 385.981 467.249C385.981 462.145 390.077 458.015 395.122 458.015C400.166 458.015 404.262 462.145 404.262 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 467.249C349.181 472.352 345.084 476.483 340.04 476.483C334.995 476.483 330.899 472.352 330.899 467.249C330.899 462.145 334.995 458.015 340.04 458.015C345.084 458.015 349.181 462.145 349.181 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 467.249C321.639 472.352 317.543 476.483 312.499 476.483C307.454 476.483 303.358 472.352 303.358 467.249C303.358 462.145 307.454 458.015 312.499 458.015C317.543 458.015 321.639 462.145 321.639 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 467.249C294.096 472.352 290 476.483 284.956 476.483C279.911 476.483 275.815 472.352 275.815 467.249C275.815 462.145 279.911 458.015 284.956 458.015C290 458.015 294.096 462.145 294.096 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9939 491.333C59.9939 496.436 55.8978 500.567 50.8532 500.567C45.8086 500.567 41.7125 496.436 41.7125 491.333C41.7125 486.229 45.8086 482.099 50.8532 482.099C55.8978 482.099 59.9939 486.229 59.9939 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1165.71C280.326 1170.81 276.23 1174.94 271.185 1174.94C266.141 1174.94 262.045 1170.81 262.045 1165.71C262.045 1160.61 266.141 1156.48 271.185 1156.48C276.23 1156.48 280.326 1160.61 280.326 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1165.71C307.868 1170.81 303.772 1174.94 298.727 1174.94C293.683 1174.94 289.587 1170.81 289.587 1165.71C289.587 1160.61 293.683 1156.48 298.727 1156.48C303.772 1156.48 307.868 1160.61 307.868 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1165.71C335.409 1170.81 331.313 1174.94 326.268 1174.94C321.224 1174.94 317.128 1170.81 317.128 1165.71C317.128 1160.61 321.224 1156.48 326.268 1156.48C331.313 1156.48 335.409 1160.61 335.409 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1165.71C362.951 1170.81 358.855 1174.94 353.81 1174.94C348.766 1174.94 344.67 1170.81 344.67 1165.71C344.67 1160.61 348.766 1156.48 353.81 1156.48C358.855 1156.48 362.951 1160.61 362.951 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1165.71C390.493 1170.81 386.397 1174.94 381.352 1174.94C376.308 1174.94 372.212 1170.81 372.212 1165.71C372.212 1160.61 376.308 1156.48 381.352 1156.48C386.397 1156.48 390.493 1160.61 390.493 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1165.71C418.034 1170.81 413.938 1174.94 408.893 1174.94C403.849 1174.94 399.753 1170.81 399.753 1165.71C399.753 1160.61 403.849 1156.48 408.893 1156.48C413.938 1156.48 418.034 1160.61 418.034 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1165.71C445.575 1170.81 441.479 1174.94 436.434 1174.94C431.39 1174.94 427.294 1170.81 427.294 1165.71C427.294 1160.61 431.39 1156.48 436.434 1156.48C441.479 1156.48 445.575 1160.61 445.575 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1165.71C473.117 1170.81 469.021 1174.94 463.976 1174.94C458.932 1174.94 454.836 1170.81 454.836 1165.71C454.836 1160.61 458.932 1156.48 463.976 1156.48C469.021 1156.48 473.117 1160.61 473.117 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1141.62C486.889 1146.73 482.792 1150.86 477.748 1150.86C472.703 1150.86 468.607 1146.73 468.607 1141.62C468.607 1136.52 472.703 1132.39 477.748 1132.39C482.792 1132.39 486.889 1136.52 486.889 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 1117.54C500.659 1122.64 496.563 1126.78 491.518 1126.78C486.474 1126.78 482.378 1122.64 482.378 1117.54C482.378 1112.44 486.474 1108.31 491.518 1108.31C496.563 1108.31 500.659 1112.44 500.659 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 1093.46C514.43 1098.56 510.334 1102.69 505.29 1102.69C500.245 1102.69 496.149 1098.56 496.149 1093.46C496.149 1088.35 500.245 1084.22 505.29 1084.22C510.334 1084.22 514.43 1088.35 514.43 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 1045.29C541.971 1050.39 537.874 1054.52 532.83 1054.52C527.785 1054.52 523.689 1050.39 523.689 1045.29C523.689 1040.18 527.785 1036.05 532.83 1036.05C537.874 1036.05 541.971 1040.18 541.971 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 1021.2C555.742 1026.3 551.646 1030.43 546.601 1030.43C541.557 1030.43 537.461 1026.3 537.461 1021.2C537.461 1016.1 541.557 1011.97 546.601 1011.97C551.646 1011.97 555.742 1016.1 555.742 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 997.116C569.512 1002.22 565.416 1006.35 560.372 1006.35C555.327 1006.35 551.231 1002.22 551.231 997.116C551.231 992.013 555.327 987.882 560.372 987.882C565.416 987.882 569.512 992.013 569.512 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 973.032C583.284 978.135 579.188 982.266 574.143 982.266C569.099 982.266 565.003 978.135 565.003 973.032C565.003 967.928 569.099 963.798 574.143 963.798C579.188 963.798 583.284 967.928 583.284 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 924.861C610.825 929.965 606.729 934.095 601.684 934.095C596.64 934.095 592.544 929.965 592.544 924.861C592.544 919.758 596.64 915.628 601.684 915.628C606.729 915.628 610.825 919.758 610.825 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 900.777C624.597 905.881 620.5 910.011 615.456 910.011C610.411 910.011 606.315 905.881 606.315 900.777C606.315 895.674 610.411 891.543 615.456 891.543C620.5 891.543 624.597 895.674 624.597 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 876.691C638.368 881.794 634.272 885.925 629.227 885.925C624.183 885.925 620.087 881.794 620.087 876.691C620.087 871.587 624.183 867.457 629.227 867.457C634.272 867.457 638.368 871.587 638.368 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 852.606C652.138 857.71 648.042 861.84 642.998 861.84C637.953 861.84 633.857 857.71 633.857 852.606C633.857 847.503 637.953 843.372 642.998 843.372C648.042 843.372 652.138 847.503 652.138 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 828.522C665.909 833.626 661.813 837.756 656.768 837.756C651.724 837.756 647.628 833.626 647.628 828.522C647.628 823.419 651.724 819.288 656.768 819.288C661.813 819.288 665.909 823.419 665.909 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 804.436C679.68 809.54 675.583 813.67 670.539 813.67C665.494 813.67 661.398 809.54 661.398 804.436C661.398 799.333 665.494 795.202 670.539 795.202C675.583 795.202 679.68 799.333 679.68 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 780.352C665.909 785.456 661.813 789.586 656.768 789.586C651.724 789.586 647.628 785.456 647.628 780.352C647.628 775.249 651.724 771.118 656.768 771.118C661.813 771.118 665.909 775.249 665.909 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 756.268C652.138 761.371 648.042 765.502 642.998 765.502C637.953 765.502 633.857 761.371 633.857 756.268C633.857 751.164 637.953 747.034 642.998 747.034C648.042 747.034 652.138 751.164 652.138 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 732.181C638.368 737.285 634.272 741.415 629.227 741.415C624.183 741.415 620.087 737.285 620.087 732.181C620.087 727.078 624.183 722.947 629.227 722.947C634.272 722.947 638.368 727.078 638.368 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 708.097C624.597 713.201 620.5 717.331 615.456 717.331C610.411 717.331 606.315 713.201 606.315 708.097C606.315 702.994 610.411 698.863 615.456 698.863C620.5 698.863 624.597 702.994 624.597 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 684.013C610.825 689.116 606.729 693.247 601.684 693.247C596.64 693.247 592.544 689.116 592.544 684.013C592.544 678.909 596.64 674.779 601.684 674.779C606.729 674.779 610.825 678.909 610.825 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 659.927C597.054 665.03 592.958 669.161 587.914 669.161C582.869 669.161 578.773 665.03 578.773 659.927C578.773 654.823 582.869 650.693 587.914 650.693C592.958 650.693 597.054 654.823 597.054 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 635.842C583.284 640.946 579.188 645.076 574.143 645.076C569.099 645.076 565.003 640.946 565.003 635.842C565.003 630.739 569.099 626.608 574.143 626.608C579.188 626.608 583.284 630.739 583.284 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 611.758C569.512 616.862 565.416 620.992 560.372 620.992C555.327 620.992 551.231 616.862 551.231 611.758C551.231 606.655 555.327 602.525 560.372 602.525C565.416 602.525 569.512 606.655 569.512 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 587.672C555.742 592.775 551.646 596.906 546.601 596.906C541.557 596.906 537.461 592.775 537.461 587.672C537.461 582.568 541.557 578.438 546.601 578.438C551.646 578.438 555.742 582.568 555.742 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 563.588C541.971 568.691 537.874 572.822 532.83 572.822C527.785 572.822 523.689 568.691 523.689 563.588C523.689 558.484 527.785 554.354 532.83 554.354C537.874 554.354 541.971 558.484 541.971 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 539.504C528.2 544.608 524.104 548.738 519.059 548.738C514.015 548.738 509.919 544.608 509.919 539.504C509.919 534.401 514.015 530.27 519.059 530.27C524.104 530.27 528.2 534.401 528.2 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 515.417C514.43 520.52 510.334 524.651 505.29 524.651C500.245 524.651 496.149 520.52 496.149 515.417C496.149 510.313 500.245 506.183 505.29 506.183C510.334 506.183 514.43 510.313 514.43 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 443.162C473.117 448.266 469.021 452.396 463.976 452.396C458.932 452.396 454.836 448.266 454.836 443.162C454.836 438.059 458.932 433.928 463.976 433.928C469.021 433.928 473.117 438.059 473.117 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 443.162C418.035 448.266 413.939 452.396 408.894 452.396C403.85 452.396 399.754 448.266 399.754 443.162C399.754 438.059 403.85 433.928 408.894 433.928C413.939 433.928 418.035 438.059 418.035 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 443.162C390.493 448.266 386.397 452.396 381.352 452.396C376.308 452.396 372.212 448.265 372.212 443.162C372.212 438.059 376.308 433.928 381.352 433.928C386.397 433.928 390.493 438.059 390.493 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 443.162C362.951 448.266 358.855 452.396 353.81 452.396C348.766 452.396 344.67 448.266 344.67 443.162C344.67 438.059 348.766 433.928 353.81 433.928C358.855 433.928 362.951 438.059 362.951 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 443.162C335.41 448.265 331.314 452.396 326.269 452.396C321.225 452.396 317.129 448.266 317.129 443.162C317.129 438.059 321.225 433.928 326.269 433.928C331.314 433.928 335.41 438.059 335.41 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 443.162C307.868 448.266 303.772 452.396 298.727 452.396C293.683 452.396 289.587 448.266 289.587 443.162C289.587 438.059 293.683 433.928 298.727 433.928C303.772 433.928 307.868 438.059 307.868 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2233 467.249C46.2233 472.352 42.1272 476.483 37.0826 476.483C32.038 476.483 27.942 472.352 27.942 467.249C27.942 462.145 32.038 458.015 37.0826 458.015C42.1272 458.015 46.2233 462.145 46.2233 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4519 491.333C32.4519 496.436 28.3558 500.567 23.3112 500.567C18.2666 500.567 14.1705 496.436 14.1705 491.333C14.1705 486.229 18.2666 482.099 23.3112 482.099C28.3558 482.099 32.4519 486.229 32.4519 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.555 1189.8C266.555 1194.9 262.459 1199.03 257.415 1199.03C252.37 1199.03 248.274 1194.9 248.274 1189.8C248.274 1184.69 252.37 1180.56 257.415 1180.56C262.459 1180.56 266.555 1184.69 266.555 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1189.8C294.096 1194.9 290 1199.03 284.956 1199.03C279.911 1199.03 275.815 1194.9 275.815 1189.8C275.815 1184.69 279.911 1180.56 284.956 1180.56C290 1180.56 294.096 1184.69 294.096 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1189.8C321.639 1194.9 317.543 1199.03 312.499 1199.03C307.454 1199.03 303.358 1194.9 303.358 1189.8C303.358 1184.69 307.454 1180.56 312.499 1180.56C317.543 1180.56 321.639 1184.69 321.639 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1189.8C349.18 1194.9 345.083 1199.03 340.039 1199.03C334.994 1199.03 330.898 1194.9 330.898 1189.8C330.898 1184.69 334.994 1180.56 340.039 1180.56C345.083 1180.56 349.18 1184.69 349.18 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1189.8C376.72 1194.9 372.624 1199.03 367.58 1199.03C362.535 1199.03 358.439 1194.9 358.439 1189.8C358.439 1184.69 362.535 1180.56 367.58 1180.56C372.624 1180.56 376.72 1184.69 376.72 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1189.8C404.262 1194.9 400.166 1199.03 395.122 1199.03C390.077 1199.03 385.981 1194.9 385.981 1189.8C385.981 1184.69 390.077 1180.56 395.122 1180.56C400.166 1180.56 404.262 1184.69 404.262 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1189.8C431.805 1194.9 427.708 1199.03 422.664 1199.03C417.619 1199.03 413.523 1194.9 413.523 1189.8C413.523 1184.69 417.619 1180.56 422.664 1180.56C427.708 1180.56 431.805 1184.69 431.805 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1189.8C459.346 1194.9 455.25 1199.03 450.206 1199.03C445.161 1199.03 441.065 1194.9 441.065 1189.8C441.065 1184.69 445.161 1180.56 450.206 1180.56C455.25 1180.56 459.346 1184.69 459.346 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1189.8C486.889 1194.9 482.792 1199.03 477.748 1199.03C472.703 1199.03 468.607 1194.9 468.607 1189.8C468.607 1184.69 472.703 1180.56 477.748 1180.56C482.792 1180.56 486.889 1184.69 486.889 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 1165.71C500.659 1170.81 496.563 1174.94 491.518 1174.94C486.474 1174.94 482.378 1170.81 482.378 1165.71C482.378 1160.61 486.474 1156.48 491.518 1156.48C496.563 1156.48 500.659 1160.61 500.659 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 1141.62C514.43 1146.73 510.334 1150.86 505.29 1150.86C500.245 1150.86 496.149 1146.73 496.149 1141.62C496.149 1136.52 500.245 1132.39 505.29 1132.39C510.334 1132.39 514.43 1136.52 514.43 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 1117.54C528.2 1122.64 524.104 1126.78 519.059 1126.78C514.015 1126.78 509.919 1122.64 509.919 1117.54C509.919 1112.44 514.015 1108.31 519.059 1108.31C524.104 1108.31 528.2 1112.44 528.2 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 1069.37C555.742 1074.47 551.646 1078.6 546.601 1078.6C541.557 1078.6 537.461 1074.47 537.461 1069.37C537.461 1064.27 541.557 1060.14 546.601 1060.14C551.646 1060.14 555.742 1064.27 555.742 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 1045.29C569.512 1050.39 565.416 1054.52 560.372 1054.52C555.327 1054.52 551.231 1050.39 551.231 1045.29C551.231 1040.18 555.327 1036.05 560.372 1036.05C565.416 1036.05 569.512 1040.18 569.512 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 1021.2C583.284 1026.3 579.188 1030.43 574.143 1030.43C569.099 1030.43 565.003 1026.3 565.003 1021.2C565.003 1016.1 569.099 1011.97 574.143 1011.97C579.188 1011.97 583.284 1016.1 583.284 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 997.116C597.054 1002.22 592.958 1006.35 587.914 1006.35C582.869 1006.35 578.773 1002.22 578.773 997.116C578.773 992.013 582.869 987.882 587.914 987.882C592.958 987.882 597.054 992.013 597.054 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 948.945C624.597 954.049 620.5 958.179 615.456 958.179C610.411 958.179 606.315 954.049 606.315 948.945C606.315 943.842 610.411 939.712 615.456 939.712C620.5 939.712 624.597 943.842 624.597 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 924.861C638.368 929.965 634.272 934.095 629.227 934.095C624.183 934.095 620.087 929.965 620.087 924.861C620.087 919.758 624.183 915.628 629.227 915.628C634.272 915.628 638.368 919.758 638.368 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 900.777C652.138 905.881 648.042 910.011 642.998 910.011C637.953 910.011 633.857 905.881 633.857 900.777C633.857 895.674 637.953 891.543 642.998 891.543C648.042 891.543 652.138 895.674 652.138 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 876.691C665.909 881.794 661.813 885.925 656.768 885.925C651.724 885.925 647.628 881.794 647.628 876.691C647.628 871.587 651.724 867.457 656.768 867.457C661.813 867.457 665.909 871.587 665.909 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 852.606C679.68 857.71 675.583 861.84 670.539 861.84C665.494 861.84 661.398 857.71 661.398 852.606C661.398 847.503 665.494 843.372 670.539 843.372C675.583 843.372 679.68 847.503 679.68 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 828.522C693.452 833.626 689.356 837.756 684.311 837.756C679.267 837.756 675.171 833.626 675.171 828.522C675.171 823.419 679.267 819.288 684.311 819.288C689.356 819.288 693.452 823.419 693.452 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 804.436C707.219 809.54 703.123 813.67 698.079 813.67C693.034 813.67 688.938 809.54 688.938 804.436C688.938 799.333 693.034 795.202 698.079 795.202C703.123 795.202 707.219 799.333 707.219 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 780.352C693.452 785.456 689.356 789.586 684.311 789.586C679.267 789.586 675.171 785.456 675.171 780.352C675.171 775.249 679.267 771.118 684.311 771.118C689.356 771.118 693.452 775.249 693.452 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 756.268C679.68 761.371 675.583 765.502 670.539 765.502C665.494 765.502 661.398 761.371 661.398 756.268C661.398 751.164 665.494 747.034 670.539 747.034C675.583 747.034 679.68 751.164 679.68 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 732.181C665.909 737.285 661.813 741.415 656.768 741.415C651.724 741.415 647.628 737.285 647.628 732.181C647.628 727.078 651.724 722.947 656.768 722.947C661.813 722.947 665.909 727.078 665.909 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 708.097C652.138 713.201 648.042 717.331 642.998 717.331C637.953 717.331 633.857 713.201 633.857 708.097C633.857 702.994 637.953 698.863 642.998 698.863C648.042 698.863 652.138 702.994 652.138 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 684.013C638.368 689.116 634.272 693.247 629.227 693.247C624.183 693.247 620.087 689.116 620.087 684.013C620.087 678.909 624.183 674.779 629.227 674.779C634.272 674.779 638.368 678.909 638.368 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 659.927C624.597 665.03 620.5 669.161 615.456 669.161C610.411 669.161 606.315 665.03 606.315 659.927C606.315 654.823 610.411 650.693 615.456 650.693C620.5 650.693 624.597 654.823 624.597 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 635.842C610.825 640.946 606.729 645.076 601.684 645.076C596.64 645.076 592.544 640.946 592.544 635.842C592.544 630.739 596.64 626.608 601.684 626.608C606.729 626.608 610.825 630.739 610.825 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 611.758C597.054 616.862 592.958 620.992 587.914 620.992C582.869 620.992 578.773 616.862 578.773 611.758C578.773 606.655 582.869 602.525 587.914 602.525C592.958 602.525 597.054 606.655 597.054 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 587.672C583.284 592.775 579.188 596.906 574.143 596.906C569.099 596.906 565.003 592.775 565.003 587.672C565.003 582.568 569.099 578.438 574.143 578.438C579.188 578.438 583.284 582.568 583.284 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 563.588C569.512 568.691 565.416 572.822 560.372 572.822C555.327 572.822 551.231 568.691 551.231 563.588C551.231 558.484 555.327 554.354 560.372 554.354C565.416 554.354 569.512 558.484 569.512 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 539.504C555.742 544.608 551.646 548.738 546.601 548.738C541.557 548.738 537.461 544.608 537.461 539.504C537.461 534.401 541.557 530.27 546.601 530.27C551.646 530.27 555.742 534.401 555.742 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 515.417C541.971 520.52 537.874 524.651 532.83 524.651C527.785 524.651 523.689 520.52 523.689 515.417C523.689 510.313 527.785 506.183 532.83 506.183C537.874 506.183 541.971 510.313 541.971 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 491.333C528.2 496.436 524.104 500.567 519.059 500.567C514.015 500.567 509.919 496.436 509.919 491.333C509.919 486.229 514.015 482.099 519.059 482.099C524.104 482.099 528.2 486.229 528.2 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 467.249C514.43 472.352 510.334 476.483 505.29 476.483C500.245 476.483 496.149 472.352 496.149 467.249C496.149 462.145 500.245 458.015 505.29 458.015C510.334 458.015 514.43 462.145 514.43 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 443.162C500.659 448.266 496.563 452.396 491.518 452.396C486.474 452.396 482.378 448.266 482.378 443.162C482.378 438.059 486.474 433.928 491.518 433.928C496.563 433.928 500.659 438.059 500.659 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 419.079C486.889 424.182 482.793 428.313 477.749 428.313C472.704 428.313 468.608 424.182 468.608 419.079C468.608 413.975 472.704 409.845 477.749 409.845C482.793 409.845 486.889 413.975 486.889 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 419.079C459.346 424.182 455.25 428.313 450.206 428.313C445.161 428.313 441.065 424.182 441.065 419.079C441.065 413.975 445.161 409.845 450.206 409.845C455.25 409.845 459.346 413.975 459.346 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.806 419.079C431.806 424.182 427.709 428.313 422.665 428.313C417.62 428.313 413.524 424.182 413.524 419.079C413.524 413.975 417.62 409.845 422.665 409.845C427.709 409.845 431.806 413.975 431.806 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 419.079C404.262 424.182 400.166 428.313 395.122 428.313C390.077 428.313 385.981 424.182 385.981 419.079C385.981 413.975 390.077 409.845 395.122 409.845C400.166 409.845 404.262 413.975 404.262 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 419.079C376.72 424.182 372.624 428.313 367.58 428.313C362.535 428.313 358.439 424.182 358.439 419.079C358.439 413.975 362.535 409.845 367.58 409.845C372.624 409.845 376.72 413.975 376.72 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.181 419.079C349.181 424.182 345.084 428.313 340.04 428.313C334.995 428.313 330.899 424.182 330.899 419.079C330.899 413.975 334.995 409.845 340.04 409.845C345.084 409.845 349.181 413.975 349.181 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.394 419.079C319.394 422.93 316.303 426.046 312.498 426.046C308.693 426.046 305.602 422.93 305.602 419.079C305.602 415.227 308.693 412.112 312.498 412.112C316.303 412.112 319.394 415.227 319.394 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6814 467.249C18.6814 472.352 14.5853 476.483 9.54074 476.483C4.49614 476.483 0.4 472.352 0.4 467.249C0.4 462.145 4.49614 458.015 9.54074 458.015C14.5853 458.015 18.6814 462.145 18.6814 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1213.88C280.326 1218.98 276.23 1223.11 271.185 1223.11C266.141 1223.11 262.045 1218.98 262.045 1213.88C262.045 1208.78 266.141 1204.65 271.185 1204.65C276.23 1204.65 280.326 1208.78 280.326 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1213.88C307.868 1218.98 303.772 1223.11 298.727 1223.11C293.683 1223.11 289.587 1218.98 289.587 1213.88C289.587 1208.78 293.683 1204.65 298.727 1204.65C303.772 1204.65 307.868 1208.78 307.868 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1213.88C335.409 1218.98 331.313 1223.11 326.268 1223.11C321.224 1223.11 317.128 1218.98 317.128 1213.88C317.128 1208.78 321.224 1204.65 326.268 1204.65C331.313 1204.65 335.409 1208.78 335.409 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1213.88C362.951 1218.98 358.855 1223.11 353.81 1223.11C348.766 1223.11 344.67 1218.98 344.67 1213.88C344.67 1208.78 348.766 1204.65 353.81 1204.65C358.855 1204.65 362.951 1208.78 362.951 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1213.88C390.493 1218.98 386.397 1223.11 381.352 1223.11C376.308 1223.11 372.212 1218.98 372.212 1213.88C372.212 1208.78 376.308 1204.65 381.352 1204.65C386.397 1204.65 390.493 1208.78 390.493 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1213.88C418.034 1218.98 413.938 1223.11 408.893 1223.11C403.849 1223.11 399.753 1218.98 399.753 1213.88C399.753 1208.78 403.849 1204.65 408.893 1204.65C413.938 1204.65 418.034 1208.78 418.034 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1213.88C445.575 1218.98 441.479 1223.11 436.434 1223.11C431.39 1223.11 427.294 1218.98 427.294 1213.88C427.294 1208.78 431.39 1204.65 436.434 1204.65C441.479 1204.65 445.575 1208.78 445.575 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1213.88C473.117 1218.98 469.021 1223.11 463.976 1223.11C458.932 1223.11 454.836 1218.98 454.836 1213.88C454.836 1208.78 458.932 1204.65 463.976 1204.65C469.021 1204.65 473.117 1208.78 473.117 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.43 1189.8C514.43 1194.9 510.334 1199.03 505.29 1199.03C500.245 1199.03 496.149 1194.9 496.149 1189.8C496.149 1184.69 500.245 1180.56 505.29 1180.56C510.334 1180.56 514.43 1184.69 514.43 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2 1165.71C528.2 1170.81 524.104 1174.94 519.059 1174.94C514.015 1174.94 509.919 1170.81 509.919 1165.71C509.919 1160.61 514.015 1156.48 519.059 1156.48C524.104 1156.48 528.2 1160.61 528.2 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 1141.62C541.971 1146.73 537.874 1150.86 532.83 1150.86C527.785 1150.86 523.689 1146.73 523.689 1141.62C523.689 1136.52 527.785 1132.39 532.83 1132.39C537.874 1132.39 541.971 1136.52 541.971 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 1117.54C555.742 1122.64 551.646 1126.78 546.601 1126.78C541.557 1126.78 537.461 1122.64 537.461 1117.54C537.461 1112.44 541.557 1108.31 546.601 1108.31C551.646 1108.31 555.742 1112.44 555.742 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.511 1093.46C569.511 1098.56 565.415 1102.69 560.371 1102.69C555.326 1102.69 551.23 1098.56 551.23 1093.46C551.23 1088.35 555.326 1084.22 560.371 1084.22C565.415 1084.22 569.511 1088.35 569.511 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 1045.29C597.054 1050.39 592.958 1054.52 587.914 1054.52C582.869 1054.52 578.773 1050.39 578.773 1045.29C578.773 1040.18 582.869 1036.05 587.914 1036.05C592.958 1036.05 597.054 1040.18 597.054 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 1021.2C610.825 1026.3 606.729 1030.43 601.684 1030.43C596.64 1030.43 592.544 1026.3 592.544 1021.2C592.544 1016.1 596.64 1011.97 601.684 1011.97C606.729 1011.97 610.825 1016.1 610.825 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 997.116C624.597 1002.22 620.5 1006.35 615.456 1006.35C610.411 1006.35 606.315 1002.22 606.315 997.116C606.315 992.013 610.411 987.882 615.456 987.882C620.5 987.882 624.597 992.013 624.597 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 948.945C652.138 954.049 648.042 958.179 642.998 958.179C637.953 958.179 633.857 954.049 633.857 948.945C633.857 943.842 637.953 939.712 642.998 939.712C648.042 939.712 652.138 943.842 652.138 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 924.861C665.909 929.965 661.813 934.095 656.768 934.095C651.724 934.095 647.628 929.965 647.628 924.861C647.628 919.758 651.724 915.628 656.768 915.628C661.813 915.628 665.909 919.758 665.909 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 900.777C679.68 905.881 675.583 910.011 670.539 910.011C665.494 910.011 661.398 905.881 661.398 900.777C661.398 895.674 665.494 891.543 670.539 891.543C675.583 891.543 679.68 895.674 679.68 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 876.691C693.452 881.794 689.356 885.925 684.311 885.925C679.267 885.925 675.171 881.794 675.171 876.691C675.171 871.587 679.267 867.457 684.311 867.457C689.356 867.457 693.452 871.587 693.452 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 852.606C707.219 857.71 703.123 861.84 698.079 861.84C693.034 861.84 688.938 857.71 688.938 852.606C688.938 847.503 693.034 843.372 698.079 843.372C703.123 843.372 707.219 847.503 707.219 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 828.522C720.991 833.626 716.895 837.756 711.85 837.756C706.806 837.756 702.71 833.626 702.71 828.522C702.71 823.419 706.806 819.288 711.85 819.288C716.895 819.288 720.991 823.419 720.991 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 804.436C734.763 809.54 730.666 813.67 725.622 813.67C720.577 813.67 716.481 809.54 716.481 804.436C716.481 799.333 720.577 795.202 725.622 795.202C730.666 795.202 734.763 799.333 734.763 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 780.352C720.991 785.456 716.895 789.586 711.85 789.586C706.806 789.586 702.71 785.456 702.71 780.352C702.71 775.249 706.806 771.118 711.85 771.118C716.895 771.118 720.991 775.249 720.991 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 756.268C707.219 761.371 703.123 765.502 698.079 765.502C693.034 765.502 688.938 761.371 688.938 756.268C688.938 751.164 693.034 747.034 698.079 747.034C703.123 747.034 707.219 751.164 707.219 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 732.181C693.452 737.285 689.356 741.415 684.311 741.415C679.267 741.415 675.171 737.285 675.171 732.181C675.171 727.078 679.267 722.947 684.311 722.947C689.356 722.947 693.452 727.078 693.452 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 708.097C679.68 713.201 675.583 717.331 670.539 717.331C665.494 717.331 661.398 713.201 661.398 708.097C661.398 702.994 665.494 698.863 670.539 698.863C675.583 698.863 679.68 702.994 679.68 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 684.013C665.909 689.116 661.813 693.247 656.768 693.247C651.724 693.247 647.628 689.116 647.628 684.013C647.628 678.909 651.724 674.779 656.768 674.779C661.813 674.779 665.909 678.909 665.909 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 659.927C652.138 665.03 648.042 669.161 642.998 669.161C637.953 669.161 633.857 665.03 633.857 659.927C633.857 654.823 637.953 650.693 642.998 650.693C648.042 650.693 652.138 654.823 652.138 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 635.842C638.368 640.946 634.272 645.076 629.227 645.076C624.183 645.076 620.087 640.946 620.087 635.842C620.087 630.739 624.183 626.608 629.227 626.608C634.272 626.608 638.368 630.739 638.368 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 611.758C624.597 616.862 620.5 620.992 615.456 620.992C610.411 620.992 606.315 616.862 606.315 611.758C606.315 606.655 610.411 602.525 615.456 602.525C620.5 602.525 624.597 606.655 624.597 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 587.672C610.825 592.775 606.729 596.906 601.684 596.906C596.64 596.906 592.544 592.775 592.544 587.672C592.544 582.568 596.64 578.438 601.684 578.438C606.729 578.438 610.825 582.568 610.825 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 563.588C597.054 568.691 592.958 572.822 587.914 572.822C582.869 572.822 578.773 568.691 578.773 563.588C578.773 558.484 582.869 554.354 587.914 554.354C592.958 554.354 597.054 558.484 597.054 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 539.504C583.284 544.608 579.188 548.738 574.143 548.738C569.099 548.738 565.003 544.608 565.003 539.504C565.003 534.401 569.099 530.27 574.143 530.27C579.188 530.27 583.284 534.401 583.284 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 515.417C569.512 520.52 565.416 524.651 560.372 524.651C555.327 524.651 551.231 520.52 551.231 515.417C551.231 510.313 555.327 506.183 560.372 506.183C565.416 506.183 569.512 510.313 569.512 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 491.333C555.742 496.436 551.646 500.567 546.601 500.567C541.557 500.567 537.461 496.436 537.461 491.333C537.461 486.229 541.557 482.099 546.601 482.099C551.646 482.099 555.742 486.229 555.742 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 467.249C541.971 472.352 537.874 476.483 532.83 476.483C527.785 476.483 523.689 472.352 523.689 467.249C523.689 462.145 527.785 458.015 532.83 458.015C537.874 458.015 541.971 462.145 541.971 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 394.994C445.575 400.098 441.479 404.228 436.434 404.228C431.39 404.228 427.294 400.098 427.294 394.994C427.294 389.891 431.39 385.76 436.434 385.76C441.479 385.76 445.575 389.891 445.575 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.035 394.994C418.035 400.098 413.939 404.228 408.894 404.228C403.85 404.228 399.754 400.098 399.754 394.994C399.754 389.891 403.85 385.76 408.894 385.76C413.939 385.76 418.035 389.891 418.035 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 394.994C390.493 400.098 386.397 404.228 381.352 404.228C376.308 404.228 372.212 400.098 372.212 394.994C372.212 389.891 376.308 385.76 381.352 385.76C386.397 385.76 390.493 389.891 390.493 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 394.994C362.951 400.098 358.855 404.228 353.81 404.228C348.766 404.228 344.67 400.098 344.67 394.994C344.67 389.891 348.766 385.76 353.81 385.76C358.855 385.76 362.951 389.891 362.951 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 394.994C335.41 400.098 331.314 404.228 326.269 404.228C321.225 404.228 317.129 400.098 317.129 394.994C317.129 389.891 321.225 385.76 326.269 385.76C331.314 385.76 335.41 389.891 335.41 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1237.96C294.096 1243.07 290 1247.2 284.956 1247.2C279.911 1247.2 275.815 1243.07 275.815 1237.96C275.815 1232.86 279.911 1228.73 284.956 1228.73C290 1228.73 294.096 1232.86 294.096 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1237.96C321.639 1243.07 317.543 1247.2 312.499 1247.2C307.454 1247.2 303.358 1243.07 303.358 1237.96C303.358 1232.86 307.454 1228.73 312.499 1228.73C317.543 1228.73 321.639 1232.86 321.639 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1237.96C349.18 1243.07 345.083 1247.2 340.039 1247.2C334.994 1247.2 330.898 1243.07 330.898 1237.96C330.898 1232.86 334.994 1228.73 340.039 1228.73C345.083 1228.73 349.18 1232.86 349.18 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1237.96C376.72 1243.07 372.624 1247.2 367.58 1247.2C362.535 1247.2 358.439 1243.07 358.439 1237.96C358.439 1232.86 362.535 1228.73 367.58 1228.73C372.624 1228.73 376.72 1232.86 376.72 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1237.96C404.262 1243.07 400.166 1247.2 395.122 1247.2C390.077 1247.2 385.981 1243.07 385.981 1237.96C385.981 1232.86 390.077 1228.73 395.122 1228.73C400.166 1228.73 404.262 1232.86 404.262 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1237.96C431.805 1243.07 427.708 1247.2 422.664 1247.2C417.619 1247.2 413.523 1243.07 413.523 1237.96C413.523 1232.86 417.619 1228.73 422.664 1228.73C427.708 1228.73 431.805 1232.86 431.805 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1237.96C459.346 1243.07 455.25 1247.2 450.206 1247.2C445.161 1247.2 441.065 1243.07 441.065 1237.96C441.065 1232.86 445.161 1228.73 450.206 1228.73C455.25 1228.73 459.346 1232.86 459.346 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1237.96C486.889 1243.07 482.792 1247.2 477.748 1247.2C472.703 1247.2 468.607 1243.07 468.607 1237.96C468.607 1232.86 472.703 1228.73 477.748 1228.73C482.792 1228.73 486.889 1232.86 486.889 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 1021.2C638.368 1026.3 634.272 1030.43 629.227 1030.43C624.183 1030.43 620.087 1026.3 620.087 1021.2C620.087 1016.1 624.183 1011.97 629.227 1011.97C634.272 1011.97 638.368 1016.1 638.368 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 997.116C652.138 1002.22 648.042 1006.35 642.998 1006.35C637.953 1006.35 633.857 1002.22 633.857 997.116C633.857 992.013 637.953 987.882 642.998 987.882C648.042 987.882 652.138 992.013 652.138 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 948.945C679.68 954.049 675.583 958.179 670.539 958.179C665.494 958.179 661.398 954.049 661.398 948.945C661.398 943.842 665.494 939.712 670.539 939.712C675.583 939.712 679.68 943.842 679.68 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 924.861C693.452 929.965 689.356 934.095 684.311 934.095C679.267 934.095 675.171 929.965 675.171 924.861C675.171 919.758 679.267 915.628 684.311 915.628C689.356 915.628 693.452 919.758 693.452 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 900.777C707.219 905.881 703.123 910.011 698.079 910.011C693.034 910.011 688.938 905.881 688.938 900.777C688.938 895.674 693.034 891.543 698.079 891.543C703.123 891.543 707.219 895.674 707.219 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 876.691C720.991 881.794 716.895 885.925 711.85 885.925C706.806 885.925 702.71 881.794 702.71 876.691C702.71 871.587 706.806 867.457 711.85 867.457C716.895 867.457 720.991 871.587 720.991 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 852.606C734.763 857.71 730.666 861.84 725.622 861.84C720.577 861.84 716.481 857.71 716.481 852.606C716.481 847.503 720.577 843.372 725.622 843.372C730.666 843.372 734.763 847.503 734.763 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 828.522C748.533 833.626 744.437 837.756 739.392 837.756C734.348 837.756 730.252 833.626 730.252 828.522C730.252 823.419 734.348 819.288 739.392 819.288C744.437 819.288 748.533 823.419 748.533 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 804.436C762.303 809.54 758.207 813.67 753.163 813.67C748.118 813.67 744.022 809.54 744.022 804.436C744.022 799.333 748.118 795.202 753.163 795.202C758.207 795.202 762.303 799.333 762.303 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 780.352C748.533 785.456 744.437 789.586 739.392 789.586C734.348 789.586 730.252 785.456 730.252 780.352C730.252 775.249 734.348 771.118 739.392 771.118C744.437 771.118 748.533 775.249 748.533 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 756.268C734.763 761.371 730.666 765.502 725.622 765.502C720.577 765.502 716.481 761.371 716.481 756.268C716.481 751.164 720.577 747.034 725.622 747.034C730.666 747.034 734.763 751.164 734.763 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 732.181C720.991 737.285 716.895 741.415 711.85 741.415C706.806 741.415 702.71 737.285 702.71 732.181C702.71 727.078 706.806 722.947 711.85 722.947C716.895 722.947 720.991 727.078 720.991 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 708.097C707.219 713.201 703.123 717.331 698.079 717.331C693.034 717.331 688.938 713.201 688.938 708.097C688.938 702.994 693.034 698.863 698.079 698.863C703.123 698.863 707.219 702.994 707.219 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 684.013C693.452 689.116 689.356 693.247 684.311 693.247C679.267 693.247 675.171 689.116 675.171 684.013C675.171 678.909 679.267 674.779 684.311 674.779C689.356 674.779 693.452 678.909 693.452 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 659.927C679.68 665.03 675.583 669.161 670.539 669.161C665.494 669.161 661.398 665.03 661.398 659.927C661.398 654.823 665.494 650.693 670.539 650.693C675.583 650.693 679.68 654.823 679.68 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 635.842C665.909 640.946 661.813 645.076 656.768 645.076C651.724 645.076 647.628 640.946 647.628 635.842C647.628 630.739 651.724 626.608 656.768 626.608C661.813 626.608 665.909 630.739 665.909 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 611.758C652.138 616.862 648.042 620.992 642.998 620.992C637.953 620.992 633.857 616.862 633.857 611.758C633.857 606.655 637.953 602.525 642.998 602.525C648.042 602.525 652.138 606.655 652.138 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 587.672C638.368 592.775 634.272 596.906 629.227 596.906C624.183 596.906 620.087 592.775 620.087 587.672C620.087 582.568 624.183 578.438 629.227 578.438C634.272 578.438 638.368 582.568 638.368 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 563.588C624.597 568.691 620.5 572.822 615.456 572.822C610.411 572.822 606.315 568.691 606.315 563.588C606.315 558.484 610.411 554.354 615.456 554.354C620.5 554.354 624.597 558.484 624.597 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 539.504C610.825 544.608 606.729 548.738 601.684 548.738C596.64 548.738 592.544 544.608 592.544 539.504C592.544 534.401 596.64 530.27 601.684 530.27C606.729 530.27 610.825 534.401 610.825 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 515.417C597.054 520.52 592.958 524.651 587.914 524.651C582.869 524.651 578.773 520.52 578.773 515.417C578.773 510.313 582.869 506.183 587.914 506.183C592.958 506.183 597.054 510.313 597.054 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 491.333C583.284 496.436 579.188 500.567 574.143 500.567C569.099 500.567 565.003 496.436 565.003 491.333C565.003 486.229 569.099 482.099 574.143 482.099C579.188 482.099 583.284 486.229 583.284 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 467.249C569.512 472.352 565.416 476.483 560.372 476.483C555.327 476.483 551.231 472.352 551.231 467.249C551.231 462.145 555.327 458.015 560.372 458.015C565.416 458.015 569.512 462.145 569.512 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 419.079C541.971 424.182 537.874 428.313 532.83 428.313C527.785 428.313 523.689 424.182 523.689 419.079C523.689 413.975 527.785 409.845 532.83 409.845C537.874 409.845 541.971 413.975 541.971 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 370.908C404.262 376.011 400.166 380.142 395.122 380.142C390.077 380.142 385.981 376.011 385.981 370.908C385.981 365.804 390.077 361.674 395.122 361.674C400.166 361.674 404.262 365.804 404.262 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 370.908C376.72 376.011 372.624 380.142 367.58 380.142C362.535 380.142 358.439 376.011 358.439 370.908C358.439 365.804 362.535 361.674 367.58 361.674C372.624 361.674 376.72 365.804 376.72 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1262.05C307.868 1267.15 303.772 1271.28 298.727 1271.28C293.683 1271.28 289.587 1267.15 289.587 1262.05C289.587 1256.95 293.683 1252.82 298.727 1252.82C303.772 1252.82 307.868 1256.95 307.868 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1262.05C335.409 1267.15 331.313 1271.28 326.268 1271.28C321.224 1271.28 317.128 1267.15 317.128 1262.05C317.128 1256.95 321.224 1252.82 326.268 1252.82C331.313 1252.82 335.409 1256.95 335.409 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1262.05C362.951 1267.15 358.855 1271.28 353.81 1271.28C348.766 1271.28 344.67 1267.15 344.67 1262.05C344.67 1256.95 348.766 1252.82 353.81 1252.82C358.855 1252.82 362.951 1256.95 362.951 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1262.05C390.493 1267.15 386.397 1271.28 381.352 1271.28C376.308 1271.28 372.212 1267.15 372.212 1262.05C372.212 1256.95 376.308 1252.82 381.352 1252.82C386.397 1252.82 390.493 1256.95 390.493 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1262.05C418.034 1267.15 413.938 1271.28 408.893 1271.28C403.849 1271.28 399.753 1267.15 399.753 1262.05C399.753 1256.95 403.849 1252.82 408.893 1252.82C413.938 1252.82 418.034 1256.95 418.034 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1262.05C445.575 1267.15 441.479 1271.28 436.434 1271.28C431.39 1271.28 427.294 1267.15 427.294 1262.05C427.294 1256.95 431.39 1252.82 436.434 1252.82C441.479 1252.82 445.575 1256.95 445.575 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1262.05C473.117 1267.15 469.021 1271.28 463.976 1271.28C458.932 1271.28 454.836 1267.15 454.836 1262.05C454.836 1256.95 458.932 1252.82 463.976 1252.82C469.021 1252.82 473.117 1256.95 473.117 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 1262.05C500.659 1267.15 496.563 1271.28 491.518 1271.28C486.474 1271.28 482.378 1267.15 482.378 1262.05C482.378 1256.95 486.474 1252.82 491.518 1252.82C496.563 1252.82 500.659 1256.95 500.659 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 948.945C707.219 954.049 703.123 958.179 698.079 958.179C693.034 958.179 688.938 954.049 688.938 948.945C688.938 943.842 693.034 939.712 698.079 939.712C703.123 939.712 707.219 943.842 707.219 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 924.861C720.991 929.965 716.895 934.095 711.85 934.095C706.806 934.095 702.71 929.965 702.71 924.861C702.71 919.758 706.806 915.628 711.85 915.628C716.895 915.628 720.991 919.758 720.991 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 900.777C734.763 905.881 730.666 910.011 725.622 910.011C720.577 910.011 716.481 905.881 716.481 900.777C716.481 895.674 720.577 891.543 725.622 891.543C730.666 891.543 734.763 895.674 734.763 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 876.691C748.533 881.794 744.437 885.925 739.392 885.925C734.348 885.925 730.252 881.794 730.252 876.691C730.252 871.587 734.348 867.457 739.392 867.457C744.437 867.457 748.533 871.587 748.533 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 852.606C762.303 857.71 758.207 861.84 753.163 861.84C748.118 861.84 744.022 857.71 744.022 852.606C744.022 847.503 748.118 843.372 753.163 843.372C758.207 843.372 762.303 847.503 762.303 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.076 828.522C776.076 833.626 771.98 837.756 766.935 837.756C761.891 837.756 757.795 833.626 757.795 828.522C757.795 823.419 761.891 819.288 766.935 819.288C771.98 819.288 776.076 823.419 776.076 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 804.436C789.847 809.54 785.75 813.67 780.706 813.67C775.661 813.67 771.565 809.54 771.565 804.436C771.565 799.333 775.661 795.202 780.706 795.202C785.75 795.202 789.847 799.333 789.847 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 780.352C776.075 785.456 771.979 789.586 766.934 789.586C761.89 789.586 757.794 785.456 757.794 780.352C757.794 775.249 761.89 771.118 766.934 771.118C771.979 771.118 776.075 775.249 776.075 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 756.268C762.303 761.371 758.207 765.502 753.163 765.502C748.118 765.502 744.022 761.371 744.022 756.268C744.022 751.164 748.118 747.034 753.163 747.034C758.207 747.034 762.303 751.164 762.303 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 732.181C748.533 737.285 744.437 741.415 739.392 741.415C734.348 741.415 730.252 737.285 730.252 732.181C730.252 727.078 734.348 722.947 739.392 722.947C744.437 722.947 748.533 727.078 748.533 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 708.097C734.763 713.201 730.666 717.331 725.622 717.331C720.577 717.331 716.481 713.201 716.481 708.097C716.481 702.994 720.577 698.863 725.622 698.863C730.666 698.863 734.763 702.994 734.763 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 684.013C720.991 689.116 716.895 693.247 711.85 693.247C706.806 693.247 702.71 689.116 702.71 684.013C702.71 678.909 706.806 674.779 711.85 674.779C716.895 674.779 720.991 678.909 720.991 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 659.927C707.219 665.03 703.123 669.161 698.079 669.161C693.034 669.161 688.938 665.03 688.938 659.927C688.938 654.823 693.034 650.693 698.079 650.693C703.123 650.693 707.219 654.823 707.219 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 635.842C693.452 640.946 689.356 645.076 684.311 645.076C679.267 645.076 675.171 640.946 675.171 635.842C675.171 630.739 679.267 626.608 684.311 626.608C689.356 626.608 693.452 630.739 693.452 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 611.758C679.68 616.862 675.583 620.992 670.539 620.992C665.494 620.992 661.398 616.862 661.398 611.758C661.398 606.655 665.494 602.525 670.539 602.525C675.583 602.525 679.68 606.655 679.68 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 587.672C665.909 592.775 661.813 596.906 656.768 596.906C651.724 596.906 647.628 592.775 647.628 587.672C647.628 582.568 651.724 578.438 656.768 578.438C661.813 578.438 665.909 582.568 665.909 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 563.588C652.138 568.691 648.042 572.822 642.998 572.822C637.953 572.822 633.857 568.691 633.857 563.588C633.857 558.484 637.953 554.354 642.998 554.354C648.042 554.354 652.138 558.484 652.138 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 539.504C638.368 544.608 634.272 548.738 629.227 548.738C624.183 548.738 620.087 544.608 620.087 539.504C620.087 534.401 624.183 530.27 629.227 530.27C634.272 530.27 638.368 534.401 638.368 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 515.417C624.597 520.52 620.5 524.651 615.456 524.651C610.411 524.651 606.315 520.52 606.315 515.417C606.315 510.313 610.411 506.183 615.456 506.183C620.5 506.183 624.597 510.313 624.597 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 491.333C610.825 496.436 606.729 500.567 601.684 500.567C596.64 500.567 592.544 496.436 592.544 491.333C592.544 486.229 596.64 482.099 601.684 482.099C606.729 482.099 610.825 486.229 610.825 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 467.249C597.054 472.352 592.958 476.483 587.914 476.483C582.869 476.483 578.773 472.352 578.773 467.249C578.773 462.145 582.869 458.015 587.914 458.015C592.958 458.015 597.054 462.145 597.054 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 443.162C583.284 448.265 579.188 452.396 574.143 452.396C569.099 452.396 565.003 448.266 565.003 443.162C565.003 438.059 569.099 433.928 574.143 433.928C579.188 433.928 583.284 438.059 583.284 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1286.13C294.096 1291.24 290 1295.37 284.956 1295.37C279.911 1295.37 275.815 1291.24 275.815 1286.13C275.815 1281.03 279.911 1276.9 284.956 1276.9C290 1276.9 294.096 1281.03 294.096 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1286.13C321.639 1291.24 317.543 1295.37 312.499 1295.37C307.454 1295.37 303.358 1291.24 303.358 1286.13C303.358 1281.03 307.454 1276.9 312.499 1276.9C317.543 1276.9 321.639 1281.03 321.639 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1286.13C349.18 1291.24 345.083 1295.37 340.039 1295.37C334.994 1295.37 330.898 1291.24 330.898 1286.13C330.898 1281.03 334.994 1276.9 340.039 1276.9C345.083 1276.9 349.18 1281.03 349.18 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1286.13C376.72 1291.24 372.624 1295.37 367.58 1295.37C362.535 1295.37 358.439 1291.24 358.439 1286.13C358.439 1281.03 362.535 1276.9 367.58 1276.9C372.624 1276.9 376.72 1281.03 376.72 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1286.13C404.262 1291.24 400.166 1295.37 395.122 1295.37C390.077 1295.37 385.981 1291.24 385.981 1286.13C385.981 1281.03 390.077 1276.9 395.122 1276.9C400.166 1276.9 404.262 1281.03 404.262 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1286.13C431.805 1291.24 427.708 1295.37 422.664 1295.37C417.619 1295.37 413.523 1291.24 413.523 1286.13C413.523 1281.03 417.619 1276.9 422.664 1276.9C427.708 1276.9 431.805 1281.03 431.805 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.598 1286.14C458.598 1290.82 454.837 1294.61 450.206 1294.61C445.574 1294.61 441.813 1290.82 441.813 1286.14C441.813 1281.45 445.574 1277.66 450.206 1277.66C454.837 1277.66 458.598 1281.45 458.598 1286.14Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.889 1286.13C486.889 1291.24 482.792 1295.37 477.748 1295.37C472.703 1295.37 468.607 1291.24 468.607 1286.13C468.607 1281.03 472.703 1276.9 477.748 1276.9C482.792 1276.9 486.889 1281.03 486.889 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 973.032C720.991 978.135 716.895 982.266 711.85 982.266C706.806 982.266 702.71 978.135 702.71 973.032C702.71 967.928 706.806 963.798 711.85 963.798C716.895 963.798 720.991 967.928 720.991 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 948.945C734.763 954.049 730.666 958.179 725.622 958.179C720.577 958.179 716.481 954.049 716.481 948.945C716.481 943.842 720.577 939.712 725.622 939.712C730.666 939.712 734.763 943.842 734.763 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 924.861C748.533 929.965 744.437 934.095 739.392 934.095C734.348 934.095 730.252 929.965 730.252 924.861C730.252 919.758 734.348 915.628 739.392 915.628C744.437 915.628 748.533 919.758 748.533 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 900.777C762.303 905.881 758.207 910.011 753.163 910.011C748.118 910.011 744.022 905.881 744.022 900.777C744.022 895.674 748.118 891.543 753.163 891.543C758.207 891.543 762.303 895.674 762.303 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 876.691C776.075 881.794 771.979 885.925 766.934 885.925C761.89 885.925 757.794 881.794 757.794 876.691C757.794 871.587 761.89 867.457 766.934 867.457C771.979 867.457 776.075 871.587 776.075 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 852.606C789.847 857.71 785.75 861.84 780.706 861.84C775.661 861.84 771.565 857.71 771.565 852.606C771.565 847.503 775.661 843.372 780.706 843.372C785.75 843.372 789.847 847.503 789.847 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 828.522C803.617 833.626 799.521 837.756 794.476 837.756C789.432 837.756 785.336 833.626 785.336 828.522C785.336 823.419 789.432 819.288 794.476 819.288C799.521 819.288 803.617 823.419 803.617 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 804.436C817.387 809.54 813.291 813.67 808.247 813.67C803.202 813.67 799.106 809.54 799.106 804.436C799.106 799.333 803.202 795.202 808.247 795.202C813.291 795.202 817.387 799.333 817.387 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 780.352C803.617 785.456 799.521 789.586 794.476 789.586C789.432 789.586 785.336 785.456 785.336 780.352C785.336 775.249 789.432 771.118 794.476 771.118C799.521 771.118 803.617 775.249 803.617 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 756.268C789.847 761.371 785.75 765.502 780.706 765.502C775.661 765.502 771.565 761.371 771.565 756.268C771.565 751.164 775.661 747.034 780.706 747.034C785.75 747.034 789.847 751.164 789.847 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 732.181C776.075 737.285 771.979 741.415 766.934 741.415C761.89 741.415 757.794 737.285 757.794 732.181C757.794 727.078 761.89 722.947 766.934 722.947C771.979 722.947 776.075 727.078 776.075 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 708.097C762.303 713.201 758.207 717.331 753.163 717.331C748.118 717.331 744.022 713.201 744.022 708.097C744.022 702.994 748.118 698.863 753.163 698.863C758.207 698.863 762.303 702.994 762.303 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 684.013C748.533 689.116 744.437 693.247 739.392 693.247C734.348 693.247 730.252 689.116 730.252 684.013C730.252 678.909 734.348 674.779 739.392 674.779C744.437 674.779 748.533 678.909 748.533 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 659.927C734.763 665.03 730.666 669.161 725.622 669.161C720.577 669.161 716.481 665.03 716.481 659.927C716.481 654.823 720.577 650.693 725.622 650.693C730.666 650.693 734.763 654.823 734.763 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 635.842C720.991 640.946 716.895 645.076 711.85 645.076C706.806 645.076 702.71 640.946 702.71 635.842C702.71 630.739 706.806 626.608 711.85 626.608C716.895 626.608 720.991 630.739 720.991 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 611.758C707.219 616.862 703.123 620.992 698.079 620.992C693.034 620.992 688.938 616.862 688.938 611.758C688.938 606.655 693.034 602.525 698.079 602.525C703.123 602.525 707.219 606.655 707.219 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 587.672C693.452 592.775 689.356 596.906 684.311 596.906C679.267 596.906 675.171 592.775 675.171 587.672C675.171 582.568 679.267 578.438 684.311 578.438C689.356 578.438 693.452 582.568 693.452 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 563.588C679.68 568.691 675.583 572.822 670.539 572.822C665.494 572.822 661.398 568.691 661.398 563.588C661.398 558.484 665.494 554.354 670.539 554.354C675.583 554.354 679.68 558.484 679.68 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 539.504C665.909 544.608 661.813 548.738 656.768 548.738C651.724 548.738 647.628 544.608 647.628 539.504C647.628 534.401 651.724 530.27 656.768 530.27C661.813 530.27 665.909 534.401 665.909 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 515.417C652.138 520.52 648.042 524.651 642.998 524.651C637.953 524.651 633.857 520.52 633.857 515.417C633.857 510.313 637.953 506.183 642.998 506.183C648.042 506.183 652.138 510.313 652.138 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 491.333C638.368 496.436 634.272 500.567 629.227 500.567C624.183 500.567 620.087 496.436 620.087 491.333C620.087 486.229 624.183 482.099 629.227 482.099C634.272 482.099 638.368 486.229 638.368 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 467.249C624.597 472.352 620.5 476.483 615.456 476.483C610.411 476.483 606.315 472.352 606.315 467.249C606.315 462.145 610.411 458.015 615.456 458.015C620.5 458.015 624.597 462.145 624.597 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 443.162C610.825 448.266 606.729 452.396 601.684 452.396C596.64 452.396 592.544 448.266 592.544 443.162C592.544 438.059 596.64 433.928 601.684 433.928C606.729 433.928 610.825 438.059 610.825 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 419.079C597.054 424.182 592.958 428.313 587.914 428.313C582.869 428.313 578.773 424.182 578.773 419.079C578.773 413.975 582.869 409.845 587.914 409.845C592.958 409.845 597.054 413.975 597.054 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 394.994C583.284 400.098 579.188 404.228 574.143 404.228C569.099 404.228 565.003 400.098 565.003 394.994C565.003 389.891 569.099 385.76 574.143 385.76C579.188 385.76 583.284 389.891 583.284 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 1310.22C280.326 1315.32 276.23 1319.45 271.185 1319.45C266.141 1319.45 262.045 1315.32 262.045 1310.22C262.045 1305.12 266.141 1300.98 271.185 1300.98C276.23 1300.98 280.326 1305.12 280.326 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1310.22C307.868 1315.32 303.772 1319.45 298.727 1319.45C293.683 1319.45 289.587 1315.32 289.587 1310.22C289.587 1305.12 293.683 1300.98 298.727 1300.98C303.772 1300.98 307.868 1305.12 307.868 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1310.22C335.409 1315.32 331.313 1319.45 326.268 1319.45C321.224 1319.45 317.128 1315.32 317.128 1310.22C317.128 1305.12 321.224 1300.98 326.268 1300.98C331.313 1300.98 335.409 1305.12 335.409 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1310.22C362.951 1315.32 358.855 1319.45 353.81 1319.45C348.766 1319.45 344.67 1315.32 344.67 1310.22C344.67 1305.12 348.766 1300.98 353.81 1300.98C358.855 1300.98 362.951 1305.12 362.951 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1310.22C390.493 1315.32 386.397 1319.45 381.352 1319.45C376.308 1319.45 372.212 1315.32 372.212 1310.22C372.212 1305.12 376.308 1300.98 381.352 1300.98C386.397 1300.98 390.493 1305.12 390.493 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1310.22C418.034 1315.32 413.938 1319.45 408.893 1319.45C403.849 1319.45 399.753 1315.32 399.753 1310.22C399.753 1305.12 403.849 1300.98 408.893 1300.98C413.938 1300.98 418.034 1305.12 418.034 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1310.22C445.575 1315.32 441.479 1319.45 436.434 1319.45C431.39 1319.45 427.294 1315.32 427.294 1310.22C427.294 1305.12 431.39 1300.98 436.434 1300.98C441.479 1300.98 445.575 1305.12 445.575 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.117 1310.22C473.117 1315.32 469.021 1319.45 463.976 1319.45C458.932 1319.45 454.836 1315.32 454.836 1310.22C454.836 1305.12 458.932 1300.98 463.976 1300.98C469.021 1300.98 473.117 1305.12 473.117 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.659 1310.22C500.659 1315.32 496.563 1319.45 491.518 1319.45C486.474 1319.45 482.378 1315.32 482.378 1310.22C482.378 1305.12 486.474 1300.98 491.518 1300.98C496.563 1300.98 500.659 1305.12 500.659 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 1310.22C555.742 1315.32 551.646 1319.45 546.601 1319.45C541.557 1319.45 537.461 1315.32 537.461 1310.22C537.461 1305.12 541.557 1300.98 546.601 1300.98C551.646 1300.98 555.742 1305.12 555.742 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 973.032C748.533 978.135 744.437 982.266 739.392 982.266C734.348 982.266 730.252 978.135 730.252 973.032C730.252 967.928 734.348 963.798 739.392 963.798C744.437 963.798 748.533 967.928 748.533 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 948.945C762.303 954.049 758.207 958.179 753.163 958.179C748.118 958.179 744.022 954.049 744.022 948.945C744.022 943.842 748.118 939.712 753.163 939.712C758.207 939.712 762.303 943.842 762.303 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 924.861C776.075 929.965 771.979 934.095 766.934 934.095C761.89 934.095 757.794 929.965 757.794 924.861C757.794 919.758 761.89 915.628 766.934 915.628C771.979 915.628 776.075 919.758 776.075 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 900.777C789.847 905.881 785.75 910.011 780.706 910.011C775.661 910.011 771.565 905.881 771.565 900.777C771.565 895.674 775.661 891.543 780.706 891.543C785.75 891.543 789.847 895.674 789.847 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 876.691C803.617 881.794 799.521 885.925 794.476 885.925C789.432 885.925 785.336 881.794 785.336 876.691C785.336 871.587 789.432 867.457 794.476 867.457C799.521 867.457 803.617 871.587 803.617 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 852.606C817.387 857.71 813.291 861.84 808.247 861.84C803.202 861.84 799.106 857.71 799.106 852.606C799.106 847.503 803.202 843.372 808.247 843.372C813.291 843.372 817.387 847.503 817.387 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 828.522C831.158 833.626 827.062 837.756 822.017 837.756C816.973 837.756 812.877 833.626 812.877 828.522C812.877 823.419 816.973 819.288 822.017 819.288C827.062 819.288 831.158 823.419 831.158 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 804.436C844.929 809.54 840.833 813.67 835.789 813.67C830.744 813.67 826.648 809.54 826.648 804.436C826.648 799.333 830.744 795.202 835.789 795.202C840.833 795.202 844.929 799.333 844.929 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 780.352C831.158 785.456 827.062 789.586 822.017 789.586C816.973 789.586 812.877 785.456 812.877 780.352C812.877 775.249 816.973 771.118 822.017 771.118C827.062 771.118 831.158 775.249 831.158 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 756.268C817.387 761.371 813.291 765.502 808.247 765.502C803.202 765.502 799.106 761.371 799.106 756.268C799.106 751.164 803.202 747.034 808.247 747.034C813.291 747.034 817.387 751.164 817.387 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 732.181C803.617 737.285 799.521 741.415 794.476 741.415C789.432 741.415 785.336 737.285 785.336 732.181C785.336 727.078 789.432 722.947 794.476 722.947C799.521 722.947 803.617 727.078 803.617 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 708.097C789.847 713.201 785.75 717.331 780.706 717.331C775.661 717.331 771.565 713.201 771.565 708.097C771.565 702.994 775.661 698.863 780.706 698.863C785.75 698.863 789.847 702.994 789.847 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 684.013C776.075 689.116 771.979 693.247 766.934 693.247C761.89 693.247 757.794 689.116 757.794 684.013C757.794 678.909 761.89 674.779 766.934 674.779C771.979 674.779 776.075 678.909 776.075 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 659.927C762.303 665.03 758.207 669.161 753.163 669.161C748.118 669.161 744.022 665.03 744.022 659.927C744.022 654.823 748.118 650.693 753.163 650.693C758.207 650.693 762.303 654.823 762.303 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 635.842C748.533 640.946 744.437 645.076 739.392 645.076C734.348 645.076 730.252 640.946 730.252 635.842C730.252 630.739 734.348 626.608 739.392 626.608C744.437 626.608 748.533 630.739 748.533 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 611.758C734.763 616.862 730.666 620.992 725.622 620.992C720.577 620.992 716.481 616.862 716.481 611.758C716.481 606.655 720.577 602.525 725.622 602.525C730.666 602.525 734.763 606.655 734.763 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 587.672C720.991 592.775 716.895 596.906 711.85 596.906C706.806 596.906 702.71 592.775 702.71 587.672C702.71 582.568 706.806 578.438 711.85 578.438C716.895 578.438 720.991 582.568 720.991 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 563.588C707.219 568.691 703.123 572.822 698.079 572.822C693.034 572.822 688.938 568.691 688.938 563.588C688.938 558.484 693.034 554.354 698.079 554.354C703.123 554.354 707.219 558.484 707.219 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 539.504C693.452 544.608 689.356 548.738 684.311 548.738C679.267 548.738 675.171 544.608 675.171 539.504C675.171 534.401 679.267 530.27 684.311 530.27C689.356 530.27 693.452 534.401 693.452 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 515.417C679.68 520.52 675.583 524.651 670.539 524.651C665.494 524.651 661.398 520.52 661.398 515.417C661.398 510.313 665.494 506.183 670.539 506.183C675.583 506.183 679.68 510.313 679.68 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 491.333C665.909 496.436 661.813 500.567 656.768 500.567C651.724 500.567 647.628 496.436 647.628 491.333C647.628 486.229 651.724 482.099 656.768 482.099C661.813 482.099 665.909 486.229 665.909 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 467.249C652.138 472.352 648.042 476.483 642.998 476.483C637.953 476.483 633.857 472.352 633.857 467.249C633.857 462.145 637.953 458.015 642.998 458.015C648.042 458.015 652.138 462.145 652.138 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 443.162C638.368 448.266 634.272 452.396 629.227 452.396C624.183 452.396 620.087 448.265 620.087 443.162C620.087 438.059 624.183 433.928 629.227 433.928C634.272 433.928 638.368 438.059 638.368 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 419.079C624.597 424.182 620.5 428.313 615.456 428.313C610.411 428.313 606.315 424.182 606.315 419.079C606.315 413.975 610.411 409.845 615.456 409.845C620.5 409.845 624.597 413.975 624.597 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 1334.31C294.096 1339.41 290 1343.54 284.956 1343.54C279.911 1343.54 275.815 1339.41 275.815 1334.31C275.815 1329.2 279.911 1325.07 284.956 1325.07C290 1325.07 294.096 1329.2 294.096 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1334.31C321.639 1339.41 317.543 1343.54 312.499 1343.54C307.454 1343.54 303.358 1339.41 303.358 1334.31C303.358 1329.2 307.454 1325.07 312.499 1325.07C317.543 1325.07 321.639 1329.2 321.639 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1334.31C349.18 1339.41 345.083 1343.54 340.039 1343.54C334.994 1343.54 330.898 1339.41 330.898 1334.31C330.898 1329.2 334.994 1325.07 340.039 1325.07C345.083 1325.07 349.18 1329.2 349.18 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1334.31C376.72 1339.41 372.624 1343.54 367.58 1343.54C362.535 1343.54 358.439 1339.41 358.439 1334.31C358.439 1329.2 362.535 1325.07 367.58 1325.07C372.624 1325.07 376.72 1329.2 376.72 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1334.31C404.262 1339.41 400.166 1343.54 395.122 1343.54C390.077 1343.54 385.981 1339.41 385.981 1334.31C385.981 1329.2 390.077 1325.07 395.122 1325.07C400.166 1325.07 404.262 1329.2 404.262 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1334.31C431.805 1339.41 427.708 1343.54 422.664 1343.54C417.619 1343.54 413.523 1339.41 413.523 1334.31C413.523 1329.2 417.619 1325.07 422.664 1325.07C427.708 1325.07 431.805 1329.2 431.805 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1334.31C459.346 1339.41 455.25 1343.54 450.206 1343.54C445.161 1343.54 441.065 1339.41 441.065 1334.31C441.065 1329.2 445.161 1325.07 450.206 1325.07C455.25 1325.07 459.346 1329.2 459.346 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 1334.31C541.971 1339.41 537.874 1343.54 532.83 1343.54C527.785 1343.54 523.689 1339.41 523.689 1334.31C523.689 1329.2 527.785 1325.07 532.83 1325.07C537.874 1325.07 541.971 1329.2 541.971 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.511 1334.31C569.511 1339.41 565.415 1343.54 560.371 1343.54C555.326 1343.54 551.23 1339.41 551.23 1334.31C551.23 1329.2 555.326 1325.07 560.371 1325.07C565.415 1325.07 569.511 1329.2 569.511 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 973.032C776.075 978.135 771.979 982.266 766.934 982.266C761.89 982.266 757.794 978.135 757.794 973.032C757.794 967.928 761.89 963.798 766.934 963.798C771.979 963.798 776.075 967.928 776.075 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 948.945C789.847 954.049 785.75 958.179 780.706 958.179C775.661 958.179 771.565 954.049 771.565 948.945C771.565 943.842 775.661 939.712 780.706 939.712C785.75 939.712 789.847 943.842 789.847 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 924.861C803.617 929.965 799.521 934.095 794.476 934.095C789.432 934.095 785.336 929.965 785.336 924.861C785.336 919.758 789.432 915.628 794.476 915.628C799.521 915.628 803.617 919.758 803.617 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 900.777C817.387 905.881 813.291 910.011 808.247 910.011C803.202 910.011 799.106 905.881 799.106 900.777C799.106 895.674 803.202 891.543 808.247 891.543C813.291 891.543 817.387 895.674 817.387 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 876.691C831.158 881.794 827.062 885.925 822.017 885.925C816.973 885.925 812.877 881.794 812.877 876.691C812.877 871.587 816.973 867.457 822.017 867.457C827.062 867.457 831.158 871.587 831.158 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 852.606C844.929 857.71 840.833 861.84 835.789 861.84C830.744 861.84 826.648 857.71 826.648 852.606C826.648 847.503 830.744 843.372 835.789 843.372C840.833 843.372 844.929 847.503 844.929 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 828.522C858.699 833.626 854.603 837.756 849.558 837.756C844.514 837.756 840.418 833.626 840.418 828.522C840.418 823.419 844.514 819.288 849.558 819.288C854.603 819.288 858.699 823.419 858.699 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 804.436C872.471 809.54 868.374 813.67 863.33 813.67C858.285 813.67 854.189 809.54 854.189 804.436C854.189 799.333 858.285 795.202 863.33 795.202C868.374 795.202 872.471 799.333 872.471 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 780.352C858.699 785.456 854.603 789.586 849.558 789.586C844.514 789.586 840.418 785.456 840.418 780.352C840.418 775.249 844.514 771.118 849.558 771.118C854.603 771.118 858.699 775.249 858.699 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 756.268C844.929 761.371 840.833 765.502 835.789 765.502C830.744 765.502 826.648 761.371 826.648 756.268C826.648 751.164 830.744 747.034 835.789 747.034C840.833 747.034 844.929 751.164 844.929 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 732.181C831.158 737.285 827.062 741.415 822.017 741.415C816.973 741.415 812.877 737.285 812.877 732.181C812.877 727.078 816.973 722.947 822.017 722.947C827.062 722.947 831.158 727.078 831.158 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 708.097C817.387 713.201 813.291 717.331 808.247 717.331C803.202 717.331 799.106 713.201 799.106 708.097C799.106 702.994 803.202 698.863 808.247 698.863C813.291 698.863 817.387 702.994 817.387 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 684.013C803.617 689.116 799.521 693.247 794.476 693.247C789.432 693.247 785.336 689.116 785.336 684.013C785.336 678.909 789.432 674.779 794.476 674.779C799.521 674.779 803.617 678.909 803.617 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 659.927C789.847 665.03 785.75 669.161 780.706 669.161C775.661 669.161 771.565 665.03 771.565 659.927C771.565 654.823 775.661 650.693 780.706 650.693C785.75 650.693 789.847 654.823 789.847 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 635.842C776.075 640.946 771.979 645.076 766.934 645.076C761.89 645.076 757.794 640.946 757.794 635.842C757.794 630.739 761.89 626.608 766.934 626.608C771.979 626.608 776.075 630.739 776.075 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 611.758C762.303 616.862 758.207 620.992 753.163 620.992C748.118 620.992 744.022 616.862 744.022 611.758C744.022 606.655 748.118 602.525 753.163 602.525C758.207 602.525 762.303 606.655 762.303 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 587.672C748.533 592.775 744.437 596.906 739.392 596.906C734.348 596.906 730.252 592.775 730.252 587.672C730.252 582.568 734.348 578.438 739.392 578.438C744.437 578.438 748.533 582.568 748.533 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 563.588C734.763 568.691 730.666 572.822 725.622 572.822C720.577 572.822 716.481 568.691 716.481 563.588C716.481 558.484 720.577 554.354 725.622 554.354C730.666 554.354 734.763 558.484 734.763 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 539.504C720.991 544.608 716.895 548.738 711.85 548.738C706.806 548.738 702.71 544.608 702.71 539.504C702.71 534.401 706.806 530.27 711.85 530.27C716.895 530.27 720.991 534.401 720.991 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 515.417C707.219 520.52 703.123 524.651 698.079 524.651C693.034 524.651 688.938 520.52 688.938 515.417C688.938 510.313 693.034 506.183 698.079 506.183C703.123 506.183 707.219 510.313 707.219 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 491.333C693.452 496.436 689.356 500.567 684.311 500.567C679.267 500.567 675.171 496.436 675.171 491.333C675.171 486.229 679.267 482.099 684.311 482.099C689.356 482.099 693.452 486.229 693.452 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 467.249C679.68 472.352 675.583 476.483 670.539 476.483C665.494 476.483 661.398 472.352 661.398 467.249C661.398 462.145 665.494 458.015 670.539 458.015C675.583 458.015 679.68 462.145 679.68 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.909 443.162C665.909 448.266 661.813 452.396 656.768 452.396C651.724 452.396 647.628 448.266 647.628 443.162C647.628 438.059 651.724 433.928 656.768 433.928C661.813 433.928 665.909 438.059 665.909 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 419.079C652.138 424.182 648.042 428.313 642.998 428.313C637.953 428.313 633.857 424.182 633.857 419.079C633.857 413.975 637.953 409.845 642.998 409.845C648.042 409.845 652.138 413.975 652.138 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.054 322.739C597.054 327.843 592.958 331.973 587.914 331.973C582.869 331.973 578.773 327.843 578.773 322.739C578.773 317.636 582.869 313.505 587.914 313.505C592.958 313.505 597.054 317.636 597.054 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1358.39C307.868 1363.49 303.772 1367.62 298.727 1367.62C293.683 1367.62 289.587 1363.49 289.587 1358.39C289.587 1353.29 293.683 1349.16 298.727 1349.16C303.772 1349.16 307.868 1353.29 307.868 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1358.39C335.409 1363.49 331.313 1367.62 326.268 1367.62C321.224 1367.62 317.128 1363.49 317.128 1358.39C317.128 1353.29 321.224 1349.16 326.268 1349.16C331.313 1349.16 335.409 1353.29 335.409 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1358.39C362.951 1363.49 358.855 1367.62 353.81 1367.62C348.766 1367.62 344.67 1363.49 344.67 1358.39C344.67 1353.29 348.766 1349.16 353.81 1349.16C358.855 1349.16 362.951 1353.29 362.951 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1358.39C390.493 1363.49 386.397 1367.62 381.352 1367.62C376.308 1367.62 372.212 1363.49 372.212 1358.39C372.212 1353.29 376.308 1349.16 381.352 1349.16C386.397 1349.16 390.493 1353.29 390.493 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1358.39C418.034 1363.49 413.938 1367.62 408.893 1367.62C403.849 1367.62 399.753 1363.49 399.753 1358.39C399.753 1353.29 403.849 1349.16 408.893 1349.16C413.938 1349.16 418.034 1353.29 418.034 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.575 1358.39C445.575 1363.49 441.479 1367.62 436.434 1367.62C431.39 1367.62 427.294 1363.49 427.294 1358.39C427.294 1353.29 431.39 1349.16 436.434 1349.16C441.479 1349.16 445.575 1353.29 445.575 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.742 1358.39C555.742 1363.49 551.646 1367.62 546.601 1367.62C541.557 1367.62 537.461 1363.49 537.461 1358.39C537.461 1353.29 541.557 1349.16 546.601 1349.16C551.646 1349.16 555.742 1353.29 555.742 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 1021.2C776.075 1026.3 771.979 1030.43 766.934 1030.43C761.89 1030.43 757.794 1026.3 757.794 1021.2C757.794 1016.1 761.89 1011.97 766.934 1011.97C771.979 1011.97 776.075 1016.1 776.075 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 997.116C789.847 1002.22 785.75 1006.35 780.706 1006.35C775.661 1006.35 771.565 1002.22 771.565 997.116C771.565 992.013 775.661 987.882 780.706 987.882C785.75 987.882 789.847 992.013 789.847 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 973.032C803.617 978.135 799.521 982.266 794.476 982.266C789.432 982.266 785.336 978.135 785.336 973.032C785.336 967.928 789.432 963.798 794.476 963.798C799.521 963.798 803.617 967.928 803.617 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 948.945C817.387 954.049 813.291 958.179 808.247 958.179C803.202 958.179 799.106 954.049 799.106 948.945C799.106 943.842 803.202 939.712 808.247 939.712C813.291 939.712 817.387 943.842 817.387 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 924.861C831.158 929.965 827.062 934.095 822.017 934.095C816.973 934.095 812.877 929.965 812.877 924.861C812.877 919.758 816.973 915.628 822.017 915.628C827.062 915.628 831.158 919.758 831.158 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 900.777C844.929 905.881 840.833 910.011 835.789 910.011C830.744 910.011 826.648 905.881 826.648 900.777C826.648 895.674 830.744 891.543 835.789 891.543C840.833 891.543 844.929 895.674 844.929 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 876.691C858.699 881.794 854.603 885.925 849.558 885.925C844.514 885.925 840.418 881.794 840.418 876.691C840.418 871.587 844.514 867.457 849.558 867.457C854.603 867.457 858.699 871.587 858.699 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 852.606C872.471 857.71 868.374 861.84 863.33 861.84C858.285 861.84 854.189 857.71 854.189 852.606C854.189 847.503 858.285 843.372 863.33 843.372C868.374 843.372 872.471 847.503 872.471 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 828.522C886.241 833.626 882.145 837.756 877.1 837.756C872.056 837.756 867.96 833.626 867.96 828.522C867.96 823.419 872.056 819.288 877.1 819.288C882.145 819.288 886.241 823.419 886.241 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 804.436C900.012 809.54 895.916 813.67 890.872 813.67C885.827 813.67 881.731 809.54 881.731 804.436C881.731 799.333 885.827 795.202 890.872 795.202C895.916 795.202 900.012 799.333 900.012 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 780.352C886.241 785.456 882.145 789.586 877.1 789.586C872.056 789.586 867.96 785.456 867.96 780.352C867.96 775.249 872.056 771.118 877.1 771.118C882.145 771.118 886.241 775.249 886.241 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 756.268C872.471 761.371 868.374 765.502 863.33 765.502C858.285 765.502 854.189 761.371 854.189 756.268C854.189 751.164 858.285 747.034 863.33 747.034C868.374 747.034 872.471 751.164 872.471 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 732.181C858.699 737.285 854.603 741.415 849.558 741.415C844.514 741.415 840.418 737.285 840.418 732.181C840.418 727.078 844.514 722.947 849.558 722.947C854.603 722.947 858.699 727.078 858.699 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 708.097C844.929 713.201 840.833 717.331 835.789 717.331C830.744 717.331 826.648 713.201 826.648 708.097C826.648 702.994 830.744 698.863 835.789 698.863C840.833 698.863 844.929 702.994 844.929 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 684.013C831.158 689.116 827.062 693.247 822.017 693.247C816.973 693.247 812.877 689.116 812.877 684.013C812.877 678.909 816.973 674.779 822.017 674.779C827.062 674.779 831.158 678.909 831.158 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 659.927C817.387 665.03 813.291 669.161 808.247 669.161C803.202 669.161 799.106 665.03 799.106 659.927C799.106 654.823 803.202 650.693 808.247 650.693C813.291 650.693 817.387 654.823 817.387 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 635.842C803.617 640.946 799.521 645.076 794.476 645.076C789.432 645.076 785.336 640.946 785.336 635.842C785.336 630.739 789.432 626.608 794.476 626.608C799.521 626.608 803.617 630.739 803.617 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 611.758C789.847 616.862 785.75 620.992 780.706 620.992C775.661 620.992 771.565 616.862 771.565 611.758C771.565 606.655 775.661 602.525 780.706 602.525C785.75 602.525 789.847 606.655 789.847 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 587.672C776.075 592.775 771.979 596.906 766.934 596.906C761.89 596.906 757.794 592.775 757.794 587.672C757.794 582.568 761.89 578.438 766.934 578.438C771.979 578.438 776.075 582.568 776.075 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 563.588C762.303 568.691 758.207 572.822 753.163 572.822C748.118 572.822 744.022 568.691 744.022 563.588C744.022 558.484 748.118 554.354 753.163 554.354C758.207 554.354 762.303 558.484 762.303 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 539.504C748.533 544.608 744.437 548.738 739.392 548.738C734.348 548.738 730.252 544.608 730.252 539.504C730.252 534.401 734.348 530.27 739.392 530.27C744.437 530.27 748.533 534.401 748.533 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 515.417C734.763 520.52 730.666 524.651 725.622 524.651C720.577 524.651 716.481 520.52 716.481 515.417C716.481 510.313 720.577 506.183 725.622 506.183C730.666 506.183 734.763 510.313 734.763 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 491.333C720.991 496.436 716.895 500.567 711.85 500.567C706.806 500.567 702.71 496.436 702.71 491.333C702.71 486.229 706.806 482.099 711.85 482.099C716.895 482.099 720.991 486.229 720.991 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 467.249C707.219 472.352 703.123 476.483 698.079 476.483C693.034 476.483 688.938 472.352 688.938 467.249C688.938 462.145 693.034 458.015 698.079 458.015C703.123 458.015 707.219 462.145 707.219 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 443.162C693.452 448.266 689.356 452.396 684.311 452.396C679.267 452.396 675.171 448.266 675.171 443.162C675.171 438.059 679.267 433.928 684.311 433.928C689.356 433.928 693.452 438.059 693.452 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.68 419.079C679.68 424.182 675.583 428.313 670.539 428.313C665.494 428.313 661.398 424.182 661.398 419.079C661.398 413.975 665.494 409.845 670.539 409.845C675.583 409.845 679.68 413.975 679.68 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 370.908C652.138 376.011 648.042 380.142 642.998 380.142C637.953 380.142 633.857 376.011 633.857 370.908C633.857 365.804 637.953 361.674 642.998 361.674C648.042 361.674 652.138 365.804 652.138 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 322.739C624.597 327.843 620.5 331.973 615.456 331.973C610.411 331.973 606.315 327.843 606.315 322.739C606.315 317.636 610.411 313.505 615.456 313.505C620.5 313.505 624.597 317.636 624.597 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.825 298.653C610.825 303.756 606.729 307.887 601.684 307.887C596.64 307.887 592.544 303.756 592.544 298.653C592.544 293.549 596.64 289.419 601.684 289.419C606.729 289.419 610.825 293.549 610.825 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1382.47C321.639 1387.58 317.543 1391.71 312.499 1391.71C307.454 1391.71 303.358 1387.58 303.358 1382.47C303.358 1377.37 307.454 1373.24 312.499 1373.24C317.543 1373.24 321.639 1377.37 321.639 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1382.47C349.18 1387.58 345.083 1391.71 340.039 1391.71C334.994 1391.71 330.898 1387.58 330.898 1382.47C330.898 1377.37 334.994 1373.24 340.039 1373.24C345.083 1373.24 349.18 1377.37 349.18 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1382.47C376.72 1387.58 372.624 1391.71 367.58 1391.71C362.535 1391.71 358.439 1387.58 358.439 1382.47C358.439 1377.37 362.535 1373.24 367.58 1373.24C372.624 1373.24 376.72 1377.37 376.72 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1382.47C404.262 1387.58 400.166 1391.71 395.122 1391.71C390.077 1391.71 385.981 1387.58 385.981 1382.47C385.981 1377.37 390.077 1373.24 395.122 1373.24C400.166 1373.24 404.262 1377.37 404.262 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.805 1382.47C431.805 1387.58 427.708 1391.71 422.664 1391.71C417.619 1391.71 413.523 1387.58 413.523 1382.47C413.523 1377.37 417.619 1373.24 422.664 1373.24C427.708 1373.24 431.805 1377.37 431.805 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.346 1382.47C459.346 1387.58 455.25 1391.71 450.206 1391.71C445.161 1391.71 441.065 1387.58 441.065 1382.47C441.065 1377.37 445.161 1373.24 450.206 1373.24C455.25 1373.24 459.346 1377.37 459.346 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.971 1382.47C541.971 1387.58 537.874 1391.71 532.83 1391.71C527.785 1391.71 523.689 1387.58 523.689 1382.47C523.689 1377.37 527.785 1373.24 532.83 1373.24C537.874 1373.24 541.971 1377.37 541.971 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 1045.29C789.847 1050.39 785.75 1054.52 780.706 1054.52C775.661 1054.52 771.565 1050.39 771.565 1045.29C771.565 1040.18 775.661 1036.05 780.706 1036.05C785.75 1036.05 789.847 1040.18 789.847 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 1021.2C803.617 1026.3 799.521 1030.43 794.476 1030.43C789.432 1030.43 785.336 1026.3 785.336 1021.2C785.336 1016.1 789.432 1011.97 794.476 1011.97C799.521 1011.97 803.617 1016.1 803.617 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 997.116C817.387 1002.22 813.291 1006.35 808.247 1006.35C803.202 1006.35 799.106 1002.22 799.106 997.116C799.106 992.013 803.202 987.882 808.247 987.882C813.291 987.882 817.387 992.013 817.387 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 973.032C831.158 978.135 827.062 982.266 822.017 982.266C816.973 982.266 812.877 978.135 812.877 973.032C812.877 967.928 816.973 963.798 822.017 963.798C827.062 963.798 831.158 967.928 831.158 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 948.945C844.929 954.049 840.833 958.179 835.789 958.179C830.744 958.179 826.648 954.049 826.648 948.945C826.648 943.842 830.744 939.712 835.789 939.712C840.833 939.712 844.929 943.842 844.929 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 924.861C858.699 929.965 854.603 934.095 849.558 934.095C844.514 934.095 840.418 929.965 840.418 924.861C840.418 919.758 844.514 915.628 849.558 915.628C854.603 915.628 858.699 919.758 858.699 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 900.777C872.471 905.881 868.374 910.011 863.33 910.011C858.285 910.011 854.189 905.881 854.189 900.777C854.189 895.674 858.285 891.543 863.33 891.543C868.374 891.543 872.471 895.674 872.471 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 876.691C886.241 881.794 882.145 885.925 877.1 885.925C872.056 885.925 867.96 881.794 867.96 876.691C867.96 871.587 872.056 867.457 877.1 867.457C882.145 867.457 886.241 871.587 886.241 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 852.606C900.012 857.71 895.916 861.84 890.872 861.84C885.827 861.84 881.731 857.71 881.731 852.606C881.731 847.503 885.827 843.372 890.872 843.372C895.916 843.372 900.012 847.503 900.012 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 828.522C913.783 833.626 909.687 837.756 904.642 837.756C899.598 837.756 895.502 833.626 895.502 828.522C895.502 823.419 899.598 819.288 904.642 819.288C909.687 819.288 913.783 823.419 913.783 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 804.436C927.555 809.54 923.458 813.67 918.414 813.67C913.369 813.67 909.273 809.54 909.273 804.436C909.273 799.333 913.369 795.202 918.414 795.202C923.458 795.202 927.555 799.333 927.555 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 780.352C913.783 785.456 909.687 789.586 904.642 789.586C899.598 789.586 895.502 785.456 895.502 780.352C895.502 775.249 899.598 771.118 904.642 771.118C909.687 771.118 913.783 775.249 913.783 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 756.268C900.012 761.371 895.916 765.502 890.872 765.502C885.827 765.502 881.731 761.371 881.731 756.268C881.731 751.164 885.827 747.034 890.872 747.034C895.916 747.034 900.012 751.164 900.012 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 732.181C886.241 737.285 882.145 741.415 877.1 741.415C872.056 741.415 867.96 737.285 867.96 732.181C867.96 727.078 872.056 722.947 877.1 722.947C882.145 722.947 886.241 727.078 886.241 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 708.097C872.471 713.201 868.374 717.331 863.33 717.331C858.285 717.331 854.189 713.201 854.189 708.097C854.189 702.994 858.285 698.863 863.33 698.863C868.374 698.863 872.471 702.994 872.471 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 684.013C858.699 689.116 854.603 693.247 849.558 693.247C844.514 693.247 840.418 689.116 840.418 684.013C840.418 678.909 844.514 674.779 849.558 674.779C854.603 674.779 858.699 678.909 858.699 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 659.927C844.929 665.03 840.833 669.161 835.789 669.161C830.744 669.161 826.648 665.03 826.648 659.927C826.648 654.823 830.744 650.693 835.789 650.693C840.833 650.693 844.929 654.823 844.929 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 635.842C831.158 640.946 827.062 645.076 822.017 645.076C816.973 645.076 812.877 640.946 812.877 635.842C812.877 630.739 816.973 626.608 822.017 626.608C827.062 626.608 831.158 630.739 831.158 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 611.758C817.387 616.862 813.291 620.992 808.247 620.992C803.202 620.992 799.106 616.862 799.106 611.758C799.106 606.655 803.202 602.525 808.247 602.525C813.291 602.525 817.387 606.655 817.387 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 587.672C803.617 592.775 799.521 596.906 794.476 596.906C789.432 596.906 785.336 592.775 785.336 587.672C785.336 582.568 789.432 578.438 794.476 578.438C799.521 578.438 803.617 582.568 803.617 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 563.588C789.847 568.691 785.75 572.822 780.706 572.822C775.661 572.822 771.565 568.691 771.565 563.588C771.565 558.484 775.661 554.354 780.706 554.354C785.75 554.354 789.847 558.484 789.847 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.076 539.504C776.076 544.608 771.98 548.738 766.935 548.738C761.891 548.738 757.795 544.608 757.795 539.504C757.795 534.401 761.891 530.27 766.935 530.27C771.98 530.27 776.076 534.401 776.076 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 515.417C762.303 520.52 758.207 524.651 753.163 524.651C748.118 524.651 744.022 520.52 744.022 515.417C744.022 510.313 748.118 506.183 753.163 506.183C758.207 506.183 762.303 510.313 762.303 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 491.333C748.533 496.436 744.437 500.567 739.392 500.567C734.348 500.567 730.252 496.436 730.252 491.333C730.252 486.229 734.348 482.099 739.392 482.099C744.437 482.099 748.533 486.229 748.533 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 467.249C734.763 472.352 730.666 476.483 725.622 476.483C720.577 476.483 716.481 472.352 716.481 467.249C716.481 462.145 720.577 458.015 725.622 458.015C730.666 458.015 734.763 462.145 734.763 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 443.162C720.991 448.266 716.895 452.396 711.85 452.396C706.806 452.396 702.71 448.266 702.71 443.162C702.71 438.059 706.806 433.928 711.85 433.928C716.895 433.928 720.991 438.059 720.991 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.219 419.079C707.219 424.182 703.123 428.313 698.079 428.313C693.034 428.313 688.938 424.182 688.938 419.079C688.938 413.975 693.034 409.845 698.079 409.845C703.123 409.845 707.219 413.975 707.219 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 394.994C693.452 400.098 689.356 404.228 684.311 404.228C679.267 404.228 675.171 400.098 675.171 394.994C675.171 389.891 679.267 385.76 684.311 385.76C689.356 385.76 693.452 389.891 693.452 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.597 274.569C624.597 279.672 620.5 283.803 615.456 283.803C610.411 283.803 606.315 279.672 606.315 274.569C606.315 269.466 610.411 265.335 615.456 265.335C620.5 265.335 624.597 269.466 624.597 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 1406.56C307.868 1411.66 303.772 1415.79 298.727 1415.79C293.683 1415.79 289.587 1411.66 289.587 1406.56C289.587 1401.45 293.683 1397.32 298.727 1397.32C303.772 1397.32 307.868 1401.45 307.868 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1406.56C335.409 1411.66 331.313 1415.79 326.268 1415.79C321.224 1415.79 317.128 1411.66 317.128 1406.56C317.128 1401.45 321.224 1397.32 326.268 1397.32C331.313 1397.32 335.409 1401.45 335.409 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1406.56C362.951 1411.66 358.855 1415.79 353.81 1415.79C348.766 1415.79 344.67 1411.66 344.67 1406.56C344.67 1401.45 348.766 1397.32 353.81 1397.32C358.855 1397.32 362.951 1401.45 362.951 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1406.56C390.493 1411.66 386.397 1415.79 381.352 1415.79C376.308 1415.79 372.212 1411.66 372.212 1406.56C372.212 1401.45 376.308 1397.32 381.352 1397.32C386.397 1397.32 390.493 1401.45 390.493 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.034 1406.56C418.034 1411.66 413.938 1415.79 408.893 1415.79C403.849 1415.79 399.753 1411.66 399.753 1406.56C399.753 1401.45 403.849 1397.32 408.893 1397.32C413.938 1397.32 418.034 1401.45 418.034 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.345 1406.56C437.345 1407.07 436.934 1407.48 436.435 1407.48C435.937 1407.48 435.526 1407.07 435.526 1406.56C435.526 1406.05 435.937 1405.64 436.435 1405.64C436.934 1405.64 437.345 1406.05 437.345 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 1069.37C803.617 1074.47 799.521 1078.6 794.476 1078.6C789.432 1078.6 785.336 1074.47 785.336 1069.37C785.336 1064.27 789.432 1060.14 794.476 1060.14C799.521 1060.14 803.617 1064.27 803.617 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 1045.29C817.387 1050.39 813.291 1054.52 808.247 1054.52C803.202 1054.52 799.106 1050.39 799.106 1045.29C799.106 1040.18 803.202 1036.05 808.247 1036.05C813.291 1036.05 817.387 1040.18 817.387 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 1021.2C831.158 1026.3 827.062 1030.43 822.017 1030.43C816.973 1030.43 812.877 1026.3 812.877 1021.2C812.877 1016.1 816.973 1011.97 822.017 1011.97C827.062 1011.97 831.158 1016.1 831.158 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 997.116C844.929 1002.22 840.833 1006.35 835.789 1006.35C830.744 1006.35 826.648 1002.22 826.648 997.116C826.648 992.013 830.744 987.882 835.789 987.882C840.833 987.882 844.929 992.013 844.929 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 973.032C858.699 978.135 854.603 982.266 849.558 982.266C844.514 982.266 840.418 978.135 840.418 973.032C840.418 967.928 844.514 963.798 849.558 963.798C854.603 963.798 858.699 967.928 858.699 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 948.945C872.471 954.049 868.374 958.179 863.33 958.179C858.285 958.179 854.189 954.049 854.189 948.945C854.189 943.842 858.285 939.712 863.33 939.712C868.374 939.712 872.471 943.842 872.471 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 924.861C886.241 929.965 882.145 934.095 877.1 934.095C872.056 934.095 867.96 929.965 867.96 924.861C867.96 919.758 872.056 915.628 877.1 915.628C882.145 915.628 886.241 919.758 886.241 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 900.777C900.012 905.881 895.916 910.011 890.872 910.011C885.827 910.011 881.731 905.881 881.731 900.777C881.731 895.674 885.827 891.543 890.872 891.543C895.916 891.543 900.012 895.674 900.012 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 876.691C913.783 881.794 909.687 885.925 904.642 885.925C899.598 885.925 895.502 881.794 895.502 876.691C895.502 871.587 899.598 867.457 904.642 867.457C909.687 867.457 913.783 871.587 913.783 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 852.606C927.555 857.71 923.458 861.84 918.414 861.84C913.369 861.84 909.273 857.71 909.273 852.606C909.273 847.503 913.369 843.372 918.414 843.372C923.458 843.372 927.555 847.503 927.555 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 828.522C941.324 833.626 937.228 837.756 932.183 837.756C927.139 837.756 923.043 833.626 923.043 828.522C923.043 823.419 927.139 819.288 932.183 819.288C937.228 819.288 941.324 823.419 941.324 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 804.436C955.095 809.54 950.999 813.67 945.955 813.67C940.91 813.67 936.814 809.54 936.814 804.436C936.814 799.333 940.91 795.202 945.955 795.202C950.999 795.202 955.095 799.333 955.095 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 780.352C941.324 785.456 937.228 789.586 932.183 789.586C927.139 789.586 923.043 785.456 923.043 780.352C923.043 775.249 927.139 771.118 932.183 771.118C937.228 771.118 941.324 775.249 941.324 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 756.268C927.555 761.371 923.458 765.502 918.414 765.502C913.369 765.502 909.273 761.371 909.273 756.268C909.273 751.164 913.369 747.034 918.414 747.034C923.458 747.034 927.555 751.164 927.555 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 732.181C913.783 737.285 909.687 741.415 904.642 741.415C899.598 741.415 895.502 737.285 895.502 732.181C895.502 727.078 899.598 722.947 904.642 722.947C909.687 722.947 913.783 727.078 913.783 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 708.097C900.012 713.201 895.916 717.331 890.872 717.331C885.827 717.331 881.731 713.201 881.731 708.097C881.731 702.994 885.827 698.863 890.872 698.863C895.916 698.863 900.012 702.994 900.012 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 684.013C886.241 689.116 882.145 693.247 877.1 693.247C872.056 693.247 867.96 689.116 867.96 684.013C867.96 678.909 872.056 674.779 877.1 674.779C882.145 674.779 886.241 678.909 886.241 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 659.927C872.471 665.03 868.374 669.161 863.33 669.161C858.285 669.161 854.189 665.03 854.189 659.927C854.189 654.823 858.285 650.693 863.33 650.693C868.374 650.693 872.471 654.823 872.471 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 635.842C858.699 640.946 854.603 645.076 849.558 645.076C844.514 645.076 840.418 640.946 840.418 635.842C840.418 630.739 844.514 626.608 849.558 626.608C854.603 626.608 858.699 630.739 858.699 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 611.758C844.929 616.862 840.833 620.992 835.789 620.992C830.744 620.992 826.648 616.862 826.648 611.758C826.648 606.655 830.744 602.525 835.789 602.525C840.833 602.525 844.929 606.655 844.929 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 587.672C831.158 592.775 827.062 596.906 822.017 596.906C816.973 596.906 812.877 592.775 812.877 587.672C812.877 582.568 816.973 578.438 822.017 578.438C827.062 578.438 831.158 582.568 831.158 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 563.588C817.387 568.691 813.291 572.822 808.247 572.822C803.202 572.822 799.106 568.691 799.106 563.588C799.106 558.484 803.202 554.354 808.247 554.354C813.291 554.354 817.387 558.484 817.387 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 539.504C803.617 544.608 799.521 548.738 794.476 548.738C789.432 548.738 785.336 544.608 785.336 539.504C785.336 534.401 789.432 530.27 794.476 530.27C799.521 530.27 803.617 534.401 803.617 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 515.417C789.847 520.52 785.75 524.651 780.706 524.651C775.661 524.651 771.565 520.52 771.565 515.417C771.565 510.313 775.661 506.183 780.706 506.183C785.75 506.183 789.847 510.313 789.847 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 491.333C776.075 496.436 771.979 500.567 766.934 500.567C761.89 500.567 757.794 496.436 757.794 491.333C757.794 486.229 761.89 482.099 766.934 482.099C771.979 482.099 776.075 486.229 776.075 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 467.249C762.303 472.352 758.207 476.483 753.163 476.483C748.118 476.483 744.022 472.352 744.022 467.249C744.022 462.145 748.118 458.015 753.163 458.015C758.207 458.015 762.303 462.145 762.303 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 443.162C748.533 448.266 744.437 452.396 739.392 452.396C734.348 452.396 730.252 448.266 730.252 443.162C730.252 438.059 734.348 433.928 739.392 433.928C744.437 433.928 748.533 438.059 748.533 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 419.079C734.763 424.182 730.666 428.313 725.622 428.313C720.577 428.313 716.481 424.182 716.481 419.079C716.481 413.975 720.577 409.845 725.622 409.845C730.666 409.845 734.763 413.975 734.763 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 250.485C638.368 255.588 634.272 259.719 629.227 259.719C624.183 259.719 620.087 255.588 620.087 250.485C620.087 245.381 624.183 241.251 629.227 241.251C634.272 241.251 638.368 245.381 638.368 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 1430.64C321.639 1435.75 317.543 1439.88 312.499 1439.88C307.454 1439.88 303.358 1435.75 303.358 1430.64C303.358 1425.54 307.454 1421.41 312.499 1421.41C317.543 1421.41 321.639 1425.54 321.639 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 1430.64C349.18 1435.75 345.083 1439.88 340.039 1439.88C334.994 1439.88 330.898 1435.75 330.898 1430.64C330.898 1425.54 334.994 1421.41 340.039 1421.41C345.083 1421.41 349.18 1425.54 349.18 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72 1430.64C376.72 1435.75 372.624 1439.88 367.58 1439.88C362.535 1439.88 358.439 1435.75 358.439 1430.64C358.439 1425.54 362.535 1421.41 367.58 1421.41C372.624 1421.41 376.72 1425.54 376.72 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 1430.64C404.262 1435.75 400.166 1439.88 395.122 1439.88C390.077 1439.88 385.981 1435.75 385.981 1430.64C385.981 1425.54 390.077 1421.41 395.122 1421.41C400.166 1421.41 404.262 1425.54 404.262 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.386 1093.46C817.386 1098.56 813.29 1102.69 808.246 1102.69C803.201 1102.69 799.105 1098.56 799.105 1093.46C799.105 1088.35 803.201 1084.22 808.246 1084.22C813.29 1084.22 817.386 1088.35 817.386 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 1021.2C858.699 1026.3 854.603 1030.43 849.558 1030.43C844.514 1030.43 840.418 1026.3 840.418 1021.2C840.418 1016.1 844.514 1011.97 849.558 1011.97C854.603 1011.97 858.699 1016.1 858.699 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 997.116C872.471 1002.22 868.374 1006.35 863.33 1006.35C858.285 1006.35 854.189 1002.22 854.189 997.116C854.189 992.013 858.285 987.882 863.33 987.882C868.374 987.882 872.471 992.013 872.471 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 973.032C886.241 978.135 882.145 982.266 877.1 982.266C872.056 982.266 867.96 978.135 867.96 973.032C867.96 967.928 872.056 963.798 877.1 963.798C882.145 963.798 886.241 967.928 886.241 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 948.945C900.012 954.049 895.916 958.179 890.872 958.179C885.827 958.179 881.731 954.049 881.731 948.945C881.731 943.842 885.827 939.712 890.872 939.712C895.916 939.712 900.012 943.842 900.012 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 924.861C913.783 929.965 909.687 934.095 904.642 934.095C899.598 934.095 895.502 929.965 895.502 924.861C895.502 919.758 899.598 915.628 904.642 915.628C909.687 915.628 913.783 919.758 913.783 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 900.777C927.555 905.881 923.458 910.011 918.414 910.011C913.369 910.011 909.273 905.881 909.273 900.777C909.273 895.674 913.369 891.543 918.414 891.543C923.458 891.543 927.555 895.674 927.555 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 876.691C941.324 881.794 937.228 885.925 932.183 885.925C927.139 885.925 923.043 881.794 923.043 876.691C923.043 871.587 927.139 867.457 932.183 867.457C937.228 867.457 941.324 871.587 941.324 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 852.606C955.095 857.71 950.999 861.84 945.955 861.84C940.91 861.84 936.814 857.71 936.814 852.606C936.814 847.503 940.91 843.372 945.955 843.372C950.999 843.372 955.095 847.503 955.095 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 828.522C968.866 833.626 964.77 837.756 959.725 837.756C954.681 837.756 950.585 833.626 950.585 828.522C950.585 823.419 954.681 819.288 959.725 819.288C964.77 819.288 968.866 823.419 968.866 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 804.436C982.636 809.54 978.54 813.67 973.495 813.67C968.45 813.67 964.354 809.54 964.354 804.436C964.354 799.333 968.45 795.202 973.495 795.202C978.54 795.202 982.636 799.333 982.636 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 780.352C968.866 785.456 964.77 789.586 959.725 789.586C954.681 789.586 950.585 785.456 950.585 780.352C950.585 775.249 954.681 771.118 959.725 771.118C964.77 771.118 968.866 775.249 968.866 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 756.268C955.095 761.371 950.999 765.502 945.955 765.502C940.91 765.502 936.814 761.371 936.814 756.268C936.814 751.164 940.91 747.034 945.955 747.034C950.999 747.034 955.095 751.164 955.095 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 732.181C941.324 737.285 937.228 741.415 932.183 741.415C927.139 741.415 923.043 737.285 923.043 732.181C923.043 727.078 927.139 722.947 932.183 722.947C937.228 722.947 941.324 727.078 941.324 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 708.097C927.555 713.201 923.458 717.331 918.414 717.331C913.369 717.331 909.273 713.201 909.273 708.097C909.273 702.994 913.369 698.863 918.414 698.863C923.458 698.863 927.555 702.994 927.555 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 684.013C913.783 689.116 909.687 693.247 904.642 693.247C899.598 693.247 895.502 689.116 895.502 684.013C895.502 678.909 899.598 674.779 904.642 674.779C909.687 674.779 913.783 678.909 913.783 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 659.927C900.012 665.03 895.916 669.161 890.872 669.161C885.827 669.161 881.731 665.03 881.731 659.927C881.731 654.823 885.827 650.693 890.872 650.693C895.916 650.693 900.012 654.823 900.012 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 635.842C886.241 640.946 882.145 645.076 877.1 645.076C872.056 645.076 867.96 640.946 867.96 635.842C867.96 630.739 872.056 626.608 877.1 626.608C882.145 626.608 886.241 630.739 886.241 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 611.758C872.471 616.862 868.374 620.992 863.33 620.992C858.285 620.992 854.189 616.862 854.189 611.758C854.189 606.655 858.285 602.525 863.33 602.525C868.374 602.525 872.471 606.655 872.471 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 587.672C858.699 592.775 854.603 596.906 849.558 596.906C844.514 596.906 840.418 592.775 840.418 587.672C840.418 582.568 844.514 578.438 849.558 578.438C854.603 578.438 858.699 582.568 858.699 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 563.588C844.929 568.691 840.833 572.822 835.789 572.822C830.744 572.822 826.648 568.691 826.648 563.588C826.648 558.484 830.744 554.354 835.789 554.354C840.833 554.354 844.929 558.484 844.929 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 539.504C831.158 544.608 827.062 548.738 822.017 548.738C816.973 548.738 812.877 544.608 812.877 539.504C812.877 534.401 816.973 530.27 822.017 530.27C827.062 530.27 831.158 534.401 831.158 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 515.417C817.387 520.52 813.291 524.651 808.247 524.651C803.202 524.651 799.106 520.52 799.106 515.417C799.106 510.313 803.202 506.183 808.247 506.183C813.291 506.183 817.387 510.313 817.387 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 491.333C803.617 496.436 799.521 500.567 794.476 500.567C789.432 500.567 785.336 496.436 785.336 491.333C785.336 486.229 789.432 482.099 794.476 482.099C799.521 482.099 803.617 486.229 803.617 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 467.249C789.847 472.352 785.75 476.483 780.706 476.483C775.661 476.483 771.565 472.352 771.565 467.249C771.565 462.145 775.661 458.015 780.706 458.015C785.75 458.015 789.847 462.145 789.847 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 443.162C776.075 448.265 771.979 452.396 766.934 452.396C761.89 452.396 757.794 448.266 757.794 443.162C757.794 438.059 761.89 433.928 766.934 433.928C771.979 433.928 776.075 438.059 776.075 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 419.079C762.303 424.182 758.207 428.313 753.163 428.313C748.118 428.313 744.022 424.182 744.022 419.079C744.022 413.975 748.118 409.845 753.163 409.845C758.207 409.845 762.303 413.975 762.303 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 394.994C748.533 400.098 744.437 404.228 739.392 404.228C734.348 404.228 730.252 400.098 730.252 394.994C730.252 389.891 734.348 385.76 739.392 385.76C744.437 385.76 748.533 389.891 748.533 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 370.908C734.763 376.011 730.666 380.142 725.622 380.142C720.577 380.142 716.481 376.011 716.481 370.908C716.481 365.804 720.577 361.674 725.622 361.674C730.666 361.674 734.763 365.804 734.763 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.991 346.823C720.991 351.927 716.895 356.057 711.85 356.057C706.806 356.057 702.71 351.927 702.71 346.823C702.71 341.72 706.806 337.589 711.85 337.589C716.895 337.589 720.991 341.72 720.991 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.138 226.398C652.138 231.502 648.042 235.632 642.998 235.632C637.953 235.632 633.857 231.502 633.857 226.398C633.857 221.295 637.953 217.164 642.998 217.164C648.042 217.164 652.138 221.295 652.138 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 1454.73C335.409 1459.83 331.313 1463.96 326.268 1463.96C321.224 1463.96 317.128 1459.83 317.128 1454.73C317.128 1449.63 321.224 1445.5 326.268 1445.5C331.313 1445.5 335.409 1449.63 335.409 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 1454.73C362.951 1459.83 358.855 1463.96 353.81 1463.96C348.766 1463.96 344.67 1459.83 344.67 1454.73C344.67 1449.63 348.766 1445.5 353.81 1445.5C358.855 1445.5 362.951 1449.63 362.951 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 1454.73C390.493 1459.83 386.397 1463.96 381.352 1463.96C376.308 1463.96 372.212 1459.83 372.212 1454.73C372.212 1449.63 376.308 1445.5 381.352 1445.5C386.397 1445.5 390.493 1449.63 390.493 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 1117.54C831.158 1122.64 827.062 1126.78 822.017 1126.78C816.973 1126.78 812.877 1122.64 812.877 1117.54C812.877 1112.44 816.973 1108.31 822.017 1108.31C827.062 1108.31 831.158 1112.44 831.158 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.514 997.116C898.514 1001.38 895.088 1004.84 890.87 1004.84C886.652 1004.84 883.226 1001.38 883.226 997.116C883.226 992.847 886.652 989.393 890.87 989.393C895.088 989.393 898.514 992.847 898.514 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 973.032C913.783 978.135 909.687 982.266 904.642 982.266C899.598 982.266 895.502 978.135 895.502 973.032C895.502 967.928 899.598 963.798 904.642 963.798C909.687 963.798 913.783 967.928 913.783 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 948.945C927.555 954.049 923.458 958.179 918.414 958.179C913.369 958.179 909.273 954.049 909.273 948.945C909.273 943.842 913.369 939.712 918.414 939.712C923.458 939.712 927.555 943.842 927.555 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 924.861C941.324 929.965 937.228 934.095 932.183 934.095C927.139 934.095 923.043 929.965 923.043 924.861C923.043 919.758 927.139 915.628 932.183 915.628C937.228 915.628 941.324 919.758 941.324 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 900.777C955.095 905.881 950.999 910.011 945.955 910.011C940.91 910.011 936.814 905.881 936.814 900.777C936.814 895.674 940.91 891.543 945.955 891.543C950.999 891.543 955.095 895.674 955.095 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 876.691C968.866 881.794 964.77 885.925 959.725 885.925C954.681 885.925 950.585 881.794 950.585 876.691C950.585 871.587 954.681 867.457 959.725 867.457C964.77 867.457 968.866 871.587 968.866 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 852.606C982.636 857.71 978.54 861.84 973.495 861.84C968.45 861.84 964.354 857.71 964.354 852.606C964.354 847.503 968.45 843.372 973.495 843.372C978.54 843.372 982.636 847.503 982.636 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 828.522C996.408 833.626 992.312 837.756 987.267 837.756C982.223 837.756 978.127 833.626 978.127 828.522C978.127 823.419 982.223 819.288 987.267 819.288C992.312 819.288 996.408 823.419 996.408 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 804.436C1010.18 809.54 1006.08 813.67 1001.04 813.67C995.992 813.67 991.896 809.54 991.896 804.436C991.896 799.333 995.992 795.202 1001.04 795.202C1006.08 795.202 1010.18 799.333 1010.18 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 780.352C996.408 785.456 992.312 789.586 987.267 789.586C982.223 789.586 978.127 785.456 978.127 780.352C978.127 775.249 982.223 771.118 987.267 771.118C992.312 771.118 996.408 775.249 996.408 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 756.268C982.636 761.371 978.54 765.502 973.495 765.502C968.45 765.502 964.354 761.371 964.354 756.268C964.354 751.164 968.45 747.034 973.495 747.034C978.54 747.034 982.636 751.164 982.636 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 732.181C968.866 737.285 964.77 741.415 959.725 741.415C954.681 741.415 950.585 737.285 950.585 732.181C950.585 727.078 954.681 722.947 959.725 722.947C964.77 722.947 968.866 727.078 968.866 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 708.097C955.095 713.201 950.999 717.331 945.955 717.331C940.91 717.331 936.814 713.201 936.814 708.097C936.814 702.994 940.91 698.863 945.955 698.863C950.999 698.863 955.095 702.994 955.095 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 684.013C941.324 689.116 937.228 693.247 932.183 693.247C927.139 693.247 923.043 689.116 923.043 684.013C923.043 678.909 927.139 674.779 932.183 674.779C937.228 674.779 941.324 678.909 941.324 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 659.927C927.555 665.03 923.458 669.161 918.414 669.161C913.369 669.161 909.273 665.03 909.273 659.927C909.273 654.823 913.369 650.693 918.414 650.693C923.458 650.693 927.555 654.823 927.555 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 635.842C913.783 640.946 909.687 645.076 904.642 645.076C899.598 645.076 895.502 640.946 895.502 635.842C895.502 630.739 899.598 626.608 904.642 626.608C909.687 626.608 913.783 630.739 913.783 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 611.758C900.012 616.862 895.916 620.992 890.872 620.992C885.827 620.992 881.731 616.862 881.731 611.758C881.731 606.655 885.827 602.525 890.872 602.525C895.916 602.525 900.012 606.655 900.012 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 587.672C886.241 592.775 882.145 596.906 877.1 596.906C872.056 596.906 867.96 592.775 867.96 587.672C867.96 582.568 872.056 578.438 877.1 578.438C882.145 578.438 886.241 582.568 886.241 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 563.588C872.471 568.691 868.374 572.822 863.33 572.822C858.285 572.822 854.189 568.691 854.189 563.588C854.189 558.484 858.285 554.354 863.33 554.354C868.374 554.354 872.471 558.484 872.471 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 539.504C858.699 544.608 854.603 548.738 849.558 548.738C844.514 548.738 840.418 544.608 840.418 539.504C840.418 534.401 844.514 530.27 849.558 530.27C854.603 530.27 858.699 534.401 858.699 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 515.417C844.929 520.52 840.833 524.651 835.789 524.651C830.744 524.651 826.648 520.52 826.648 515.417C826.648 510.313 830.744 506.183 835.789 506.183C840.833 506.183 844.929 510.313 844.929 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 491.333C831.158 496.436 827.062 500.567 822.017 500.567C816.973 500.567 812.877 496.436 812.877 491.333C812.877 486.229 816.973 482.099 822.017 482.099C827.062 482.099 831.158 486.229 831.158 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 467.249C817.387 472.352 813.291 476.483 808.247 476.483C803.202 476.483 799.106 472.352 799.106 467.249C799.106 462.145 803.202 458.015 808.247 458.015C813.291 458.015 817.387 462.145 817.387 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 443.162C803.617 448.266 799.521 452.396 794.476 452.396C789.432 452.396 785.336 448.266 785.336 443.162C785.336 438.059 789.432 433.928 794.476 433.928C799.521 433.928 803.617 438.059 803.617 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 419.079C789.847 424.182 785.75 428.313 780.706 428.313C775.661 428.313 771.565 424.182 771.565 419.079C771.565 413.975 775.661 409.845 780.706 409.845C785.75 409.845 789.847 413.975 789.847 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 394.994C776.075 400.098 771.979 404.228 766.934 404.228C761.89 404.228 757.794 400.098 757.794 394.994C757.794 389.891 761.89 385.76 766.934 385.76C771.979 385.76 776.075 389.891 776.075 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 370.908C762.303 376.011 758.207 380.142 753.163 380.142C748.118 380.142 744.022 376.011 744.022 370.908C744.022 365.804 748.118 361.674 753.163 361.674C758.207 361.674 762.303 365.804 762.303 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.533 346.823C748.533 351.927 744.437 356.057 739.392 356.057C734.348 356.057 730.252 351.927 730.252 346.823C730.252 341.72 734.348 337.589 739.392 337.589C744.437 337.589 748.533 341.72 748.533 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.763 322.739C734.763 327.843 730.666 331.973 725.622 331.973C720.577 331.973 716.481 327.843 716.481 322.739C716.481 317.636 720.577 313.505 725.622 313.505C730.666 313.505 734.763 317.636 734.763 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 154.143C307.868 159.247 303.772 163.377 298.727 163.377C293.683 163.377 289.587 159.247 289.587 154.143C289.587 149.04 293.683 144.909 298.727 144.909C303.772 144.909 307.868 149.04 307.868 154.143Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 997.116C927.555 1002.22 923.458 1006.35 918.414 1006.35C913.369 1006.35 909.273 1002.22 909.273 997.116C909.273 992.013 913.369 987.882 918.414 987.882C923.458 987.882 927.555 992.013 927.555 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 973.032C941.324 978.135 937.228 982.266 932.183 982.266C927.139 982.266 923.043 978.135 923.043 973.032C923.043 967.928 927.139 963.798 932.183 963.798C937.228 963.798 941.324 967.928 941.324 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 948.945C955.095 954.049 950.999 958.179 945.955 958.179C940.91 958.179 936.814 954.049 936.814 948.945C936.814 943.842 940.91 939.712 945.955 939.712C950.999 939.712 955.095 943.842 955.095 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 924.861C968.866 929.965 964.77 934.095 959.725 934.095C954.681 934.095 950.585 929.965 950.585 924.861C950.585 919.758 954.681 915.628 959.725 915.628C964.77 915.628 968.866 919.758 968.866 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 900.777C982.636 905.881 978.54 910.011 973.495 910.011C968.45 910.011 964.354 905.881 964.354 900.777C964.354 895.674 968.45 891.543 973.495 891.543C978.54 891.543 982.636 895.674 982.636 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 876.691C996.408 881.794 992.312 885.925 987.267 885.925C982.223 885.925 978.127 881.794 978.127 876.691C978.127 871.587 982.223 867.457 987.267 867.457C992.312 867.457 996.408 871.587 996.408 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 852.606C1010.18 857.71 1006.08 861.84 1001.04 861.84C995.992 861.84 991.896 857.71 991.896 852.606C991.896 847.503 995.992 843.372 1001.04 843.372C1006.08 843.372 1010.18 847.503 1010.18 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 828.522C1023.95 833.626 1019.85 837.756 1014.81 837.756C1009.76 837.756 1005.67 833.626 1005.67 828.522C1005.67 823.419 1009.76 819.288 1014.81 819.288C1019.85 819.288 1023.95 823.419 1023.95 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 804.436C1037.72 809.54 1033.62 813.67 1028.58 813.67C1023.53 813.67 1019.44 809.54 1019.44 804.436C1019.44 799.333 1023.53 795.202 1028.58 795.202C1033.62 795.202 1037.72 799.333 1037.72 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 780.352C1023.95 785.456 1019.85 789.586 1014.81 789.586C1009.76 789.586 1005.67 785.456 1005.67 780.352C1005.67 775.249 1009.76 771.118 1014.81 771.118C1019.85 771.118 1023.95 775.249 1023.95 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 756.268C1010.18 761.371 1006.08 765.502 1001.04 765.502C995.992 765.502 991.896 761.371 991.896 756.268C991.896 751.164 995.992 747.034 1001.04 747.034C1006.08 747.034 1010.18 751.164 1010.18 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 732.181C996.408 737.285 992.312 741.415 987.267 741.415C982.223 741.415 978.127 737.285 978.127 732.181C978.127 727.078 982.223 722.947 987.267 722.947C992.312 722.947 996.408 727.078 996.408 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 708.097C982.636 713.201 978.54 717.331 973.495 717.331C968.45 717.331 964.354 713.201 964.354 708.097C964.354 702.994 968.45 698.863 973.495 698.863C978.54 698.863 982.636 702.994 982.636 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 684.013C968.866 689.116 964.77 693.247 959.725 693.247C954.681 693.247 950.585 689.116 950.585 684.013C950.585 678.909 954.681 674.779 959.725 674.779C964.77 674.779 968.866 678.909 968.866 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 659.927C955.095 665.03 950.999 669.161 945.955 669.161C940.91 669.161 936.814 665.03 936.814 659.927C936.814 654.823 940.91 650.693 945.955 650.693C950.999 650.693 955.095 654.823 955.095 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 635.842C941.324 640.946 937.228 645.076 932.183 645.076C927.139 645.076 923.043 640.946 923.043 635.842C923.043 630.739 927.139 626.608 932.183 626.608C937.228 626.608 941.324 630.739 941.324 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 611.758C927.555 616.862 923.458 620.992 918.414 620.992C913.369 620.992 909.273 616.862 909.273 611.758C909.273 606.655 913.369 602.525 918.414 602.525C923.458 602.525 927.555 606.655 927.555 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 587.672C913.783 592.775 909.687 596.906 904.642 596.906C899.598 596.906 895.502 592.775 895.502 587.672C895.502 582.568 899.598 578.438 904.642 578.438C909.687 578.438 913.783 582.568 913.783 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 563.588C900.012 568.691 895.916 572.822 890.872 572.822C885.827 572.822 881.731 568.691 881.731 563.588C881.731 558.484 885.827 554.354 890.872 554.354C895.916 554.354 900.012 558.484 900.012 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 539.504C886.241 544.608 882.145 548.738 877.1 548.738C872.056 548.738 867.96 544.608 867.96 539.504C867.96 534.401 872.056 530.27 877.1 530.27C882.145 530.27 886.241 534.401 886.241 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 515.417C872.471 520.52 868.374 524.651 863.33 524.651C858.285 524.651 854.189 520.52 854.189 515.417C854.189 510.313 858.285 506.183 863.33 506.183C868.374 506.183 872.471 510.313 872.471 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 491.333C858.699 496.436 854.603 500.567 849.558 500.567C844.514 500.567 840.418 496.436 840.418 491.333C840.418 486.229 844.514 482.099 849.558 482.099C854.603 482.099 858.699 486.229 858.699 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 467.249C844.929 472.352 840.833 476.483 835.789 476.483C830.744 476.483 826.648 472.352 826.648 467.249C826.648 462.145 830.744 458.015 835.789 458.015C840.833 458.015 844.929 462.145 844.929 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 443.162C831.158 448.266 827.062 452.396 822.017 452.396C816.973 452.396 812.877 448.265 812.877 443.162C812.877 438.059 816.973 433.928 822.017 433.928C827.062 433.928 831.158 438.059 831.158 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 419.079C817.387 424.182 813.291 428.313 808.247 428.313C803.202 428.313 799.106 424.182 799.106 419.079C799.106 413.975 803.202 409.845 808.247 409.845C813.291 409.845 817.387 413.975 817.387 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.617 394.994C803.617 400.098 799.521 404.228 794.476 404.228C789.432 404.228 785.336 400.098 785.336 394.994C785.336 389.891 789.432 385.76 794.476 385.76C799.521 385.76 803.617 389.891 803.617 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.847 370.908C789.847 376.011 785.75 380.142 780.706 380.142C775.661 380.142 771.565 376.011 771.565 370.908C771.565 365.804 775.661 361.674 780.706 361.674C785.75 361.674 789.847 365.804 789.847 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.075 346.823C776.075 351.927 771.979 356.057 766.934 356.057C761.89 356.057 757.794 351.927 757.794 346.823C757.794 341.72 761.89 337.589 766.934 337.589C771.979 337.589 776.075 341.72 776.075 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.303 322.739C762.303 327.843 758.207 331.973 753.163 331.973C748.118 331.973 744.022 327.843 744.022 322.739C744.022 317.636 748.118 313.505 753.163 313.505C758.207 313.505 762.303 317.636 762.303 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 202.314C693.452 207.417 689.356 211.548 684.311 211.548C679.267 211.548 675.171 207.417 675.171 202.314C675.171 197.21 679.267 193.08 684.311 193.08C689.356 193.08 693.452 197.21 693.452 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 130.06C321.639 135.163 317.543 139.293 312.499 139.293C307.454 139.293 303.358 135.163 303.358 130.06C303.358 124.956 307.454 120.826 312.499 120.826C317.543 120.826 321.639 124.956 321.639 130.06Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 1021.2C941.324 1026.3 937.228 1030.43 932.183 1030.43C927.139 1030.43 923.043 1026.3 923.043 1021.2C923.043 1016.1 927.139 1011.97 932.183 1011.97C937.228 1011.97 941.324 1016.1 941.324 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 997.116C955.095 1002.22 950.999 1006.35 945.955 1006.35C940.91 1006.35 936.814 1002.22 936.814 997.116C936.814 992.013 940.91 987.882 945.955 987.882C950.999 987.882 955.095 992.013 955.095 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 973.032C968.866 978.135 964.77 982.266 959.725 982.266C954.681 982.266 950.585 978.135 950.585 973.032C950.585 967.928 954.681 963.798 959.725 963.798C964.77 963.798 968.866 967.928 968.866 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 948.945C982.636 954.049 978.54 958.179 973.495 958.179C968.45 958.179 964.354 954.049 964.354 948.945C964.354 943.842 968.45 939.712 973.495 939.712C978.54 939.712 982.636 943.842 982.636 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 924.861C996.408 929.965 992.312 934.095 987.267 934.095C982.223 934.095 978.127 929.965 978.127 924.861C978.127 919.758 982.223 915.628 987.267 915.628C992.312 915.628 996.408 919.758 996.408 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 900.777C1010.18 905.881 1006.08 910.011 1001.04 910.011C995.992 910.011 991.896 905.881 991.896 900.777C991.896 895.674 995.992 891.543 1001.04 891.543C1006.08 891.543 1010.18 895.674 1010.18 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 876.691C1023.95 881.794 1019.85 885.925 1014.81 885.925C1009.76 885.925 1005.67 881.794 1005.67 876.691C1005.67 871.587 1009.76 867.457 1014.81 867.457C1019.85 867.457 1023.95 871.587 1023.95 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 852.606C1037.72 857.71 1033.62 861.84 1028.58 861.84C1023.53 861.84 1019.44 857.71 1019.44 852.606C1019.44 847.503 1023.53 843.372 1028.58 843.372C1033.62 843.372 1037.72 847.503 1037.72 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 828.522C1051.49 833.626 1047.39 837.756 1042.35 837.756C1037.31 837.756 1033.21 833.626 1033.21 828.522C1033.21 823.419 1037.31 819.288 1042.35 819.288C1047.39 819.288 1051.49 823.419 1051.49 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 804.436C1065.26 809.54 1061.17 813.67 1056.12 813.67C1051.08 813.67 1046.98 809.54 1046.98 804.436C1046.98 799.333 1051.08 795.202 1056.12 795.202C1061.17 795.202 1065.26 799.333 1065.26 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 780.352C1051.49 785.456 1047.39 789.586 1042.35 789.586C1037.31 789.586 1033.21 785.456 1033.21 780.352C1033.21 775.249 1037.31 771.118 1042.35 771.118C1047.39 771.118 1051.49 775.249 1051.49 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 756.268C1037.72 761.371 1033.62 765.502 1028.58 765.502C1023.53 765.502 1019.44 761.371 1019.44 756.268C1019.44 751.164 1023.53 747.034 1028.58 747.034C1033.62 747.034 1037.72 751.164 1037.72 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 732.181C1023.95 737.285 1019.85 741.415 1014.81 741.415C1009.76 741.415 1005.67 737.285 1005.67 732.181C1005.67 727.078 1009.76 722.947 1014.81 722.947C1019.85 722.947 1023.95 727.078 1023.95 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 708.097C1010.18 713.201 1006.08 717.331 1001.04 717.331C995.992 717.331 991.896 713.201 991.896 708.097C991.896 702.994 995.992 698.863 1001.04 698.863C1006.08 698.863 1010.18 702.994 1010.18 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 684.013C996.408 689.116 992.312 693.247 987.267 693.247C982.223 693.247 978.127 689.116 978.127 684.013C978.127 678.909 982.223 674.779 987.267 674.779C992.312 674.779 996.408 678.909 996.408 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 659.927C982.636 665.03 978.54 669.161 973.495 669.161C968.45 669.161 964.354 665.03 964.354 659.927C964.354 654.823 968.45 650.693 973.495 650.693C978.54 650.693 982.636 654.823 982.636 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 635.842C968.866 640.946 964.77 645.076 959.725 645.076C954.681 645.076 950.585 640.946 950.585 635.842C950.585 630.739 954.681 626.608 959.725 626.608C964.77 626.608 968.866 630.739 968.866 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 611.758C955.095 616.862 950.999 620.992 945.955 620.992C940.91 620.992 936.814 616.862 936.814 611.758C936.814 606.655 940.91 602.525 945.955 602.525C950.999 602.525 955.095 606.655 955.095 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 587.672C941.324 592.775 937.228 596.906 932.183 596.906C927.139 596.906 923.043 592.775 923.043 587.672C923.043 582.568 927.139 578.438 932.183 578.438C937.228 578.438 941.324 582.568 941.324 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 563.588C927.555 568.691 923.458 572.822 918.414 572.822C913.369 572.822 909.273 568.691 909.273 563.588C909.273 558.484 913.369 554.354 918.414 554.354C923.458 554.354 927.555 558.484 927.555 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 539.504C913.783 544.608 909.687 548.738 904.642 548.738C899.598 548.738 895.502 544.608 895.502 539.504C895.502 534.401 899.598 530.27 904.642 530.27C909.687 530.27 913.783 534.401 913.783 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 515.417C900.012 520.52 895.916 524.651 890.872 524.651C885.827 524.651 881.731 520.52 881.731 515.417C881.731 510.313 885.827 506.183 890.872 506.183C895.916 506.183 900.012 510.313 900.012 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 491.333C886.241 496.436 882.145 500.567 877.1 500.567C872.056 500.567 867.96 496.436 867.96 491.333C867.96 486.229 872.056 482.099 877.1 482.099C882.145 482.099 886.241 486.229 886.241 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 467.249C872.471 472.352 868.374 476.483 863.33 476.483C858.285 476.483 854.189 472.352 854.189 467.249C854.189 462.145 858.285 458.015 863.33 458.015C868.374 458.015 872.471 462.145 872.471 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 443.162C858.699 448.266 854.603 452.396 849.558 452.396C844.514 452.396 840.418 448.266 840.418 443.162C840.418 438.059 844.514 433.928 849.558 433.928C854.603 433.928 858.699 438.059 858.699 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 419.079C844.929 424.182 840.833 428.313 835.789 428.313C830.744 428.313 826.648 424.182 826.648 419.079C826.648 413.975 830.744 409.845 835.789 409.845C840.833 409.845 844.929 413.975 844.929 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 394.994C831.158 400.098 827.062 404.228 822.017 404.228C816.973 404.228 812.877 400.098 812.877 394.994C812.877 389.891 816.973 385.76 822.017 385.76C827.062 385.76 831.158 389.891 831.158 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 370.908C817.387 376.011 813.291 380.142 808.247 380.142C803.202 380.142 799.106 376.011 799.106 370.908C799.106 365.804 803.202 361.674 808.247 361.674C813.291 361.674 817.387 365.804 817.387 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.747 202.314C718.747 206.166 715.656 209.281 711.851 209.281C708.047 209.281 704.956 206.166 704.956 202.314C704.956 198.463 708.047 195.347 711.851 195.347C715.656 195.347 718.747 198.463 718.747 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 105.975C335.409 111.078 331.313 115.209 326.268 115.209C321.224 115.209 317.128 111.078 317.128 105.975C317.128 100.872 321.224 96.7411 326.268 96.7411C331.313 96.7411 335.409 100.872 335.409 105.975Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.868 105.975C307.868 111.078 303.772 115.209 298.727 115.209C293.683 115.209 289.587 111.078 289.587 105.975C289.587 100.872 293.683 96.7411 298.727 96.7411C303.772 96.7411 307.868 100.872 307.868 105.975Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.326 105.975C280.326 111.078 276.23 115.209 271.185 115.209C266.141 115.209 262.045 111.078 262.045 105.975C262.045 100.872 266.141 96.7411 271.185 96.7411C276.23 96.7411 280.326 100.872 280.326 105.975Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 1021.2C968.866 1026.3 964.77 1030.43 959.725 1030.43C954.681 1030.43 950.585 1026.3 950.585 1021.2C950.585 1016.1 954.681 1011.97 959.725 1011.97C964.77 1011.97 968.866 1016.1 968.866 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 997.116C982.636 1002.22 978.54 1006.35 973.495 1006.35C968.45 1006.35 964.354 1002.22 964.354 997.116C964.354 992.013 968.45 987.882 973.495 987.882C978.54 987.882 982.636 992.013 982.636 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 973.032C996.408 978.135 992.312 982.266 987.267 982.266C982.223 982.266 978.127 978.135 978.127 973.032C978.127 967.928 982.223 963.798 987.267 963.798C992.312 963.798 996.408 967.928 996.408 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 948.945C1010.18 954.049 1006.08 958.179 1001.04 958.179C995.992 958.179 991.896 954.049 991.896 948.945C991.896 943.842 995.992 939.712 1001.04 939.712C1006.08 939.712 1010.18 943.842 1010.18 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 924.861C1023.95 929.965 1019.85 934.095 1014.81 934.095C1009.76 934.095 1005.67 929.965 1005.67 924.861C1005.67 919.758 1009.76 915.628 1014.81 915.628C1019.85 915.628 1023.95 919.758 1023.95 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 900.777C1037.72 905.881 1033.62 910.011 1028.58 910.011C1023.53 910.011 1019.44 905.881 1019.44 900.777C1019.44 895.674 1023.53 891.543 1028.58 891.543C1033.62 891.543 1037.72 895.674 1037.72 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 876.691C1051.49 881.794 1047.39 885.925 1042.35 885.925C1037.31 885.925 1033.21 881.794 1033.21 876.691C1033.21 871.587 1037.31 867.457 1042.35 867.457C1047.39 867.457 1051.49 871.587 1051.49 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 852.606C1065.26 857.71 1061.17 861.84 1056.12 861.84C1051.08 861.84 1046.98 857.71 1046.98 852.606C1046.98 847.503 1051.08 843.372 1056.12 843.372C1061.17 843.372 1065.26 847.503 1065.26 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 828.522C1079.03 833.626 1074.94 837.756 1069.89 837.756C1064.85 837.756 1060.75 833.626 1060.75 828.522C1060.75 823.419 1064.85 819.288 1069.89 819.288C1074.94 819.288 1079.03 823.419 1079.03 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 804.436C1092.8 809.54 1088.71 813.67 1083.66 813.67C1078.62 813.67 1074.52 809.54 1074.52 804.436C1074.52 799.333 1078.62 795.202 1083.66 795.202C1088.71 795.202 1092.8 799.333 1092.8 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 780.352C1079.03 785.456 1074.94 789.586 1069.89 789.586C1064.85 789.586 1060.75 785.456 1060.75 780.352C1060.75 775.249 1064.85 771.118 1069.89 771.118C1074.94 771.118 1079.03 775.249 1079.03 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 756.268C1065.26 761.371 1061.17 765.502 1056.12 765.502C1051.08 765.502 1046.98 761.371 1046.98 756.268C1046.98 751.164 1051.08 747.034 1056.12 747.034C1061.17 747.034 1065.26 751.164 1065.26 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 732.181C1051.49 737.285 1047.39 741.415 1042.35 741.415C1037.31 741.415 1033.21 737.285 1033.21 732.181C1033.21 727.078 1037.31 722.947 1042.35 722.947C1047.39 722.947 1051.49 727.078 1051.49 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 708.097C1037.72 713.201 1033.62 717.331 1028.58 717.331C1023.53 717.331 1019.44 713.201 1019.44 708.097C1019.44 702.994 1023.53 698.863 1028.58 698.863C1033.62 698.863 1037.72 702.994 1037.72 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 684.013C1023.95 689.116 1019.85 693.247 1014.81 693.247C1009.76 693.247 1005.67 689.116 1005.67 684.013C1005.67 678.909 1009.76 674.779 1014.81 674.779C1019.85 674.779 1023.95 678.909 1023.95 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 659.927C1010.18 665.03 1006.08 669.161 1001.04 669.161C995.992 669.161 991.896 665.03 991.896 659.927C991.896 654.823 995.992 650.693 1001.04 650.693C1006.08 650.693 1010.18 654.823 1010.18 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 635.842C996.408 640.946 992.312 645.076 987.267 645.076C982.223 645.076 978.127 640.946 978.127 635.842C978.127 630.739 982.223 626.608 987.267 626.608C992.312 626.608 996.408 630.739 996.408 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 611.758C982.636 616.862 978.54 620.992 973.495 620.992C968.45 620.992 964.354 616.862 964.354 611.758C964.354 606.655 968.45 602.525 973.495 602.525C978.54 602.525 982.636 606.655 982.636 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 587.672C968.866 592.775 964.77 596.906 959.725 596.906C954.681 596.906 950.585 592.775 950.585 587.672C950.585 582.568 954.681 578.438 959.725 578.438C964.77 578.438 968.866 582.568 968.866 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 563.588C955.095 568.691 950.999 572.822 945.955 572.822C940.91 572.822 936.814 568.691 936.814 563.588C936.814 558.484 940.91 554.354 945.955 554.354C950.999 554.354 955.095 558.484 955.095 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 539.504C941.324 544.608 937.228 548.738 932.183 548.738C927.139 548.738 923.043 544.608 923.043 539.504C923.043 534.401 927.139 530.27 932.183 530.27C937.228 530.27 941.324 534.401 941.324 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 515.417C927.555 520.52 923.458 524.651 918.414 524.651C913.369 524.651 909.273 520.52 909.273 515.417C909.273 510.313 913.369 506.183 918.414 506.183C923.458 506.183 927.555 510.313 927.555 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 491.333C913.783 496.436 909.687 500.567 904.642 500.567C899.598 500.567 895.502 496.436 895.502 491.333C895.502 486.229 899.598 482.099 904.642 482.099C909.687 482.099 913.783 486.229 913.783 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 467.249C900.012 472.352 895.916 476.483 890.872 476.483C885.827 476.483 881.731 472.352 881.731 467.249C881.731 462.145 885.827 458.015 890.872 458.015C895.916 458.015 900.012 462.145 900.012 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 443.162C886.241 448.266 882.145 452.396 877.1 452.396C872.056 452.396 867.96 448.265 867.96 443.162C867.96 438.059 872.056 433.928 877.1 433.928C882.145 433.928 886.241 438.059 886.241 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 419.079C872.471 424.182 868.374 428.313 863.33 428.313C858.285 428.313 854.189 424.182 854.189 419.079C854.189 413.975 858.285 409.845 863.33 409.845C868.374 409.845 872.471 413.975 872.471 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 394.994C858.699 400.098 854.603 404.228 849.558 404.228C844.514 404.228 840.418 400.098 840.418 394.994C840.418 389.891 844.514 385.76 849.558 385.76C854.603 385.76 858.699 389.891 858.699 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 346.823C831.158 351.927 827.062 356.057 822.017 356.057C816.973 356.057 812.877 351.927 812.877 346.823C812.877 341.72 816.973 337.589 822.017 337.589C827.062 337.589 831.158 341.72 831.158 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.387 322.739C817.387 327.843 813.291 331.973 808.247 331.973C803.202 331.973 799.106 327.843 799.106 322.739C799.106 317.636 803.202 313.505 808.247 313.505C813.291 313.505 817.387 317.636 817.387 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.639 81.8886C321.639 86.9921 317.543 91.1226 312.499 91.1226C307.454 91.1226 303.358 86.9921 303.358 81.8886C303.358 76.7852 307.454 72.6546 312.499 72.6546C317.543 72.6546 321.639 76.7852 321.639 81.8886Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.096 81.8886C294.096 86.9921 290 91.1226 284.956 91.1226C279.911 91.1226 275.815 86.9921 275.815 81.8886C275.815 76.7852 279.911 72.6546 284.956 72.6546C290 72.6546 294.096 76.7852 294.096 81.8886Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 1045.29C982.636 1050.39 978.54 1054.52 973.495 1054.52C968.45 1054.52 964.354 1050.39 964.354 1045.29C964.354 1040.18 968.45 1036.05 973.495 1036.05C978.54 1036.05 982.636 1040.18 982.636 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 1021.2C996.408 1026.3 992.312 1030.43 987.267 1030.43C982.223 1030.43 978.127 1026.3 978.127 1021.2C978.127 1016.1 982.223 1011.97 987.267 1011.97C992.312 1011.97 996.408 1016.1 996.408 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 997.116C1010.18 1002.22 1006.08 1006.35 1001.04 1006.35C995.992 1006.35 991.896 1002.22 991.896 997.116C991.896 992.013 995.992 987.882 1001.04 987.882C1006.08 987.882 1010.18 992.013 1010.18 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 973.032C1023.95 978.135 1019.85 982.266 1014.81 982.266C1009.76 982.266 1005.67 978.135 1005.67 973.032C1005.67 967.928 1009.76 963.798 1014.81 963.798C1019.85 963.798 1023.95 967.928 1023.95 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 948.945C1037.72 954.049 1033.62 958.179 1028.58 958.179C1023.53 958.179 1019.44 954.049 1019.44 948.945C1019.44 943.842 1023.53 939.712 1028.58 939.712C1033.62 939.712 1037.72 943.842 1037.72 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 924.861C1051.49 929.965 1047.39 934.095 1042.35 934.095C1037.31 934.095 1033.21 929.965 1033.21 924.861C1033.21 919.758 1037.31 915.628 1042.35 915.628C1047.39 915.628 1051.49 919.758 1051.49 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 900.777C1065.26 905.881 1061.17 910.011 1056.12 910.011C1051.08 910.011 1046.98 905.881 1046.98 900.777C1046.98 895.674 1051.08 891.543 1056.12 891.543C1061.17 891.543 1065.26 895.674 1065.26 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 876.691C1079.03 881.794 1074.94 885.925 1069.89 885.925C1064.85 885.925 1060.75 881.794 1060.75 876.691C1060.75 871.587 1064.85 867.457 1069.89 867.457C1074.94 867.457 1079.03 871.587 1079.03 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 852.606C1092.8 857.71 1088.71 861.84 1083.66 861.84C1078.62 861.84 1074.52 857.71 1074.52 852.606C1074.52 847.503 1078.62 843.372 1083.66 843.372C1088.71 843.372 1092.8 847.503 1092.8 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 828.522C1106.57 833.626 1102.48 837.756 1097.43 837.756C1092.39 837.756 1088.29 833.626 1088.29 828.522C1088.29 823.419 1092.39 819.288 1097.43 819.288C1102.48 819.288 1106.57 823.419 1106.57 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 804.436C1120.35 809.54 1116.25 813.67 1111.2 813.67C1106.16 813.67 1102.06 809.54 1102.06 804.436C1102.06 799.333 1106.16 795.202 1111.2 795.202C1116.25 795.202 1120.35 799.333 1120.35 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 780.352C1106.57 785.456 1102.48 789.586 1097.43 789.586C1092.39 789.586 1088.29 785.456 1088.29 780.352C1088.29 775.249 1092.39 771.118 1097.43 771.118C1102.48 771.118 1106.57 775.249 1106.57 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 756.268C1092.8 761.371 1088.71 765.502 1083.66 765.502C1078.62 765.502 1074.52 761.371 1074.52 756.268C1074.52 751.164 1078.62 747.034 1083.66 747.034C1088.71 747.034 1092.8 751.164 1092.8 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 732.181C1079.03 737.285 1074.94 741.415 1069.89 741.415C1064.85 741.415 1060.75 737.285 1060.75 732.181C1060.75 727.078 1064.85 722.947 1069.89 722.947C1074.94 722.947 1079.03 727.078 1079.03 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 708.097C1065.26 713.201 1061.17 717.331 1056.12 717.331C1051.08 717.331 1046.98 713.201 1046.98 708.097C1046.98 702.994 1051.08 698.863 1056.12 698.863C1061.17 698.863 1065.26 702.994 1065.26 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 684.013C1051.49 689.116 1047.39 693.247 1042.35 693.247C1037.31 693.247 1033.21 689.116 1033.21 684.013C1033.21 678.909 1037.31 674.779 1042.35 674.779C1047.39 674.779 1051.49 678.909 1051.49 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 659.927C1037.72 665.03 1033.62 669.161 1028.58 669.161C1023.53 669.161 1019.44 665.03 1019.44 659.927C1019.44 654.823 1023.53 650.693 1028.58 650.693C1033.62 650.693 1037.72 654.823 1037.72 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 635.842C1023.95 640.946 1019.85 645.076 1014.81 645.076C1009.76 645.076 1005.67 640.946 1005.67 635.842C1005.67 630.739 1009.76 626.608 1014.81 626.608C1019.85 626.608 1023.95 630.739 1023.95 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 611.758C1010.18 616.862 1006.08 620.992 1001.04 620.992C995.992 620.992 991.896 616.862 991.896 611.758C991.896 606.655 995.992 602.525 1001.04 602.525C1006.08 602.525 1010.18 606.655 1010.18 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 587.672C996.408 592.775 992.312 596.906 987.267 596.906C982.223 596.906 978.127 592.775 978.127 587.672C978.127 582.568 982.223 578.438 987.267 578.438C992.312 578.438 996.408 582.568 996.408 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 563.588C982.636 568.691 978.54 572.822 973.495 572.822C968.45 572.822 964.354 568.691 964.354 563.588C964.354 558.484 968.45 554.354 973.495 554.354C978.54 554.354 982.636 558.484 982.636 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 539.504C968.866 544.608 964.77 548.738 959.725 548.738C954.681 548.738 950.585 544.608 950.585 539.504C950.585 534.401 954.681 530.27 959.725 530.27C964.77 530.27 968.866 534.401 968.866 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 515.417C955.095 520.52 950.999 524.651 945.955 524.651C940.91 524.651 936.814 520.52 936.814 515.417C936.814 510.313 940.91 506.183 945.955 506.183C950.999 506.183 955.095 510.313 955.095 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 491.333C941.324 496.436 937.228 500.567 932.183 500.567C927.139 500.567 923.043 496.436 923.043 491.333C923.043 486.229 927.139 482.099 932.183 482.099C937.228 482.099 941.324 486.229 941.324 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 467.249C927.555 472.352 923.458 476.483 918.414 476.483C913.369 476.483 909.273 472.352 909.273 467.249C909.273 462.145 913.369 458.015 918.414 458.015C923.458 458.015 927.555 462.145 927.555 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 443.162C913.783 448.266 909.687 452.396 904.642 452.396C899.598 452.396 895.502 448.266 895.502 443.162C895.502 438.059 899.598 433.928 904.642 433.928C909.687 433.928 913.783 438.059 913.783 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 419.079C900.012 424.182 895.916 428.313 890.872 428.313C885.827 428.313 881.731 424.182 881.731 419.079C881.731 413.975 885.827 409.845 890.872 409.845C895.916 409.845 900.012 413.975 900.012 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 394.994C886.241 400.098 882.145 404.228 877.1 404.228C872.056 404.228 867.96 400.098 867.96 394.994C867.96 389.891 872.056 385.76 877.1 385.76C882.145 385.76 886.241 389.891 886.241 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 370.908C872.471 376.011 868.374 380.142 863.33 380.142C858.285 380.142 854.189 376.011 854.189 370.908C854.189 365.804 858.285 361.674 863.33 361.674C868.374 361.674 872.471 365.804 872.471 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 346.823C858.699 351.927 854.603 356.057 849.558 356.057C844.514 356.057 840.418 351.927 840.418 346.823C840.418 341.72 844.514 337.589 849.558 337.589C854.603 337.589 858.699 341.72 858.699 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.929 322.739C844.929 327.843 840.833 331.973 835.789 331.973C830.744 331.973 826.648 327.843 826.648 322.739C826.648 317.636 830.744 313.505 835.789 313.505C840.833 313.505 844.929 317.636 844.929 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.158 298.653C831.158 303.756 827.062 307.887 822.017 307.887C816.973 307.887 812.877 303.756 812.877 298.653C812.877 293.549 816.973 289.419 822.017 289.419C827.062 289.419 831.158 293.549 831.158 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.493 57.8041C390.493 62.9076 386.397 67.0381 381.352 67.0381C376.308 67.0381 372.212 62.9076 372.212 57.8041C372.212 52.7007 376.308 48.5702 381.352 48.5702C386.397 48.5702 390.493 52.7007 390.493 57.8041Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.951 57.8041C362.951 62.9076 358.855 67.0381 353.81 67.0381C348.766 67.0381 344.67 62.9076 344.67 57.8041C344.67 52.7007 348.766 48.5702 353.81 48.5702C358.855 48.5702 362.951 52.7007 362.951 57.8041Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.409 57.8041C335.409 62.9076 331.313 67.0381 326.268 67.0381C321.224 67.0381 317.128 62.9076 317.128 57.8041C317.128 52.7007 321.224 48.5702 326.268 48.5702C331.313 48.5702 335.409 52.7007 335.409 57.8041Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 1141.62C955.095 1146.73 950.999 1150.86 945.955 1150.86C940.91 1150.86 936.814 1146.73 936.814 1141.62C936.814 1136.52 940.91 1132.39 945.955 1132.39C950.999 1132.39 955.095 1136.52 955.095 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 1069.37C996.408 1074.47 992.312 1078.6 987.267 1078.6C982.223 1078.6 978.127 1074.47 978.127 1069.37C978.127 1064.27 982.223 1060.14 987.267 1060.14C992.312 1060.14 996.408 1064.27 996.408 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 1045.29C1010.18 1050.39 1006.08 1054.52 1001.04 1054.52C995.992 1054.52 991.896 1050.39 991.896 1045.29C991.896 1040.18 995.992 1036.05 1001.04 1036.05C1006.08 1036.05 1010.18 1040.18 1010.18 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 1021.2C1023.95 1026.3 1019.85 1030.43 1014.81 1030.43C1009.76 1030.43 1005.67 1026.3 1005.67 1021.2C1005.67 1016.1 1009.76 1011.97 1014.81 1011.97C1019.85 1011.97 1023.95 1016.1 1023.95 1021.2Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 997.116C1037.72 1002.22 1033.62 1006.35 1028.58 1006.35C1023.53 1006.35 1019.44 1002.22 1019.44 997.116C1019.44 992.013 1023.53 987.882 1028.58 987.882C1033.62 987.882 1037.72 992.013 1037.72 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 973.032C1051.49 978.135 1047.39 982.266 1042.35 982.266C1037.31 982.266 1033.21 978.135 1033.21 973.032C1033.21 967.928 1037.31 963.798 1042.35 963.798C1047.39 963.798 1051.49 967.928 1051.49 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 948.945C1065.26 954.049 1061.17 958.179 1056.12 958.179C1051.08 958.179 1046.98 954.049 1046.98 948.945C1046.98 943.842 1051.08 939.712 1056.12 939.712C1061.17 939.712 1065.26 943.842 1065.26 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 924.861C1079.03 929.965 1074.94 934.095 1069.89 934.095C1064.85 934.095 1060.75 929.965 1060.75 924.861C1060.75 919.758 1064.85 915.628 1069.89 915.628C1074.94 915.628 1079.03 919.758 1079.03 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 900.777C1092.8 905.881 1088.71 910.011 1083.66 910.011C1078.62 910.011 1074.52 905.881 1074.52 900.777C1074.52 895.674 1078.62 891.543 1083.66 891.543C1088.71 891.543 1092.8 895.674 1092.8 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 876.691C1106.57 881.794 1102.48 885.925 1097.43 885.925C1092.39 885.925 1088.29 881.794 1088.29 876.691C1088.29 871.587 1092.39 867.457 1097.43 867.457C1102.48 867.457 1106.57 871.587 1106.57 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 852.606C1120.35 857.71 1116.25 861.84 1111.2 861.84C1106.16 861.84 1102.06 857.71 1102.06 852.606C1102.06 847.503 1106.16 843.372 1111.2 843.372C1116.25 843.372 1120.35 847.503 1120.35 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 828.522C1134.12 833.626 1130.02 837.756 1124.98 837.756C1119.93 837.756 1115.83 833.626 1115.83 828.522C1115.83 823.419 1119.93 819.288 1124.98 819.288C1130.02 819.288 1134.12 823.419 1134.12 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 804.436C1147.89 809.54 1143.79 813.67 1138.75 813.67C1133.7 813.67 1129.61 809.54 1129.61 804.436C1129.61 799.333 1133.7 795.202 1138.75 795.202C1143.79 795.202 1147.89 799.333 1147.89 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 780.352C1134.12 785.456 1130.02 789.586 1124.98 789.586C1119.93 789.586 1115.83 785.456 1115.83 780.352C1115.83 775.249 1119.93 771.118 1124.98 771.118C1130.02 771.118 1134.12 775.249 1134.12 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 756.268C1120.35 761.371 1116.25 765.502 1111.2 765.502C1106.16 765.502 1102.06 761.371 1102.06 756.268C1102.06 751.164 1106.16 747.034 1111.2 747.034C1116.25 747.034 1120.35 751.164 1120.35 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 732.181C1106.57 737.285 1102.48 741.415 1097.43 741.415C1092.39 741.415 1088.29 737.285 1088.29 732.181C1088.29 727.078 1092.39 722.947 1097.43 722.947C1102.48 722.947 1106.57 727.078 1106.57 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 708.097C1092.8 713.201 1088.71 717.331 1083.66 717.331C1078.62 717.331 1074.52 713.201 1074.52 708.097C1074.52 702.994 1078.62 698.863 1083.66 698.863C1088.71 698.863 1092.8 702.994 1092.8 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 684.013C1079.03 689.116 1074.94 693.247 1069.89 693.247C1064.85 693.247 1060.75 689.116 1060.75 684.013C1060.75 678.909 1064.85 674.779 1069.89 674.779C1074.94 674.779 1079.03 678.909 1079.03 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 659.927C1065.26 665.03 1061.17 669.161 1056.12 669.161C1051.08 669.161 1046.98 665.03 1046.98 659.927C1046.98 654.823 1051.08 650.693 1056.12 650.693C1061.17 650.693 1065.26 654.823 1065.26 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 635.842C1051.49 640.946 1047.39 645.076 1042.35 645.076C1037.31 645.076 1033.21 640.946 1033.21 635.842C1033.21 630.739 1037.31 626.608 1042.35 626.608C1047.39 626.608 1051.49 630.739 1051.49 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 611.758C1037.72 616.862 1033.62 620.992 1028.58 620.992C1023.53 620.992 1019.44 616.862 1019.44 611.758C1019.44 606.655 1023.53 602.525 1028.58 602.525C1033.62 602.525 1037.72 606.655 1037.72 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 587.672C1023.95 592.775 1019.85 596.906 1014.81 596.906C1009.76 596.906 1005.67 592.775 1005.67 587.672C1005.67 582.568 1009.76 578.438 1014.81 578.438C1019.85 578.438 1023.95 582.568 1023.95 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 563.588C1010.18 568.691 1006.08 572.822 1001.04 572.822C995.992 572.822 991.896 568.691 991.896 563.588C991.896 558.484 995.992 554.354 1001.04 554.354C1006.08 554.354 1010.18 558.484 1010.18 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 539.504C996.408 544.608 992.312 548.738 987.267 548.738C982.223 548.738 978.127 544.608 978.127 539.504C978.127 534.401 982.223 530.27 987.267 530.27C992.312 530.27 996.408 534.401 996.408 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 515.417C982.636 520.52 978.54 524.651 973.495 524.651C968.45 524.651 964.354 520.52 964.354 515.417C964.354 510.313 968.45 506.183 973.495 506.183C978.54 506.183 982.636 510.313 982.636 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 491.333C968.866 496.436 964.77 500.567 959.725 500.567C954.681 500.567 950.585 496.436 950.585 491.333C950.585 486.229 954.681 482.099 959.725 482.099C964.77 482.099 968.866 486.229 968.866 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 467.249C955.095 472.352 950.999 476.483 945.955 476.483C940.91 476.483 936.814 472.352 936.814 467.249C936.814 462.145 940.91 458.015 945.955 458.015C950.999 458.015 955.095 462.145 955.095 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 443.162C941.324 448.266 937.228 452.396 932.183 452.396C927.139 452.396 923.043 448.266 923.043 443.162C923.043 438.059 927.139 433.928 932.183 433.928C937.228 433.928 941.324 438.059 941.324 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 419.079C927.555 424.182 923.458 428.313 918.414 428.313C913.369 428.313 909.273 424.182 909.273 419.079C909.273 413.975 913.369 409.845 918.414 409.845C923.458 409.845 927.555 413.975 927.555 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 394.994C913.783 400.098 909.687 404.228 904.642 404.228C899.598 404.228 895.502 400.098 895.502 394.994C895.502 389.891 899.598 385.76 904.642 385.76C909.687 385.76 913.783 389.891 913.783 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 370.908C900.012 376.011 895.916 380.142 890.872 380.142C885.827 380.142 881.731 376.011 881.731 370.908C881.731 365.804 885.827 361.674 890.872 361.674C895.916 361.674 900.012 365.804 900.012 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 346.823C886.241 351.927 882.145 356.057 877.1 356.057C872.056 356.057 867.96 351.927 867.96 346.823C867.96 341.72 872.056 337.589 877.1 337.589C882.145 337.589 886.241 341.72 886.241 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.471 322.739C872.471 327.843 868.374 331.973 863.33 331.973C858.285 331.973 854.189 327.843 854.189 322.739C854.189 317.636 858.285 313.505 863.33 313.505C868.374 313.505 872.471 317.636 872.471 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.699 298.653C858.699 303.756 854.603 307.887 849.558 307.887C844.514 307.887 840.418 303.756 840.418 298.653C840.418 293.549 844.514 289.419 849.558 289.419C854.603 289.419 858.699 293.549 858.699 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.512 33.7204C569.512 38.8238 565.416 42.9544 560.372 42.9544C555.327 42.9544 551.231 38.8238 551.231 33.7204C551.231 28.6169 555.327 24.4864 560.372 24.4864C565.416 24.4864 569.512 28.6169 569.512 33.7204Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 1069.37C1023.95 1074.47 1019.85 1078.6 1014.81 1078.6C1009.76 1078.6 1005.67 1074.47 1005.67 1069.37C1005.67 1064.27 1009.76 1060.14 1014.81 1060.14C1019.85 1060.14 1023.95 1064.27 1023.95 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 1045.29C1037.72 1050.39 1033.62 1054.52 1028.58 1054.52C1023.53 1054.52 1019.44 1050.39 1019.44 1045.29C1019.44 1040.18 1023.53 1036.05 1028.58 1036.05C1033.62 1036.05 1037.72 1040.18 1037.72 1045.29Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 997.116C1065.26 1002.22 1061.17 1006.35 1056.12 1006.35C1051.08 1006.35 1046.98 1002.22 1046.98 997.116C1046.98 992.013 1051.08 987.882 1056.12 987.882C1061.17 987.882 1065.26 992.013 1065.26 997.116Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 973.032C1079.03 978.135 1074.94 982.266 1069.89 982.266C1064.85 982.266 1060.75 978.135 1060.75 973.032C1060.75 967.928 1064.85 963.798 1069.89 963.798C1074.94 963.798 1079.03 967.928 1079.03 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 948.945C1092.8 954.049 1088.71 958.179 1083.66 958.179C1078.62 958.179 1074.52 954.049 1074.52 948.945C1074.52 943.842 1078.62 939.712 1083.66 939.712C1088.71 939.712 1092.8 943.842 1092.8 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 924.861C1106.57 929.965 1102.48 934.095 1097.43 934.095C1092.39 934.095 1088.29 929.965 1088.29 924.861C1088.29 919.758 1092.39 915.628 1097.43 915.628C1102.48 915.628 1106.57 919.758 1106.57 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 900.777C1120.35 905.881 1116.25 910.011 1111.2 910.011C1106.16 910.011 1102.06 905.881 1102.06 900.777C1102.06 895.674 1106.16 891.543 1111.2 891.543C1116.25 891.543 1120.35 895.674 1120.35 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 876.691C1134.12 881.794 1130.02 885.925 1124.98 885.925C1119.93 885.925 1115.83 881.794 1115.83 876.691C1115.83 871.587 1119.93 867.457 1124.98 867.457C1130.02 867.457 1134.12 871.587 1134.12 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 828.522C1161.66 833.626 1157.56 837.756 1152.52 837.756C1147.47 837.756 1143.38 833.626 1143.38 828.522C1143.38 823.419 1147.47 819.288 1152.52 819.288C1157.56 819.288 1161.66 823.419 1161.66 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 804.436C1175.43 809.54 1171.33 813.67 1166.29 813.67C1161.24 813.67 1157.15 809.54 1157.15 804.436C1157.15 799.333 1161.24 795.202 1166.29 795.202C1171.33 795.202 1175.43 799.333 1175.43 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 780.352C1161.66 785.456 1157.56 789.586 1152.52 789.586C1147.47 789.586 1143.38 785.456 1143.38 780.352C1143.38 775.249 1147.47 771.118 1152.52 771.118C1157.56 771.118 1161.66 775.249 1161.66 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 756.268C1147.89 761.371 1143.79 765.502 1138.75 765.502C1133.7 765.502 1129.61 761.371 1129.61 756.268C1129.61 751.164 1133.7 747.034 1138.75 747.034C1143.79 747.034 1147.89 751.164 1147.89 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 732.181C1134.12 737.285 1130.02 741.415 1124.98 741.415C1119.93 741.415 1115.83 737.285 1115.83 732.181C1115.83 727.078 1119.93 722.947 1124.98 722.947C1130.02 722.947 1134.12 727.078 1134.12 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 708.097C1120.35 713.201 1116.25 717.331 1111.2 717.331C1106.16 717.331 1102.06 713.201 1102.06 708.097C1102.06 702.994 1106.16 698.863 1111.2 698.863C1116.25 698.863 1120.35 702.994 1120.35 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 684.013C1106.57 689.116 1102.48 693.247 1097.43 693.247C1092.39 693.247 1088.29 689.116 1088.29 684.013C1088.29 678.909 1092.39 674.779 1097.43 674.779C1102.48 674.779 1106.57 678.909 1106.57 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 659.927C1092.8 665.03 1088.71 669.161 1083.66 669.161C1078.62 669.161 1074.52 665.03 1074.52 659.927C1074.52 654.823 1078.62 650.693 1083.66 650.693C1088.71 650.693 1092.8 654.823 1092.8 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 635.842C1079.03 640.946 1074.94 645.076 1069.89 645.076C1064.85 645.076 1060.75 640.946 1060.75 635.842C1060.75 630.739 1064.85 626.608 1069.89 626.608C1074.94 626.608 1079.03 630.739 1079.03 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 611.758C1065.26 616.862 1061.17 620.992 1056.12 620.992C1051.08 620.992 1046.98 616.862 1046.98 611.758C1046.98 606.655 1051.08 602.525 1056.12 602.525C1061.17 602.525 1065.26 606.655 1065.26 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 587.672C1051.49 592.775 1047.39 596.906 1042.35 596.906C1037.31 596.906 1033.21 592.775 1033.21 587.672C1033.21 582.568 1037.31 578.438 1042.35 578.438C1047.39 578.438 1051.49 582.568 1051.49 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 563.588C1037.72 568.691 1033.62 572.822 1028.58 572.822C1023.53 572.822 1019.44 568.691 1019.44 563.588C1019.44 558.484 1023.53 554.354 1028.58 554.354C1033.62 554.354 1037.72 558.484 1037.72 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 539.504C1023.95 544.608 1019.85 548.738 1014.81 548.738C1009.76 548.738 1005.67 544.608 1005.67 539.504C1005.67 534.401 1009.76 530.27 1014.81 530.27C1019.85 530.27 1023.95 534.401 1023.95 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 515.417C1010.18 520.52 1006.08 524.651 1001.04 524.651C995.992 524.651 991.896 520.52 991.896 515.417C991.896 510.313 995.992 506.183 1001.04 506.183C1006.08 506.183 1010.18 510.313 1010.18 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 491.333C996.408 496.436 992.312 500.567 987.267 500.567C982.223 500.567 978.127 496.436 978.127 491.333C978.127 486.229 982.223 482.099 987.267 482.099C992.312 482.099 996.408 486.229 996.408 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 467.249C982.636 472.352 978.54 476.483 973.495 476.483C968.45 476.483 964.354 472.352 964.354 467.249C964.354 462.145 968.45 458.015 973.495 458.015C978.54 458.015 982.636 462.145 982.636 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 443.162C968.866 448.265 964.77 452.396 959.725 452.396C954.681 452.396 950.585 448.266 950.585 443.162C950.585 438.059 954.681 433.928 959.725 433.928C964.77 433.928 968.866 438.059 968.866 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 419.079C955.095 424.182 950.999 428.313 945.955 428.313C940.91 428.313 936.814 424.182 936.814 419.079C936.814 413.975 940.91 409.845 945.955 409.845C950.999 409.845 955.095 413.975 955.095 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 394.994C941.324 400.098 937.228 404.228 932.183 404.228C927.139 404.228 923.043 400.098 923.043 394.994C923.043 389.891 927.139 385.76 932.183 385.76C937.228 385.76 941.324 389.891 941.324 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 370.908C927.555 376.011 923.458 380.142 918.414 380.142C913.369 380.142 909.273 376.011 909.273 370.908C909.273 365.804 913.369 361.674 918.414 361.674C923.458 361.674 927.555 365.804 927.555 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 346.823C913.783 351.927 909.687 356.057 904.642 356.057C899.598 356.057 895.502 351.927 895.502 346.823C895.502 341.72 899.598 337.589 904.642 337.589C909.687 337.589 913.783 341.72 913.783 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 322.739C900.012 327.843 895.916 331.973 890.872 331.973C885.827 331.973 881.731 327.843 881.731 322.739C881.731 317.636 885.827 313.505 890.872 313.505C895.916 313.505 900.012 317.636 900.012 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 298.653C886.241 303.756 882.145 307.887 877.1 307.887C872.056 307.887 867.96 303.756 867.96 298.653C867.96 293.549 872.056 289.419 877.1 289.419C882.145 289.419 886.241 293.549 886.241 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 9.63396C693.452 14.7374 689.356 18.8679 684.311 18.8679C679.267 18.8679 675.171 14.7374 675.171 9.63396C675.171 4.5305 679.267 0.4 684.311 0.4C689.356 0.4 693.452 4.5305 693.452 9.63396Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.368 9.63396C638.368 14.7374 634.272 18.8679 629.227 18.8679C624.183 18.8679 620.087 14.7374 620.087 9.63396C620.087 4.53051 624.183 0.4 629.227 0.4C634.272 0.4 638.368 4.5305 638.368 9.63396Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.284 9.63396C583.284 14.7374 579.188 18.8679 574.143 18.8679C569.099 18.8679 565.003 14.7374 565.003 9.63396C565.003 4.5305 569.099 0.4 574.143 0.4C579.188 0.4 583.284 4.53051 583.284 9.63396Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.66 1165.71C995.66 1170.4 991.898 1174.19 987.267 1174.19C982.636 1174.19 978.875 1170.4 978.875 1165.71C978.875 1161.02 982.636 1157.23 987.267 1157.23C991.898 1157.23 995.66 1161.02 995.66 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 1141.62C1010.18 1146.73 1006.08 1150.86 1001.04 1150.86C995.992 1150.86 991.896 1146.73 991.896 1141.62C991.896 1136.52 995.992 1132.39 1001.04 1132.39C1006.08 1132.39 1010.18 1136.52 1010.18 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.97 1093.46C1036.97 1098.14 1033.21 1101.93 1028.58 1101.93C1023.95 1101.93 1020.19 1098.14 1020.19 1093.46C1020.19 1088.77 1023.95 1084.98 1028.58 1084.98C1033.21 1084.98 1036.97 1088.77 1036.97 1093.46Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 1069.37C1051.49 1074.47 1047.39 1078.6 1042.35 1078.6C1037.31 1078.6 1033.21 1074.47 1033.21 1069.37C1033.21 1064.27 1037.31 1060.14 1042.35 1060.14C1047.39 1060.14 1051.49 1064.27 1051.49 1069.37Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 973.032C1106.57 978.135 1102.48 982.266 1097.43 982.266C1092.39 982.266 1088.29 978.135 1088.29 973.032C1088.29 967.928 1092.39 963.798 1097.43 963.798C1102.48 963.798 1106.57 967.928 1106.57 973.032Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 948.945C1120.35 954.049 1116.25 958.179 1111.2 958.179C1106.16 958.179 1102.06 954.049 1102.06 948.945C1102.06 943.842 1106.16 939.712 1111.2 939.712C1116.25 939.712 1120.35 943.842 1120.35 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 924.861C1134.12 929.965 1130.02 934.095 1124.98 934.095C1119.93 934.095 1115.83 929.965 1115.83 924.861C1115.83 919.758 1119.93 915.628 1124.98 915.628C1130.02 915.628 1134.12 919.758 1134.12 924.861Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 900.777C1147.89 905.881 1143.79 910.011 1138.75 910.011C1133.7 910.011 1129.61 905.881 1129.61 900.777C1129.61 895.674 1133.7 891.543 1138.75 891.543C1143.79 891.543 1147.89 895.674 1147.89 900.777Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 828.522C1189.2 833.626 1185.1 837.756 1180.06 837.756C1175.01 837.756 1170.92 833.626 1170.92 828.522C1170.92 823.419 1175.01 819.288 1180.06 819.288C1185.1 819.288 1189.2 823.419 1189.2 828.522Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 804.436C1202.97 809.54 1198.87 813.67 1193.83 813.67C1188.79 813.67 1184.69 809.54 1184.69 804.436C1184.69 799.333 1188.79 795.202 1193.83 795.202C1198.87 795.202 1202.97 799.333 1202.97 804.436Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 780.352C1189.2 785.456 1185.1 789.586 1180.06 789.586C1175.01 789.586 1170.92 785.456 1170.92 780.352C1170.92 775.249 1175.01 771.118 1180.06 771.118C1185.1 771.118 1189.2 775.249 1189.2 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 756.268C1175.43 761.371 1171.33 765.502 1166.29 765.502C1161.24 765.502 1157.15 761.371 1157.15 756.268C1157.15 751.164 1161.24 747.034 1166.29 747.034C1171.33 747.034 1175.43 751.164 1175.43 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 732.181C1161.66 737.285 1157.56 741.415 1152.52 741.415C1147.47 741.415 1143.38 737.285 1143.38 732.181C1143.38 727.078 1147.47 722.947 1152.52 722.947C1157.56 722.947 1161.66 727.078 1161.66 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 708.097C1147.89 713.201 1143.79 717.331 1138.75 717.331C1133.7 717.331 1129.61 713.201 1129.61 708.097C1129.61 702.994 1133.7 698.863 1138.75 698.863C1143.79 698.863 1147.89 702.994 1147.89 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 684.013C1134.12 689.116 1130.02 693.247 1124.98 693.247C1119.93 693.247 1115.83 689.116 1115.83 684.013C1115.83 678.909 1119.93 674.779 1124.98 674.779C1130.02 674.779 1134.12 678.909 1134.12 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 659.927C1120.35 665.03 1116.25 669.161 1111.2 669.161C1106.16 669.161 1102.06 665.03 1102.06 659.927C1102.06 654.823 1106.16 650.693 1111.2 650.693C1116.25 650.693 1120.35 654.823 1120.35 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 635.842C1106.57 640.946 1102.48 645.076 1097.43 645.076C1092.39 645.076 1088.29 640.946 1088.29 635.842C1088.29 630.739 1092.39 626.608 1097.43 626.608C1102.48 626.608 1106.57 630.739 1106.57 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 611.758C1092.8 616.862 1088.71 620.992 1083.66 620.992C1078.62 620.992 1074.52 616.862 1074.52 611.758C1074.52 606.655 1078.62 602.525 1083.66 602.525C1088.71 602.525 1092.8 606.655 1092.8 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 587.672C1079.03 592.775 1074.94 596.906 1069.89 596.906C1064.85 596.906 1060.75 592.775 1060.75 587.672C1060.75 582.568 1064.85 578.438 1069.89 578.438C1074.94 578.438 1079.03 582.568 1079.03 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 563.588C1065.26 568.691 1061.17 572.822 1056.12 572.822C1051.08 572.822 1046.98 568.691 1046.98 563.588C1046.98 558.484 1051.08 554.354 1056.12 554.354C1061.17 554.354 1065.26 558.484 1065.26 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 539.504C1051.49 544.608 1047.39 548.738 1042.35 548.738C1037.31 548.738 1033.21 544.608 1033.21 539.504C1033.21 534.401 1037.31 530.27 1042.35 530.27C1047.39 530.27 1051.49 534.401 1051.49 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 515.417C1037.72 520.52 1033.62 524.651 1028.58 524.651C1023.53 524.651 1019.44 520.52 1019.44 515.417C1019.44 510.313 1023.53 506.183 1028.58 506.183C1033.62 506.183 1037.72 510.313 1037.72 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 491.333C1023.95 496.436 1019.85 500.567 1014.81 500.567C1009.76 500.567 1005.67 496.436 1005.67 491.333C1005.67 486.229 1009.76 482.099 1014.81 482.099C1019.85 482.099 1023.95 486.229 1023.95 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 467.249C1010.18 472.352 1006.08 476.483 1001.04 476.483C995.992 476.483 991.896 472.352 991.896 467.249C991.896 462.145 995.992 458.015 1001.04 458.015C1006.08 458.015 1010.18 462.145 1010.18 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 443.162C996.408 448.266 992.312 452.396 987.267 452.396C982.223 452.396 978.127 448.266 978.127 443.162C978.127 438.059 982.223 433.928 987.267 433.928C992.312 433.928 996.408 438.059 996.408 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 419.079C982.636 424.182 978.54 428.313 973.495 428.313C968.45 428.313 964.354 424.182 964.354 419.079C964.354 413.975 968.45 409.845 973.495 409.845C978.54 409.845 982.636 413.975 982.636 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 394.994C968.866 400.098 964.77 404.228 959.725 404.228C954.681 404.228 950.585 400.098 950.585 394.994C950.585 389.891 954.681 385.76 959.725 385.76C964.77 385.76 968.866 389.891 968.866 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 370.908C955.095 376.011 950.999 380.142 945.955 380.142C940.91 380.142 936.814 376.011 936.814 370.908C936.814 365.804 940.91 361.674 945.955 361.674C950.999 361.674 955.095 365.804 955.095 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 346.823C941.324 351.927 937.228 356.057 932.183 356.057C927.139 356.057 923.043 351.927 923.043 346.823C923.043 341.72 927.139 337.589 932.183 337.589C937.228 337.589 941.324 341.72 941.324 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 322.739C927.555 327.843 923.458 331.973 918.414 331.973C913.369 331.973 909.273 327.843 909.273 322.739C909.273 317.636 913.369 313.505 918.414 313.505C923.458 313.505 927.555 317.636 927.555 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 298.653C913.783 303.756 909.687 307.887 904.642 307.887C899.598 307.887 895.502 303.756 895.502 298.653C895.502 293.549 899.598 289.419 904.642 289.419C909.687 289.419 913.783 293.549 913.783 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 274.569C900.012 279.672 895.916 283.803 890.872 283.803C885.827 283.803 881.731 279.672 881.731 274.569C881.731 269.466 885.827 265.335 890.872 265.335C895.916 265.335 900.012 269.466 900.012 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.241 250.485C886.241 255.588 882.145 259.719 877.1 259.719C872.056 259.719 867.96 255.588 867.96 250.485C867.96 245.381 872.056 241.251 877.1 241.251C882.145 241.251 886.241 245.381 886.241 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 1189.8C1010.18 1194.9 1006.08 1199.03 1001.04 1199.03C995.992 1199.03 991.896 1194.9 991.896 1189.8C991.896 1184.69 995.992 1180.56 1001.04 1180.56C1006.08 1180.56 1010.18 1184.69 1010.18 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.63 973.031C1129.63 975.631 1127.54 977.731 1124.98 977.731C1122.41 977.731 1120.32 975.631 1120.32 973.031C1120.32 970.431 1122.41 968.331 1124.98 968.331C1127.54 968.331 1129.63 970.431 1129.63 973.031Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 948.945C1147.89 954.049 1143.79 958.179 1138.75 958.179C1133.7 958.179 1129.61 954.049 1129.61 948.945C1129.61 943.842 1133.7 939.712 1138.75 939.712C1143.79 939.712 1147.89 943.842 1147.89 948.945Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 852.606C1202.97 857.71 1198.87 861.84 1193.83 861.84C1188.79 861.84 1184.69 857.71 1184.69 852.606C1184.69 847.503 1188.79 843.372 1193.83 843.372C1198.87 843.372 1202.97 847.503 1202.97 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 780.352C1216.74 785.456 1212.64 789.586 1207.6 789.586C1202.56 789.586 1198.46 785.456 1198.46 780.352C1198.46 775.249 1202.56 771.118 1207.6 771.118C1212.64 771.118 1216.74 775.249 1216.74 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 756.268C1202.97 761.371 1198.87 765.502 1193.83 765.502C1188.79 765.502 1184.69 761.371 1184.69 756.268C1184.69 751.164 1188.79 747.034 1193.83 747.034C1198.87 747.034 1202.97 751.164 1202.97 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 732.181C1189.2 737.285 1185.1 741.415 1180.06 741.415C1175.01 741.415 1170.92 737.285 1170.92 732.181C1170.92 727.078 1175.01 722.947 1180.06 722.947C1185.1 722.947 1189.2 727.078 1189.2 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 708.097C1175.43 713.201 1171.33 717.331 1166.29 717.331C1161.24 717.331 1157.15 713.201 1157.15 708.097C1157.15 702.994 1161.24 698.863 1166.29 698.863C1171.33 698.863 1175.43 702.994 1175.43 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 684.013C1161.66 689.116 1157.56 693.247 1152.52 693.247C1147.47 693.247 1143.38 689.116 1143.38 684.013C1143.38 678.909 1147.47 674.779 1152.52 674.779C1157.56 674.779 1161.66 678.909 1161.66 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 659.927C1147.89 665.03 1143.79 669.161 1138.75 669.161C1133.7 669.161 1129.61 665.03 1129.61 659.927C1129.61 654.823 1133.7 650.693 1138.75 650.693C1143.79 650.693 1147.89 654.823 1147.89 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 635.842C1134.12 640.946 1130.02 645.076 1124.98 645.076C1119.93 645.076 1115.83 640.946 1115.83 635.842C1115.83 630.739 1119.93 626.608 1124.98 626.608C1130.02 626.608 1134.12 630.739 1134.12 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 611.758C1120.35 616.862 1116.25 620.992 1111.2 620.992C1106.16 620.992 1102.06 616.862 1102.06 611.758C1102.06 606.655 1106.16 602.525 1111.2 602.525C1116.25 602.525 1120.35 606.655 1120.35 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 587.672C1106.57 592.775 1102.48 596.906 1097.43 596.906C1092.39 596.906 1088.29 592.775 1088.29 587.672C1088.29 582.568 1092.39 578.438 1097.43 578.438C1102.48 578.438 1106.57 582.568 1106.57 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 563.588C1092.8 568.691 1088.71 572.822 1083.66 572.822C1078.62 572.822 1074.52 568.691 1074.52 563.588C1074.52 558.484 1078.62 554.354 1083.66 554.354C1088.71 554.354 1092.8 558.484 1092.8 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 539.504C1079.03 544.608 1074.94 548.738 1069.89 548.738C1064.85 548.738 1060.75 544.608 1060.75 539.504C1060.75 534.401 1064.85 530.27 1069.89 530.27C1074.94 530.27 1079.03 534.401 1079.03 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 515.417C1065.26 520.52 1061.17 524.651 1056.12 524.651C1051.08 524.651 1046.98 520.52 1046.98 515.417C1046.98 510.313 1051.08 506.183 1056.12 506.183C1061.17 506.183 1065.26 510.313 1065.26 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 491.333C1051.49 496.436 1047.39 500.567 1042.35 500.567C1037.31 500.567 1033.21 496.436 1033.21 491.333C1033.21 486.229 1037.31 482.099 1042.35 482.099C1047.39 482.099 1051.49 486.229 1051.49 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 467.249C1037.72 472.352 1033.62 476.483 1028.58 476.483C1023.53 476.483 1019.44 472.352 1019.44 467.249C1019.44 462.145 1023.53 458.015 1028.58 458.015C1033.62 458.015 1037.72 462.145 1037.72 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 443.162C1023.95 448.265 1019.85 452.396 1014.81 452.396C1009.76 452.396 1005.67 448.266 1005.67 443.162C1005.67 438.059 1009.76 433.928 1014.81 433.928C1019.85 433.928 1023.95 438.059 1023.95 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 419.079C1010.18 424.182 1006.08 428.313 1001.04 428.313C995.992 428.313 991.896 424.182 991.896 419.079C991.896 413.975 995.992 409.845 1001.04 409.845C1006.08 409.845 1010.18 413.975 1010.18 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 394.994C996.408 400.098 992.312 404.228 987.267 404.228C982.223 404.228 978.127 400.098 978.127 394.994C978.127 389.891 982.223 385.76 987.267 385.76C992.312 385.76 996.408 389.891 996.408 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 370.908C982.636 376.011 978.54 380.142 973.495 380.142C968.45 380.142 964.354 376.011 964.354 370.908C964.354 365.804 968.45 361.674 973.495 361.674C978.54 361.674 982.636 365.804 982.636 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 346.823C968.866 351.927 964.77 356.057 959.725 356.057C954.681 356.057 950.585 351.927 950.585 346.823C950.585 341.72 954.681 337.589 959.725 337.589C964.77 337.589 968.866 341.72 968.866 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 322.739C955.095 327.843 950.999 331.973 945.955 331.973C940.91 331.973 936.814 327.843 936.814 322.739C936.814 317.636 940.91 313.505 945.955 313.505C950.999 313.505 955.095 317.636 955.095 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 298.653C941.324 303.756 937.228 307.887 932.183 307.887C927.139 307.887 923.043 303.756 923.043 298.653C923.043 293.549 927.139 289.419 932.183 289.419C937.228 289.419 941.324 293.549 941.324 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 274.569C927.555 279.672 923.458 283.803 918.414 283.803C913.369 283.803 909.273 279.672 909.273 274.569C909.273 269.466 913.369 265.335 918.414 265.335C923.458 265.335 927.555 269.466 927.555 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.783 250.485C913.783 255.588 909.687 259.719 904.642 259.719C899.598 259.719 895.502 255.588 895.502 250.485C895.502 245.381 899.598 241.251 904.642 241.251C909.687 241.251 913.783 245.381 913.783 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.012 226.398C900.012 231.502 895.916 235.632 890.872 235.632C885.827 235.632 881.731 231.502 881.731 226.398C881.731 221.295 885.827 217.164 890.872 217.164C895.916 217.164 900.012 221.295 900.012 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 1213.88C1023.95 1218.98 1019.85 1223.11 1014.81 1223.11C1009.76 1223.11 1005.67 1218.98 1005.67 1213.88C1005.67 1208.78 1009.76 1204.65 1014.81 1204.65C1019.85 1204.65 1023.95 1208.78 1023.95 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 876.691C1216.74 881.794 1212.64 885.925 1207.6 885.925C1202.56 885.925 1198.46 881.794 1198.46 876.691C1198.46 871.587 1202.56 867.457 1207.6 867.457C1212.64 867.457 1216.74 871.587 1216.74 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 780.352C1244.28 785.456 1240.19 789.586 1235.14 789.586C1230.1 789.586 1226 785.456 1226 780.352C1226 775.249 1230.1 771.118 1235.14 771.118C1240.19 771.118 1244.28 775.249 1244.28 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 756.268C1230.51 761.371 1226.42 765.502 1221.37 765.502C1216.33 765.502 1212.23 761.371 1212.23 756.268C1212.23 751.164 1216.33 747.034 1221.37 747.034C1226.42 747.034 1230.51 751.164 1230.51 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 732.181C1216.74 737.285 1212.64 741.415 1207.6 741.415C1202.56 741.415 1198.46 737.285 1198.46 732.181C1198.46 727.078 1202.56 722.947 1207.6 722.947C1212.64 722.947 1216.74 727.078 1216.74 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 708.097C1202.97 713.201 1198.87 717.331 1193.83 717.331C1188.79 717.331 1184.69 713.201 1184.69 708.097C1184.69 702.994 1188.79 698.863 1193.83 698.863C1198.87 698.863 1202.97 702.994 1202.97 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 684.013C1189.2 689.116 1185.1 693.247 1180.06 693.247C1175.01 693.247 1170.92 689.116 1170.92 684.013C1170.92 678.909 1175.01 674.779 1180.06 674.779C1185.1 674.779 1189.2 678.909 1189.2 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 659.927C1175.43 665.03 1171.33 669.161 1166.29 669.161C1161.24 669.161 1157.15 665.03 1157.15 659.927C1157.15 654.823 1161.24 650.693 1166.29 650.693C1171.33 650.693 1175.43 654.823 1175.43 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 635.842C1161.66 640.946 1157.56 645.076 1152.52 645.076C1147.47 645.076 1143.38 640.946 1143.38 635.842C1143.38 630.739 1147.47 626.608 1152.52 626.608C1157.56 626.608 1161.66 630.739 1161.66 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 611.758C1147.89 616.862 1143.79 620.992 1138.75 620.992C1133.7 620.992 1129.61 616.862 1129.61 611.758C1129.61 606.655 1133.7 602.525 1138.75 602.525C1143.79 602.525 1147.89 606.655 1147.89 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 587.672C1134.12 592.775 1130.02 596.906 1124.98 596.906C1119.93 596.906 1115.83 592.775 1115.83 587.672C1115.83 582.568 1119.93 578.438 1124.98 578.438C1130.02 578.438 1134.12 582.568 1134.12 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 563.588C1120.35 568.691 1116.25 572.822 1111.2 572.822C1106.16 572.822 1102.06 568.691 1102.06 563.588C1102.06 558.484 1106.16 554.354 1111.2 554.354C1116.25 554.354 1120.35 558.484 1120.35 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 539.504C1106.57 544.608 1102.48 548.738 1097.43 548.738C1092.39 548.738 1088.29 544.608 1088.29 539.504C1088.29 534.401 1092.39 530.27 1097.43 530.27C1102.48 530.27 1106.57 534.401 1106.57 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 515.417C1092.8 520.52 1088.71 524.651 1083.66 524.651C1078.62 524.651 1074.52 520.52 1074.52 515.417C1074.52 510.313 1078.62 506.183 1083.66 506.183C1088.71 506.183 1092.8 510.313 1092.8 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 491.333C1079.03 496.436 1074.94 500.567 1069.89 500.567C1064.85 500.567 1060.75 496.436 1060.75 491.333C1060.75 486.229 1064.85 482.099 1069.89 482.099C1074.94 482.099 1079.03 486.229 1079.03 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 467.249C1065.26 472.352 1061.17 476.483 1056.12 476.483C1051.08 476.483 1046.98 472.352 1046.98 467.249C1046.98 462.145 1051.08 458.015 1056.12 458.015C1061.17 458.015 1065.26 462.145 1065.26 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 443.162C1051.49 448.266 1047.39 452.396 1042.35 452.396C1037.31 452.396 1033.21 448.266 1033.21 443.162C1033.21 438.059 1037.31 433.928 1042.35 433.928C1047.39 433.928 1051.49 438.059 1051.49 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 419.079C1037.72 424.182 1033.62 428.313 1028.58 428.313C1023.53 428.313 1019.44 424.182 1019.44 419.079C1019.44 413.975 1023.53 409.845 1028.58 409.845C1033.62 409.845 1037.72 413.975 1037.72 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 394.994C1023.95 400.098 1019.85 404.228 1014.81 404.228C1009.76 404.228 1005.67 400.098 1005.67 394.994C1005.67 389.891 1009.76 385.76 1014.81 385.76C1019.85 385.76 1023.95 389.891 1023.95 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 370.908C1010.18 376.011 1006.08 380.142 1001.04 380.142C995.992 380.142 991.896 376.011 991.896 370.908C991.896 365.804 995.992 361.674 1001.04 361.674C1006.08 361.674 1010.18 365.804 1010.18 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 346.823C996.408 351.927 992.312 356.057 987.267 356.057C982.223 356.057 978.127 351.927 978.127 346.823C978.127 341.72 982.223 337.589 987.267 337.589C992.312 337.589 996.408 341.72 996.408 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 322.739C982.636 327.843 978.54 331.973 973.495 331.973C968.45 331.973 964.354 327.843 964.354 322.739C964.354 317.636 968.45 313.505 973.495 313.505C978.54 313.505 982.636 317.636 982.636 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 298.653C968.866 303.756 964.77 307.887 959.725 307.887C954.681 307.887 950.585 303.756 950.585 298.653C950.585 293.549 954.681 289.419 959.725 289.419C964.77 289.419 968.866 293.549 968.866 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 274.569C955.095 279.672 950.999 283.803 945.955 283.803C940.91 283.803 936.814 279.672 936.814 274.569C936.814 269.466 940.91 265.335 945.955 265.335C950.999 265.335 955.095 269.466 955.095 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 250.485C941.324 255.588 937.228 259.719 932.183 259.719C927.139 259.719 923.043 255.588 923.043 250.485C923.043 245.381 927.139 241.251 932.183 241.251C937.228 241.251 941.324 245.381 941.324 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 226.398C927.555 231.502 923.458 235.632 918.414 235.632C913.369 235.632 909.273 231.502 909.273 226.398C909.273 221.295 913.369 217.164 918.414 217.164C923.458 217.164 927.555 221.295 927.555 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 1189.8C1065.26 1194.9 1061.17 1199.03 1056.12 1199.03C1051.08 1199.03 1046.98 1194.9 1046.98 1189.8C1046.98 1184.69 1051.08 1180.56 1056.12 1180.56C1061.17 1180.56 1065.26 1184.69 1065.26 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 1165.71C1079.03 1170.81 1074.94 1174.94 1069.89 1174.94C1064.85 1174.94 1060.75 1170.81 1060.75 1165.71C1060.75 1160.61 1064.85 1156.48 1069.89 1156.48C1074.94 1156.48 1079.03 1160.61 1079.03 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 780.352C1271.82 785.456 1267.73 789.586 1262.68 789.586C1257.64 789.586 1253.54 785.456 1253.54 780.352C1253.54 775.249 1257.64 771.118 1262.68 771.118C1267.73 771.118 1271.82 775.249 1271.82 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 756.268C1258.05 761.371 1253.96 765.502 1248.91 765.502C1243.87 765.502 1239.77 761.371 1239.77 756.268C1239.77 751.164 1243.87 747.034 1248.91 747.034C1253.96 747.034 1258.05 751.164 1258.05 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 732.181C1244.28 737.285 1240.19 741.415 1235.14 741.415C1230.1 741.415 1226 737.285 1226 732.181C1226 727.078 1230.1 722.947 1235.14 722.947C1240.19 722.947 1244.28 727.078 1244.28 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 708.097C1230.51 713.201 1226.42 717.331 1221.37 717.331C1216.33 717.331 1212.23 713.201 1212.23 708.097C1212.23 702.994 1216.33 698.863 1221.37 698.863C1226.42 698.863 1230.51 702.994 1230.51 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 684.013C1216.74 689.116 1212.64 693.247 1207.6 693.247C1202.56 693.247 1198.46 689.116 1198.46 684.013C1198.46 678.909 1202.56 674.779 1207.6 674.779C1212.64 674.779 1216.74 678.909 1216.74 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 659.927C1202.97 665.03 1198.87 669.161 1193.83 669.161C1188.79 669.161 1184.69 665.03 1184.69 659.927C1184.69 654.823 1188.79 650.693 1193.83 650.693C1198.87 650.693 1202.97 654.823 1202.97 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 635.842C1189.2 640.946 1185.1 645.076 1180.06 645.076C1175.01 645.076 1170.92 640.946 1170.92 635.842C1170.92 630.739 1175.01 626.608 1180.06 626.608C1185.1 626.608 1189.2 630.739 1189.2 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 611.758C1175.43 616.862 1171.33 620.992 1166.29 620.992C1161.24 620.992 1157.15 616.862 1157.15 611.758C1157.15 606.655 1161.24 602.525 1166.29 602.525C1171.33 602.525 1175.43 606.655 1175.43 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 587.672C1161.66 592.775 1157.56 596.906 1152.52 596.906C1147.47 596.906 1143.38 592.775 1143.38 587.672C1143.38 582.568 1147.47 578.438 1152.52 578.438C1157.56 578.438 1161.66 582.568 1161.66 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 563.588C1147.89 568.691 1143.79 572.822 1138.75 572.822C1133.7 572.822 1129.61 568.691 1129.61 563.588C1129.61 558.484 1133.7 554.354 1138.75 554.354C1143.79 554.354 1147.89 558.484 1147.89 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 539.504C1134.12 544.608 1130.02 548.738 1124.98 548.738C1119.93 548.738 1115.83 544.608 1115.83 539.504C1115.83 534.401 1119.93 530.27 1124.98 530.27C1130.02 530.27 1134.12 534.401 1134.12 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 515.417C1120.35 520.52 1116.25 524.651 1111.2 524.651C1106.16 524.651 1102.06 520.52 1102.06 515.417C1102.06 510.313 1106.16 506.183 1111.2 506.183C1116.25 506.183 1120.35 510.313 1120.35 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 491.333C1106.57 496.436 1102.48 500.567 1097.43 500.567C1092.39 500.567 1088.29 496.436 1088.29 491.333C1088.29 486.229 1092.39 482.099 1097.43 482.099C1102.48 482.099 1106.57 486.229 1106.57 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 467.249C1092.8 472.352 1088.71 476.483 1083.66 476.483C1078.62 476.483 1074.52 472.352 1074.52 467.249C1074.52 462.145 1078.62 458.015 1083.66 458.015C1088.71 458.015 1092.8 462.145 1092.8 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 443.162C1079.03 448.266 1074.94 452.396 1069.89 452.396C1064.85 452.396 1060.75 448.265 1060.75 443.162C1060.75 438.059 1064.85 433.928 1069.89 433.928C1074.94 433.928 1079.03 438.059 1079.03 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 419.079C1065.26 424.182 1061.17 428.313 1056.12 428.313C1051.08 428.313 1046.98 424.182 1046.98 419.079C1046.98 413.975 1051.08 409.845 1056.12 409.845C1061.17 409.845 1065.26 413.975 1065.26 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 394.994C1051.49 400.098 1047.39 404.228 1042.35 404.228C1037.31 404.228 1033.21 400.098 1033.21 394.994C1033.21 389.891 1037.31 385.76 1042.35 385.76C1047.39 385.76 1051.49 389.891 1051.49 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 370.908C1037.72 376.011 1033.62 380.142 1028.58 380.142C1023.53 380.142 1019.44 376.011 1019.44 370.908C1019.44 365.804 1023.53 361.674 1028.58 361.674C1033.62 361.674 1037.72 365.804 1037.72 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 346.823C1023.95 351.927 1019.85 356.057 1014.81 356.057C1009.76 356.057 1005.67 351.927 1005.67 346.823C1005.67 341.72 1009.76 337.589 1014.81 337.589C1019.85 337.589 1023.95 341.72 1023.95 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 322.739C1010.18 327.843 1006.08 331.973 1001.04 331.973C995.992 331.973 991.896 327.843 991.896 322.739C991.896 317.636 995.992 313.505 1001.04 313.505C1006.08 313.505 1010.18 317.636 1010.18 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 298.653C996.408 303.756 992.312 307.887 987.267 307.887C982.223 307.887 978.127 303.756 978.127 298.653C978.127 293.549 982.223 289.419 987.267 289.419C992.312 289.419 996.408 293.549 996.408 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 274.569C982.636 279.672 978.54 283.803 973.495 283.803C968.45 283.803 964.354 279.672 964.354 274.569C964.354 269.466 968.45 265.335 973.495 265.335C978.54 265.335 982.636 269.466 982.636 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 250.485C968.866 255.588 964.77 259.719 959.725 259.719C954.681 259.719 950.585 255.588 950.585 250.485C950.585 245.381 954.681 241.251 959.725 241.251C964.77 241.251 968.866 245.381 968.866 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 226.398C955.095 231.502 950.999 235.632 945.955 235.632C940.91 235.632 936.814 231.502 936.814 226.398C936.814 221.295 940.91 217.164 945.955 217.164C950.999 217.164 955.095 221.295 955.095 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 1237.96C1065.26 1243.07 1061.17 1247.2 1056.12 1247.2C1051.08 1247.2 1046.98 1243.07 1046.98 1237.96C1046.98 1232.86 1051.08 1228.73 1056.12 1228.73C1061.17 1228.73 1065.26 1232.86 1065.26 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 1189.8C1092.8 1194.9 1088.71 1199.03 1083.66 1199.03C1078.62 1199.03 1074.52 1194.9 1074.52 1189.8C1074.52 1184.69 1078.62 1180.56 1083.66 1180.56C1088.71 1180.56 1092.8 1184.69 1092.8 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 1165.71C1106.57 1170.81 1102.48 1174.94 1097.43 1174.94C1092.39 1174.94 1088.29 1170.81 1088.29 1165.71C1088.29 1160.61 1092.39 1156.48 1097.43 1156.48C1102.48 1156.48 1106.57 1160.61 1106.57 1165.71Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 1141.62C1120.35 1146.73 1116.25 1150.86 1111.2 1150.86C1106.16 1150.86 1102.06 1146.73 1102.06 1141.62C1102.06 1136.52 1106.16 1132.39 1111.2 1132.39C1116.25 1132.39 1120.35 1136.52 1120.35 1141.62Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 876.691C1271.82 881.794 1267.73 885.925 1262.68 885.925C1257.64 885.925 1253.54 881.794 1253.54 876.691C1253.54 871.587 1257.64 867.457 1262.68 867.457C1267.73 867.457 1271.82 871.587 1271.82 876.691Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.39 804.437C1312.39 809.123 1308.63 812.915 1303.99 812.915C1299.36 812.915 1295.6 809.123 1295.6 804.437C1295.6 799.751 1299.36 795.958 1303.99 795.958C1308.63 795.958 1312.39 799.751 1312.39 804.437Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 756.268C1285.59 761.371 1281.5 765.502 1276.45 765.502C1271.41 765.502 1267.31 761.371 1267.31 756.268C1267.31 751.164 1271.41 747.034 1276.45 747.034C1281.5 747.034 1285.59 751.164 1285.59 756.268Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 732.181C1271.82 737.285 1267.73 741.415 1262.68 741.415C1257.64 741.415 1253.54 737.285 1253.54 732.181C1253.54 727.078 1257.64 722.947 1262.68 722.947C1267.73 722.947 1271.82 727.078 1271.82 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 708.097C1258.05 713.201 1253.96 717.331 1248.91 717.331C1243.87 717.331 1239.77 713.201 1239.77 708.097C1239.77 702.994 1243.87 698.863 1248.91 698.863C1253.96 698.863 1258.05 702.994 1258.05 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 684.013C1244.28 689.116 1240.19 693.247 1235.14 693.247C1230.1 693.247 1226 689.116 1226 684.013C1226 678.909 1230.1 674.779 1235.14 674.779C1240.19 674.779 1244.28 678.909 1244.28 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 659.927C1230.51 665.03 1226.42 669.161 1221.37 669.161C1216.33 669.161 1212.23 665.03 1212.23 659.927C1212.23 654.823 1216.33 650.693 1221.37 650.693C1226.42 650.693 1230.51 654.823 1230.51 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 635.842C1216.74 640.946 1212.64 645.076 1207.6 645.076C1202.56 645.076 1198.46 640.946 1198.46 635.842C1198.46 630.739 1202.56 626.608 1207.6 626.608C1212.64 626.608 1216.74 630.739 1216.74 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 611.758C1202.97 616.862 1198.87 620.992 1193.83 620.992C1188.79 620.992 1184.69 616.862 1184.69 611.758C1184.69 606.655 1188.79 602.525 1193.83 602.525C1198.87 602.525 1202.97 606.655 1202.97 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 587.672C1189.2 592.775 1185.1 596.906 1180.06 596.906C1175.01 596.906 1170.92 592.775 1170.92 587.672C1170.92 582.568 1175.01 578.438 1180.06 578.438C1185.1 578.438 1189.2 582.568 1189.2 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 563.588C1175.43 568.691 1171.33 572.822 1166.29 572.822C1161.24 572.822 1157.15 568.691 1157.15 563.588C1157.15 558.484 1161.24 554.354 1166.29 554.354C1171.33 554.354 1175.43 558.484 1175.43 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 539.504C1161.66 544.608 1157.56 548.738 1152.52 548.738C1147.47 548.738 1143.38 544.608 1143.38 539.504C1143.38 534.401 1147.47 530.27 1152.52 530.27C1157.56 530.27 1161.66 534.401 1161.66 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 515.417C1147.89 520.52 1143.79 524.651 1138.75 524.651C1133.7 524.651 1129.61 520.52 1129.61 515.417C1129.61 510.313 1133.7 506.183 1138.75 506.183C1143.79 506.183 1147.89 510.313 1147.89 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 491.333C1134.12 496.436 1130.02 500.567 1124.98 500.567C1119.93 500.567 1115.83 496.436 1115.83 491.333C1115.83 486.229 1119.93 482.099 1124.98 482.099C1130.02 482.099 1134.12 486.229 1134.12 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 467.249C1120.35 472.352 1116.25 476.483 1111.2 476.483C1106.16 476.483 1102.06 472.352 1102.06 467.249C1102.06 462.145 1106.16 458.015 1111.2 458.015C1116.25 458.015 1120.35 462.145 1120.35 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 443.162C1106.57 448.266 1102.48 452.396 1097.43 452.396C1092.39 452.396 1088.29 448.266 1088.29 443.162C1088.29 438.059 1092.39 433.928 1097.43 433.928C1102.48 433.928 1106.57 438.059 1106.57 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 419.079C1092.8 424.182 1088.71 428.313 1083.66 428.313C1078.62 428.313 1074.52 424.182 1074.52 419.079C1074.52 413.975 1078.62 409.845 1083.66 409.845C1088.71 409.845 1092.8 413.975 1092.8 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 394.994C1079.03 400.098 1074.94 404.228 1069.89 404.228C1064.85 404.228 1060.75 400.098 1060.75 394.994C1060.75 389.891 1064.85 385.76 1069.89 385.76C1074.94 385.76 1079.03 389.891 1079.03 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 370.908C1065.26 376.011 1061.17 380.142 1056.12 380.142C1051.08 380.142 1046.98 376.011 1046.98 370.908C1046.98 365.804 1051.08 361.674 1056.12 361.674C1061.17 361.674 1065.26 365.804 1065.26 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 346.823C1051.49 351.927 1047.39 356.057 1042.35 356.057C1037.31 356.057 1033.21 351.927 1033.21 346.823C1033.21 341.72 1037.31 337.589 1042.35 337.589C1047.39 337.589 1051.49 341.72 1051.49 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 322.739C1037.72 327.843 1033.62 331.973 1028.58 331.973C1023.53 331.973 1019.44 327.843 1019.44 322.739C1019.44 317.636 1023.53 313.505 1028.58 313.505C1033.62 313.505 1037.72 317.636 1037.72 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 298.653C1023.95 303.756 1019.85 307.887 1014.81 307.887C1009.76 307.887 1005.67 303.756 1005.67 298.653C1005.67 293.549 1009.76 289.419 1014.81 289.419C1019.85 289.419 1023.95 293.549 1023.95 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 274.569C1010.18 279.672 1006.08 283.803 1001.04 283.803C995.992 283.803 991.896 279.672 991.896 274.569C991.896 269.466 995.992 265.335 1001.04 265.335C1006.08 265.335 1010.18 269.466 1010.18 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 250.485C996.408 255.588 992.312 259.719 987.267 259.719C982.223 259.719 978.127 255.588 978.127 250.485C978.127 245.381 982.223 241.251 987.267 241.251C992.312 241.251 996.408 245.381 996.408 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 226.398C982.636 231.502 978.54 235.632 973.495 235.632C968.45 235.632 964.354 231.502 964.354 226.398C964.354 221.295 968.45 217.164 973.495 217.164C978.54 217.164 982.636 221.295 982.636 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 1237.96C1092.8 1243.07 1088.71 1247.2 1083.66 1247.2C1078.62 1247.2 1074.52 1243.07 1074.52 1237.96C1074.52 1232.86 1078.62 1228.73 1083.66 1228.73C1088.71 1228.73 1092.8 1232.86 1092.8 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.93 1093.45C1173.93 1097.72 1170.5 1101.18 1166.29 1101.18C1162.07 1101.18 1158.64 1097.72 1158.64 1093.45C1158.64 1089.19 1162.07 1085.73 1166.29 1085.73C1170.5 1085.73 1173.93 1089.19 1173.93 1093.45Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 852.606C1313.14 857.71 1309.04 861.84 1303.99 861.84C1298.95 861.84 1294.85 857.71 1294.85 852.606C1294.85 847.503 1298.95 843.372 1303.99 843.372C1309.04 843.372 1313.14 847.503 1313.14 852.606Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 780.352C1326.91 785.456 1322.81 789.586 1317.77 789.586C1312.72 789.586 1308.62 785.456 1308.62 780.352C1308.62 775.249 1312.72 771.118 1317.77 771.118C1322.81 771.118 1326.91 775.249 1326.91 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 732.181C1299.37 737.285 1295.27 741.415 1290.23 741.415C1285.18 741.415 1281.08 737.285 1281.08 732.181C1281.08 727.078 1285.18 722.947 1290.23 722.947C1295.27 722.947 1299.37 727.078 1299.37 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 708.097C1285.59 713.201 1281.5 717.331 1276.45 717.331C1271.41 717.331 1267.31 713.201 1267.31 708.097C1267.31 702.994 1271.41 698.863 1276.45 698.863C1281.5 698.863 1285.59 702.994 1285.59 708.097Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 684.013C1271.82 689.116 1267.73 693.247 1262.68 693.247C1257.64 693.247 1253.54 689.116 1253.54 684.013C1253.54 678.909 1257.64 674.779 1262.68 674.779C1267.73 674.779 1271.82 678.909 1271.82 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 659.927C1258.05 665.03 1253.96 669.161 1248.91 669.161C1243.87 669.161 1239.77 665.03 1239.77 659.927C1239.77 654.823 1243.87 650.693 1248.91 650.693C1253.96 650.693 1258.05 654.823 1258.05 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 635.842C1244.28 640.946 1240.19 645.076 1235.14 645.076C1230.1 645.076 1226 640.946 1226 635.842C1226 630.739 1230.1 626.608 1235.14 626.608C1240.19 626.608 1244.28 630.739 1244.28 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 611.758C1230.51 616.862 1226.42 620.992 1221.37 620.992C1216.33 620.992 1212.23 616.862 1212.23 611.758C1212.23 606.655 1216.33 602.525 1221.37 602.525C1226.42 602.525 1230.51 606.655 1230.51 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 587.672C1216.74 592.775 1212.64 596.906 1207.6 596.906C1202.56 596.906 1198.46 592.775 1198.46 587.672C1198.46 582.568 1202.56 578.438 1207.6 578.438C1212.64 578.438 1216.74 582.568 1216.74 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 563.588C1202.97 568.691 1198.87 572.822 1193.83 572.822C1188.79 572.822 1184.69 568.691 1184.69 563.588C1184.69 558.484 1188.79 554.354 1193.83 554.354C1198.87 554.354 1202.97 558.484 1202.97 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 539.504C1189.2 544.608 1185.1 548.738 1180.06 548.738C1175.01 548.738 1170.92 544.608 1170.92 539.504C1170.92 534.401 1175.01 530.27 1180.06 530.27C1185.1 530.27 1189.2 534.401 1189.2 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 515.417C1175.43 520.52 1171.33 524.651 1166.29 524.651C1161.24 524.651 1157.15 520.52 1157.15 515.417C1157.15 510.313 1161.24 506.183 1166.29 506.183C1171.33 506.183 1175.43 510.313 1175.43 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 491.333C1161.66 496.436 1157.56 500.567 1152.52 500.567C1147.47 500.567 1143.38 496.436 1143.38 491.333C1143.38 486.229 1147.47 482.099 1152.52 482.099C1157.56 482.099 1161.66 486.229 1161.66 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 467.249C1147.89 472.352 1143.79 476.483 1138.75 476.483C1133.7 476.483 1129.61 472.352 1129.61 467.249C1129.61 462.145 1133.7 458.015 1138.75 458.015C1143.79 458.015 1147.89 462.145 1147.89 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 443.162C1134.12 448.266 1130.02 452.396 1124.98 452.396C1119.93 452.396 1115.83 448.266 1115.83 443.162C1115.83 438.059 1119.93 433.928 1124.98 433.928C1130.02 433.928 1134.12 438.059 1134.12 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 419.079C1120.35 424.182 1116.25 428.313 1111.2 428.313C1106.16 428.313 1102.06 424.182 1102.06 419.079C1102.06 413.975 1106.16 409.845 1111.2 409.845C1116.25 409.845 1120.35 413.975 1120.35 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 394.994C1106.57 400.098 1102.48 404.228 1097.43 404.228C1092.39 404.228 1088.29 400.098 1088.29 394.994C1088.29 389.891 1092.39 385.76 1097.43 385.76C1102.48 385.76 1106.57 389.891 1106.57 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 370.908C1092.8 376.011 1088.71 380.142 1083.66 380.142C1078.62 380.142 1074.52 376.011 1074.52 370.908C1074.52 365.804 1078.62 361.674 1083.66 361.674C1088.71 361.674 1092.8 365.804 1092.8 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 346.823C1079.03 351.927 1074.94 356.057 1069.89 356.057C1064.85 356.057 1060.75 351.927 1060.75 346.823C1060.75 341.72 1064.85 337.589 1069.89 337.589C1074.94 337.589 1079.03 341.72 1079.03 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 322.739C1065.26 327.843 1061.17 331.973 1056.12 331.973C1051.08 331.973 1046.98 327.843 1046.98 322.739C1046.98 317.636 1051.08 313.505 1056.12 313.505C1061.17 313.505 1065.26 317.636 1065.26 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 298.653C1051.49 303.756 1047.39 307.887 1042.35 307.887C1037.31 307.887 1033.21 303.756 1033.21 298.653C1033.21 293.549 1037.31 289.419 1042.35 289.419C1047.39 289.419 1051.49 293.549 1051.49 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 274.569C1037.72 279.672 1033.62 283.803 1028.58 283.803C1023.53 283.803 1019.44 279.672 1019.44 274.569C1019.44 269.466 1023.53 265.335 1028.58 265.335C1033.62 265.335 1037.72 269.466 1037.72 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 250.485C1023.95 255.588 1019.85 259.719 1014.81 259.719C1009.76 259.719 1005.67 255.588 1005.67 250.485C1005.67 245.381 1009.76 241.251 1014.81 241.251C1019.85 241.251 1023.95 245.381 1023.95 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 226.398C1010.18 231.502 1006.08 235.632 1001.04 235.632C995.992 235.632 991.896 231.502 991.896 226.398C991.896 221.295 995.992 217.164 1001.04 217.164C1006.08 217.164 1010.18 221.295 1010.18 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 202.314C996.408 207.417 992.312 211.548 987.267 211.548C982.223 211.548 978.127 207.417 978.127 202.314C978.127 197.21 982.223 193.08 987.267 193.08C992.312 193.08 996.408 197.21 996.408 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 1189.8C1147.89 1194.9 1143.79 1199.03 1138.75 1199.03C1133.7 1199.03 1129.61 1194.9 1129.61 1189.8C1129.61 1184.69 1133.7 1180.56 1138.75 1180.56C1143.79 1180.56 1147.89 1184.69 1147.89 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 1117.54C1189.2 1122.64 1185.1 1126.78 1180.06 1126.78C1175.01 1126.78 1170.92 1122.64 1170.92 1117.54C1170.92 1112.44 1175.01 1108.31 1180.06 1108.31C1185.1 1108.31 1189.2 1112.44 1189.2 1117.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.95 780.352C1352.95 784.621 1349.53 788.074 1345.31 788.074C1341.09 788.074 1337.66 784.621 1337.66 780.352C1337.66 776.083 1341.09 772.629 1345.31 772.629C1349.53 772.629 1352.95 776.083 1352.95 780.352Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 732.181C1326.91 737.285 1322.81 741.415 1317.77 741.415C1312.72 741.415 1308.62 737.285 1308.62 732.181C1308.62 727.078 1312.72 722.947 1317.77 722.947C1322.81 722.947 1326.91 727.078 1326.91 732.181Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 684.013C1299.37 689.116 1295.27 693.247 1290.23 693.247C1285.18 693.247 1281.08 689.116 1281.08 684.013C1281.08 678.909 1285.18 674.779 1290.23 674.779C1295.27 674.779 1299.37 678.909 1299.37 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 635.842C1271.82 640.946 1267.73 645.076 1262.68 645.076C1257.64 645.076 1253.54 640.946 1253.54 635.842C1253.54 630.739 1257.64 626.608 1262.68 626.608C1267.73 626.608 1271.82 630.739 1271.82 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 611.758C1258.05 616.862 1253.96 620.992 1248.91 620.992C1243.87 620.992 1239.77 616.862 1239.77 611.758C1239.77 606.655 1243.87 602.525 1248.91 602.525C1253.96 602.525 1258.05 606.655 1258.05 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 587.672C1244.28 592.775 1240.19 596.906 1235.14 596.906C1230.1 596.906 1226 592.775 1226 587.672C1226 582.568 1230.1 578.438 1235.14 578.438C1240.19 578.438 1244.28 582.568 1244.28 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 563.588C1230.51 568.691 1226.42 572.822 1221.37 572.822C1216.33 572.822 1212.23 568.691 1212.23 563.588C1212.23 558.484 1216.33 554.354 1221.37 554.354C1226.42 554.354 1230.51 558.484 1230.51 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 539.504C1216.74 544.608 1212.64 548.738 1207.6 548.738C1202.56 548.738 1198.46 544.608 1198.46 539.504C1198.46 534.401 1202.56 530.27 1207.6 530.27C1212.64 530.27 1216.74 534.401 1216.74 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 515.417C1202.97 520.52 1198.87 524.651 1193.83 524.651C1188.79 524.651 1184.69 520.52 1184.69 515.417C1184.69 510.313 1188.79 506.183 1193.83 506.183C1198.87 506.183 1202.97 510.313 1202.97 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 491.333C1189.2 496.436 1185.1 500.567 1180.06 500.567C1175.01 500.567 1170.92 496.436 1170.92 491.333C1170.92 486.229 1175.01 482.099 1180.06 482.099C1185.1 482.099 1189.2 486.229 1189.2 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 467.249C1175.43 472.352 1171.33 476.483 1166.29 476.483C1161.24 476.483 1157.15 472.352 1157.15 467.249C1157.15 462.145 1161.24 458.015 1166.29 458.015C1171.33 458.015 1175.43 462.145 1175.43 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 443.162C1161.66 448.266 1157.56 452.396 1152.52 452.396C1147.47 452.396 1143.38 448.266 1143.38 443.162C1143.38 438.059 1147.47 433.928 1152.52 433.928C1157.56 433.928 1161.66 438.059 1161.66 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 419.079C1147.89 424.182 1143.79 428.313 1138.75 428.313C1133.7 428.313 1129.61 424.182 1129.61 419.079C1129.61 413.975 1133.7 409.845 1138.75 409.845C1143.79 409.845 1147.89 413.975 1147.89 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 394.994C1134.12 400.098 1130.02 404.228 1124.98 404.228C1119.93 404.228 1115.83 400.098 1115.83 394.994C1115.83 389.891 1119.93 385.76 1124.98 385.76C1130.02 385.76 1134.12 389.891 1134.12 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 370.908C1120.35 376.011 1116.25 380.142 1111.2 380.142C1106.16 380.142 1102.06 376.011 1102.06 370.908C1102.06 365.804 1106.16 361.674 1111.2 361.674C1116.25 361.674 1120.35 365.804 1120.35 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 346.823C1106.57 351.927 1102.48 356.057 1097.43 356.057C1092.39 356.057 1088.29 351.927 1088.29 346.823C1088.29 341.72 1092.39 337.589 1097.43 337.589C1102.48 337.589 1106.57 341.72 1106.57 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 322.739C1092.8 327.843 1088.71 331.973 1083.66 331.973C1078.62 331.973 1074.52 327.843 1074.52 322.739C1074.52 317.636 1078.62 313.505 1083.66 313.505C1088.71 313.505 1092.8 317.636 1092.8 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 298.653C1079.03 303.756 1074.94 307.887 1069.89 307.887C1064.85 307.887 1060.75 303.756 1060.75 298.653C1060.75 293.549 1064.85 289.419 1069.89 289.419C1074.94 289.419 1079.03 293.549 1079.03 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 274.569C1065.26 279.672 1061.17 283.803 1056.12 283.803C1051.08 283.803 1046.98 279.672 1046.98 274.569C1046.98 269.466 1051.08 265.335 1056.12 265.335C1061.17 265.335 1065.26 269.466 1065.26 274.569Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 250.485C1051.49 255.588 1047.39 259.719 1042.35 259.719C1037.31 259.719 1033.21 255.588 1033.21 250.485C1033.21 245.381 1037.31 241.251 1042.35 241.251C1047.39 241.251 1051.49 245.381 1051.49 250.485Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 226.398C1037.72 231.502 1033.62 235.632 1028.58 235.632C1023.53 235.632 1019.44 231.502 1019.44 226.398C1019.44 221.295 1023.53 217.164 1028.58 217.164C1033.62 217.164 1037.72 221.295 1037.72 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 202.314C1023.95 207.417 1019.85 211.548 1014.81 211.548C1009.76 211.548 1005.67 207.417 1005.67 202.314C1005.67 197.21 1009.76 193.08 1014.81 193.08C1019.85 193.08 1023.95 197.21 1023.95 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.18 178.229C1010.18 183.333 1006.08 187.463 1001.04 187.463C995.992 187.463 991.896 183.333 991.896 178.229C991.896 173.126 995.992 168.995 1001.04 168.995C1006.08 168.995 1010.18 173.126 1010.18 178.229Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.636 130.06C982.636 135.163 978.54 139.293 973.495 139.293C968.45 139.293 964.354 135.163 964.354 130.06C964.354 124.956 968.45 120.826 973.495 120.826C978.54 120.826 982.636 124.956 982.636 130.06Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 81.8886C955.095 86.9921 950.999 91.1226 945.955 91.1226C940.91 91.1226 936.814 86.9921 936.814 81.8886C936.814 76.7852 940.91 72.6546 945.955 72.6546C950.999 72.6546 955.095 76.7852 955.095 81.8886Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 57.8041C941.324 62.9076 937.228 67.0381 932.183 67.0381C927.139 67.0381 923.043 62.9076 923.043 57.8041C923.043 52.7007 927.139 48.5702 932.183 48.5702C937.228 48.5702 941.324 52.7007 941.324 57.8041Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.555 33.7204C927.555 38.8238 923.458 42.9544 918.414 42.9544C913.369 42.9544 909.273 38.8238 909.273 33.7204C909.273 28.6169 913.369 24.4864 918.414 24.4864C923.458 24.4864 927.555 28.6169 927.555 33.7204Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 1213.88C1161.66 1218.98 1157.56 1223.11 1152.52 1223.11C1147.47 1223.11 1143.38 1218.98 1143.38 1213.88C1143.38 1208.78 1147.47 1204.65 1152.52 1204.65C1157.56 1204.65 1161.66 1208.78 1161.66 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 684.013C1326.91 689.116 1322.81 693.247 1317.77 693.247C1312.72 693.247 1308.62 689.116 1308.62 684.013C1308.62 678.909 1312.72 674.779 1317.77 674.779C1322.81 674.779 1326.91 678.909 1326.91 684.013Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 611.758C1285.59 616.862 1281.5 620.992 1276.45 620.992C1271.41 620.992 1267.31 616.862 1267.31 611.758C1267.31 606.655 1271.41 602.525 1276.45 602.525C1281.5 602.525 1285.59 606.655 1285.59 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 587.672C1271.82 592.775 1267.73 596.906 1262.68 596.906C1257.64 596.906 1253.54 592.775 1253.54 587.672C1253.54 582.568 1257.64 578.438 1262.68 578.438C1267.73 578.438 1271.82 582.568 1271.82 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 563.588C1258.05 568.691 1253.96 572.822 1248.91 572.822C1243.87 572.822 1239.77 568.691 1239.77 563.588C1239.77 558.484 1243.87 554.354 1248.91 554.354C1253.96 554.354 1258.05 558.484 1258.05 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 539.504C1244.28 544.608 1240.19 548.738 1235.14 548.738C1230.1 548.738 1226 544.608 1226 539.504C1226 534.401 1230.1 530.27 1235.14 530.27C1240.19 530.27 1244.28 534.401 1244.28 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 515.417C1230.51 520.52 1226.42 524.651 1221.37 524.651C1216.33 524.651 1212.23 520.52 1212.23 515.417C1212.23 510.313 1216.33 506.183 1221.37 506.183C1226.42 506.183 1230.51 510.313 1230.51 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 491.333C1216.74 496.436 1212.64 500.567 1207.6 500.567C1202.56 500.567 1198.46 496.436 1198.46 491.333C1198.46 486.229 1202.56 482.099 1207.6 482.099C1212.64 482.099 1216.74 486.229 1216.74 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 467.249C1202.97 472.352 1198.87 476.483 1193.83 476.483C1188.79 476.483 1184.69 472.352 1184.69 467.249C1184.69 462.145 1188.79 458.015 1193.83 458.015C1198.87 458.015 1202.97 462.145 1202.97 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 443.162C1189.2 448.266 1185.1 452.396 1180.06 452.396C1175.01 452.396 1170.92 448.266 1170.92 443.162C1170.92 438.059 1175.01 433.928 1180.06 433.928C1185.1 433.928 1189.2 438.059 1189.2 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 419.079C1175.43 424.182 1171.33 428.313 1166.29 428.313C1161.24 428.313 1157.15 424.182 1157.15 419.079C1157.15 413.975 1161.24 409.845 1166.29 409.845C1171.33 409.845 1175.43 413.975 1175.43 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 394.994C1161.66 400.098 1157.56 404.228 1152.52 404.228C1147.47 404.228 1143.38 400.098 1143.38 394.994C1143.38 389.891 1147.47 385.76 1152.52 385.76C1157.56 385.76 1161.66 389.891 1161.66 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 370.908C1147.89 376.011 1143.79 380.142 1138.75 380.142C1133.7 380.142 1129.61 376.011 1129.61 370.908C1129.61 365.804 1133.7 361.674 1138.75 361.674C1143.79 361.674 1147.89 365.804 1147.89 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 346.823C1134.12 351.927 1130.02 356.057 1124.98 356.057C1119.93 356.057 1115.83 351.927 1115.83 346.823C1115.83 341.72 1119.93 337.589 1124.98 337.589C1130.02 337.589 1134.12 341.72 1134.12 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 322.739C1120.35 327.843 1116.25 331.973 1111.2 331.973C1106.16 331.973 1102.06 327.843 1102.06 322.739C1102.06 317.636 1106.16 313.505 1111.2 313.505C1116.25 313.505 1120.35 317.636 1120.35 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 298.653C1106.57 303.756 1102.48 307.887 1097.43 307.887C1092.39 307.887 1088.29 303.756 1088.29 298.653C1088.29 293.549 1092.39 289.419 1097.43 289.419C1102.48 289.419 1106.57 293.549 1106.57 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.26 226.398C1065.26 231.502 1061.17 235.632 1056.12 235.632C1051.08 235.632 1046.98 231.502 1046.98 226.398C1046.98 221.295 1051.08 217.164 1056.12 217.164C1061.17 217.164 1065.26 221.295 1065.26 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.49 202.314C1051.49 207.417 1047.39 211.548 1042.35 211.548C1037.31 211.548 1033.21 207.417 1033.21 202.314C1033.21 197.21 1037.31 193.08 1042.35 193.08C1047.39 193.08 1051.49 197.21 1051.49 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.72 178.229C1037.72 183.333 1033.62 187.463 1028.58 187.463C1023.53 187.463 1019.44 183.333 1019.44 178.229C1019.44 173.126 1023.53 168.995 1028.58 168.995C1033.62 168.995 1037.72 173.126 1037.72 178.229Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 154.143C1023.95 159.247 1019.85 163.377 1014.81 163.377C1009.76 163.377 1005.67 159.247 1005.67 154.143C1005.67 149.04 1009.76 144.909 1014.81 144.909C1019.85 144.909 1023.95 149.04 1023.95 154.143Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.408 105.975C996.408 111.078 992.312 115.209 987.267 115.209C982.223 115.209 978.127 111.078 978.127 105.975C978.127 100.872 982.223 96.7411 987.267 96.7411C992.312 96.7411 996.408 100.872 996.408 105.975Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.866 57.8041C968.866 62.9076 964.77 67.0381 959.725 67.0381C954.681 67.0381 950.585 62.9076 950.585 57.8041C950.585 52.7007 954.681 48.5702 959.725 48.5702C964.77 48.5702 968.866 52.7007 968.866 57.8041Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.095 33.7204C955.095 38.8238 950.999 42.9544 945.955 42.9544C940.91 42.9544 936.814 38.8238 936.814 33.7204C936.814 28.6169 940.91 24.4864 945.955 24.4864C950.999 24.4864 955.095 28.6169 955.095 33.7204Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.324 9.63396C941.324 14.7374 937.228 18.8679 932.183 18.8679C927.139 18.8679 923.043 14.7374 923.043 9.63396C923.043 4.5305 927.139 0.4 932.183 0.4C937.228 0.4 941.324 4.5305 941.324 9.63396Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 587.672C1299.37 592.775 1295.27 596.906 1290.23 596.906C1285.18 596.906 1281.08 592.775 1281.08 587.672C1281.08 582.568 1285.18 578.438 1290.23 578.438C1295.27 578.438 1299.37 582.568 1299.37 587.672Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 563.588C1285.59 568.691 1281.5 572.822 1276.45 572.822C1271.41 572.822 1267.31 568.691 1267.31 563.588C1267.31 558.484 1271.41 554.354 1276.45 554.354C1281.5 554.354 1285.59 558.484 1285.59 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 539.504C1271.82 544.608 1267.73 548.738 1262.68 548.738C1257.64 548.738 1253.54 544.608 1253.54 539.504C1253.54 534.401 1257.64 530.27 1262.68 530.27C1267.73 530.27 1271.82 534.401 1271.82 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 515.417C1258.05 520.52 1253.96 524.651 1248.91 524.651C1243.87 524.651 1239.77 520.52 1239.77 515.417C1239.77 510.313 1243.87 506.183 1248.91 506.183C1253.96 506.183 1258.05 510.313 1258.05 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 491.333C1244.28 496.436 1240.19 500.567 1235.14 500.567C1230.1 500.567 1226 496.436 1226 491.333C1226 486.229 1230.1 482.099 1235.14 482.099C1240.19 482.099 1244.28 486.229 1244.28 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 467.249C1230.51 472.352 1226.42 476.483 1221.37 476.483C1216.33 476.483 1212.23 472.352 1212.23 467.249C1212.23 462.145 1216.33 458.015 1221.37 458.015C1226.42 458.015 1230.51 462.145 1230.51 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 443.162C1216.74 448.265 1212.64 452.396 1207.6 452.396C1202.56 452.396 1198.46 448.266 1198.46 443.162C1198.46 438.059 1202.56 433.928 1207.6 433.928C1212.64 433.928 1216.74 438.059 1216.74 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 419.079C1202.97 424.182 1198.87 428.313 1193.83 428.313C1188.79 428.313 1184.69 424.182 1184.69 419.079C1184.69 413.975 1188.79 409.845 1193.83 409.845C1198.87 409.845 1202.97 413.975 1202.97 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 394.994C1189.2 400.098 1185.1 404.228 1180.06 404.228C1175.01 404.228 1170.92 400.098 1170.92 394.994C1170.92 389.891 1175.01 385.76 1180.06 385.76C1185.1 385.76 1189.2 389.891 1189.2 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 370.908C1175.43 376.011 1171.33 380.142 1166.29 380.142C1161.24 380.142 1157.15 376.011 1157.15 370.908C1157.15 365.804 1161.24 361.674 1166.29 361.674C1171.33 361.674 1175.43 365.804 1175.43 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 346.823C1161.66 351.927 1157.56 356.057 1152.52 356.057C1147.47 356.057 1143.38 351.927 1143.38 346.823C1143.38 341.72 1147.47 337.589 1152.52 337.589C1157.56 337.589 1161.66 341.72 1161.66 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 322.739C1147.89 327.843 1143.79 331.973 1138.75 331.973C1133.7 331.973 1129.61 327.843 1129.61 322.739C1129.61 317.636 1133.7 313.505 1138.75 313.505C1143.79 313.505 1147.89 317.636 1147.89 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 298.653C1134.12 303.756 1130.02 307.887 1124.98 307.887C1119.93 307.887 1115.83 303.756 1115.83 298.653C1115.83 293.549 1119.93 289.419 1124.98 289.419C1130.02 289.419 1134.12 293.549 1134.12 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.8 226.398C1092.8 231.502 1088.71 235.632 1083.66 235.632C1078.62 235.632 1074.52 231.502 1074.52 226.398C1074.52 221.295 1078.62 217.164 1083.66 217.164C1088.71 217.164 1092.8 221.295 1092.8 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.03 202.314C1079.03 207.417 1074.94 211.548 1069.89 211.548C1064.85 211.548 1060.75 207.417 1060.75 202.314C1060.75 197.21 1064.85 193.08 1069.89 193.08C1074.94 193.08 1079.03 197.21 1079.03 202.314Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.95 105.975C1023.95 111.078 1019.85 115.209 1014.81 115.209C1009.76 115.209 1005.67 111.078 1005.67 105.975C1005.67 100.872 1009.76 96.7411 1014.81 96.7411C1019.85 96.7411 1023.95 100.872 1023.95 105.975Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.57 1406.56C1106.57 1411.66 1102.48 1415.79 1097.43 1415.79C1092.39 1415.79 1088.29 1411.66 1088.29 1406.56C1088.29 1401.45 1092.39 1397.32 1097.43 1397.32C1102.48 1397.32 1106.57 1401.45 1106.57 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 1382.47C1120.35 1387.58 1116.25 1391.71 1111.2 1391.71C1106.16 1391.71 1102.06 1387.58 1102.06 1382.47C1102.06 1377.37 1106.16 1373.24 1111.2 1373.24C1116.25 1373.24 1120.35 1377.37 1120.35 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 1358.39C1134.12 1363.49 1130.02 1367.62 1124.98 1367.62C1119.93 1367.62 1115.83 1363.49 1115.83 1358.39C1115.83 1353.29 1119.93 1349.16 1124.98 1349.16C1130.02 1349.16 1134.12 1353.29 1134.12 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 563.588C1313.14 568.691 1309.04 572.822 1303.99 572.822C1298.95 572.822 1294.85 568.691 1294.85 563.588C1294.85 558.484 1298.95 554.354 1303.99 554.354C1309.04 554.354 1313.14 558.484 1313.14 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 539.504C1299.37 544.608 1295.27 548.738 1290.23 548.738C1285.18 548.738 1281.08 544.608 1281.08 539.504C1281.08 534.401 1285.18 530.27 1290.23 530.27C1295.27 530.27 1299.37 534.401 1299.37 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 515.417C1285.59 520.52 1281.5 524.651 1276.45 524.651C1271.41 524.651 1267.31 520.52 1267.31 515.417C1267.31 510.313 1271.41 506.183 1276.45 506.183C1281.5 506.183 1285.59 510.313 1285.59 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 491.333C1271.82 496.436 1267.73 500.567 1262.68 500.567C1257.64 500.567 1253.54 496.436 1253.54 491.333C1253.54 486.229 1257.64 482.099 1262.68 482.099C1267.73 482.099 1271.82 486.229 1271.82 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 467.249C1258.05 472.352 1253.96 476.483 1248.91 476.483C1243.87 476.483 1239.77 472.352 1239.77 467.249C1239.77 462.145 1243.87 458.015 1248.91 458.015C1253.96 458.015 1258.05 462.145 1258.05 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 443.162C1244.28 448.266 1240.19 452.396 1235.14 452.396C1230.1 452.396 1226 448.266 1226 443.162C1226 438.059 1230.1 433.928 1235.14 433.928C1240.19 433.928 1244.28 438.059 1244.28 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 419.079C1230.51 424.182 1226.42 428.313 1221.37 428.313C1216.33 428.313 1212.23 424.182 1212.23 419.079C1212.23 413.975 1216.33 409.845 1221.37 409.845C1226.42 409.845 1230.51 413.975 1230.51 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 394.994C1216.74 400.098 1212.64 404.228 1207.6 404.228C1202.56 404.228 1198.46 400.098 1198.46 394.994C1198.46 389.891 1202.56 385.76 1207.6 385.76C1212.64 385.76 1216.74 389.891 1216.74 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 370.908C1202.97 376.011 1198.87 380.142 1193.83 380.142C1188.79 380.142 1184.69 376.011 1184.69 370.908C1184.69 365.804 1188.79 361.674 1193.83 361.674C1198.87 361.674 1202.97 365.804 1202.97 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 346.823C1189.2 351.927 1185.1 356.057 1180.06 356.057C1175.01 356.057 1170.92 351.927 1170.92 346.823C1170.92 341.72 1175.01 337.589 1180.06 337.589C1185.1 337.589 1189.2 341.72 1189.2 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 322.739C1175.43 327.843 1171.33 331.973 1166.29 331.973C1161.24 331.973 1157.15 327.843 1157.15 322.739C1157.15 317.636 1161.24 313.505 1166.29 313.505C1171.33 313.505 1175.43 317.636 1175.43 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 1430.64C1120.35 1435.75 1116.25 1439.88 1111.2 1439.88C1106.16 1439.88 1102.06 1435.75 1102.06 1430.64C1102.06 1425.54 1106.16 1421.41 1111.2 1421.41C1116.25 1421.41 1120.35 1425.54 1120.35 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 1406.56C1134.12 1411.66 1130.02 1415.79 1124.98 1415.79C1119.93 1415.79 1115.83 1411.66 1115.83 1406.56C1115.83 1401.45 1119.93 1397.32 1124.98 1397.32C1130.02 1397.32 1134.12 1401.45 1134.12 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 1382.47C1147.89 1387.58 1143.79 1391.71 1138.75 1391.71C1133.7 1391.71 1129.61 1387.58 1129.61 1382.47C1129.61 1377.37 1133.7 1373.24 1138.75 1373.24C1143.79 1373.24 1147.89 1377.37 1147.89 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 1358.39C1161.66 1363.49 1157.56 1367.62 1152.52 1367.62C1147.47 1367.62 1143.38 1363.49 1143.38 1358.39C1143.38 1353.29 1147.47 1349.16 1152.52 1349.16C1157.56 1349.16 1161.66 1353.29 1161.66 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 1334.31C1175.43 1339.41 1171.33 1343.54 1166.29 1343.54C1161.24 1343.54 1157.15 1339.41 1157.15 1334.31C1157.15 1329.2 1161.24 1325.07 1166.29 1325.07C1171.33 1325.07 1175.43 1329.2 1175.43 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 1310.22C1189.2 1315.32 1185.1 1319.45 1180.06 1319.45C1175.01 1319.45 1170.92 1315.32 1170.92 1310.22C1170.92 1305.12 1175.01 1300.98 1180.06 1300.98C1185.1 1300.98 1189.2 1305.12 1189.2 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 1189.8C1258.05 1194.9 1253.96 1199.03 1248.91 1199.03C1243.87 1199.03 1239.77 1194.9 1239.77 1189.8C1239.77 1184.69 1243.87 1180.56 1248.91 1180.56C1253.96 1180.56 1258.05 1184.69 1258.05 1189.8Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.87 1121.54C1460.24 1118.99 1465.83 1120.5 1468.36 1124.92C1470.88 1129.34 1469.38 1134.98 1465.01 1137.53C1460.64 1140.08 1455.05 1138.57 1452.52 1134.15C1450 1129.73 1451.5 1124.08 1455.87 1121.54Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 563.588C1340.68 568.691 1336.58 572.822 1331.54 572.822C1326.49 572.822 1322.4 568.691 1322.4 563.588C1322.4 558.484 1326.49 554.354 1331.54 554.354C1336.58 554.354 1340.68 558.484 1340.68 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 539.504C1326.91 544.608 1322.81 548.738 1317.77 548.738C1312.72 548.738 1308.62 544.608 1308.62 539.504C1308.62 534.401 1312.72 530.27 1317.77 530.27C1322.81 530.27 1326.91 534.401 1326.91 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 515.417C1313.14 520.52 1309.04 524.651 1303.99 524.651C1298.95 524.651 1294.85 520.52 1294.85 515.417C1294.85 510.313 1298.95 506.183 1303.99 506.183C1309.04 506.183 1313.14 510.313 1313.14 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 491.333C1299.37 496.436 1295.27 500.567 1290.23 500.567C1285.18 500.567 1281.08 496.436 1281.08 491.333C1281.08 486.229 1285.18 482.099 1290.23 482.099C1295.27 482.099 1299.37 486.229 1299.37 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 467.249C1285.59 472.352 1281.5 476.483 1276.45 476.483C1271.41 476.483 1267.31 472.352 1267.31 467.249C1267.31 462.145 1271.41 458.015 1276.45 458.015C1281.5 458.015 1285.59 462.145 1285.59 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 443.162C1271.82 448.266 1267.73 452.396 1262.68 452.396C1257.64 452.396 1253.54 448.265 1253.54 443.162C1253.54 438.059 1257.64 433.928 1262.68 433.928C1267.73 433.928 1271.82 438.059 1271.82 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 419.079C1258.05 424.182 1253.96 428.313 1248.91 428.313C1243.87 428.313 1239.77 424.182 1239.77 419.079C1239.77 413.975 1243.87 409.845 1248.91 409.845C1253.96 409.845 1258.05 413.975 1258.05 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 394.994C1244.28 400.098 1240.19 404.228 1235.14 404.228C1230.1 404.228 1226 400.098 1226 394.994C1226 389.891 1230.1 385.76 1235.14 385.76C1240.19 385.76 1244.28 389.891 1244.28 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 370.908C1230.51 376.011 1226.42 380.142 1221.37 380.142C1216.33 380.142 1212.23 376.011 1212.23 370.908C1212.23 365.804 1216.33 361.674 1221.37 361.674C1226.42 361.674 1230.51 365.804 1230.51 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 346.823C1216.74 351.927 1212.64 356.057 1207.6 356.057C1202.56 356.057 1198.46 351.927 1198.46 346.823C1198.46 341.72 1202.56 337.589 1207.6 337.589C1212.64 337.589 1216.74 341.72 1216.74 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 322.739C1202.97 327.843 1198.87 331.973 1193.83 331.973C1188.79 331.973 1184.69 327.843 1184.69 322.739C1184.69 317.636 1188.79 313.505 1193.83 313.505C1198.87 313.505 1202.97 317.636 1202.97 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 298.653C1189.2 303.756 1185.1 307.887 1180.06 307.887C1175.01 307.887 1170.92 303.756 1170.92 298.653C1170.92 293.549 1175.01 289.419 1180.06 289.419C1185.1 289.419 1189.2 293.549 1189.2 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.35 1478.81C1120.35 1483.92 1116.25 1488.05 1111.2 1488.05C1106.16 1488.05 1102.06 1483.92 1102.06 1478.81C1102.06 1473.71 1106.16 1469.58 1111.2 1469.58C1116.25 1469.58 1120.35 1473.71 1120.35 1478.81Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.12 1454.73C1134.12 1459.83 1130.02 1463.96 1124.98 1463.96C1119.93 1463.96 1115.83 1459.83 1115.83 1454.73C1115.83 1449.63 1119.93 1445.5 1124.98 1445.5C1130.02 1445.5 1134.12 1449.63 1134.12 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.89 1430.64C1147.89 1435.75 1143.79 1439.88 1138.75 1439.88C1133.7 1439.88 1129.61 1435.75 1129.61 1430.64C1129.61 1425.54 1133.7 1421.41 1138.75 1421.41C1143.79 1421.41 1147.89 1425.54 1147.89 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 1406.56C1161.66 1411.66 1157.56 1415.79 1152.52 1415.79C1147.47 1415.79 1143.38 1411.66 1143.38 1406.56C1143.38 1401.45 1147.47 1397.32 1152.52 1397.32C1157.56 1397.32 1161.66 1401.45 1161.66 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 1382.47C1175.43 1387.58 1171.33 1391.71 1166.29 1391.71C1161.24 1391.71 1157.15 1387.58 1157.15 1382.47C1157.15 1377.37 1161.24 1373.24 1166.29 1373.24C1171.33 1373.24 1175.43 1377.37 1175.43 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 1358.39C1189.2 1363.49 1185.1 1367.62 1180.06 1367.62C1175.01 1367.62 1170.92 1363.49 1170.92 1358.39C1170.92 1353.29 1175.01 1349.16 1180.06 1349.16C1185.1 1349.16 1189.2 1353.29 1189.2 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 1334.31C1202.97 1339.41 1198.87 1343.54 1193.83 1343.54C1188.78 1343.54 1184.69 1339.41 1184.69 1334.31C1184.69 1329.2 1188.78 1325.07 1193.83 1325.07C1198.87 1325.07 1202.97 1329.2 1202.97 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 1310.22C1216.74 1315.32 1212.64 1319.45 1207.6 1319.45C1202.55 1319.45 1198.46 1315.32 1198.46 1310.22C1198.46 1305.12 1202.55 1300.98 1207.6 1300.98C1212.64 1300.98 1216.74 1305.12 1216.74 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 1286.13C1230.51 1291.24 1226.41 1295.37 1221.37 1295.37C1216.33 1295.37 1212.23 1291.24 1212.23 1286.13C1212.23 1281.03 1216.33 1276.9 1221.37 1276.9C1226.41 1276.9 1230.51 1281.03 1230.51 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 1213.88C1271.82 1218.98 1267.73 1223.11 1262.68 1223.11C1257.64 1223.11 1253.54 1218.98 1253.54 1213.88C1253.54 1208.78 1257.64 1204.65 1262.68 1204.65C1267.73 1204.65 1271.82 1208.78 1271.82 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.63 1097.45C1474 1094.9 1479.6 1096.41 1482.12 1100.83C1484.65 1105.25 1483.15 1110.9 1478.78 1113.44C1474.41 1115.99 1468.82 1114.48 1466.29 1110.06C1463.77 1105.64 1465.26 1100 1469.63 1097.45Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 563.588C1368.22 568.691 1364.12 572.822 1359.08 572.822C1354.03 572.822 1349.94 568.691 1349.94 563.588C1349.94 558.484 1354.03 554.354 1359.08 554.354C1364.12 554.354 1368.22 558.484 1368.22 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 539.504C1354.45 544.608 1350.35 548.738 1345.31 548.738C1340.26 548.738 1336.17 544.608 1336.17 539.504C1336.17 534.401 1340.26 530.27 1345.31 530.27C1350.35 530.27 1354.45 534.401 1354.45 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 515.417C1340.68 520.52 1336.58 524.651 1331.54 524.651C1326.49 524.651 1322.4 520.52 1322.4 515.417C1322.4 510.313 1326.49 506.183 1331.54 506.183C1336.58 506.183 1340.68 510.313 1340.68 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 491.333C1326.91 496.436 1322.81 500.567 1317.77 500.567C1312.72 500.567 1308.62 496.436 1308.62 491.333C1308.62 486.229 1312.72 482.099 1317.77 482.099C1322.81 482.099 1326.91 486.229 1326.91 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 467.249C1313.14 472.352 1309.04 476.483 1303.99 476.483C1298.95 476.483 1294.85 472.352 1294.85 467.249C1294.85 462.145 1298.95 458.015 1303.99 458.015C1309.04 458.015 1313.14 462.145 1313.14 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 443.162C1299.37 448.266 1295.27 452.396 1290.23 452.396C1285.18 452.396 1281.08 448.266 1281.08 443.162C1281.08 438.059 1285.18 433.928 1290.23 433.928C1295.27 433.928 1299.37 438.059 1299.37 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 419.079C1285.59 424.182 1281.5 428.313 1276.45 428.313C1271.41 428.313 1267.31 424.182 1267.31 419.079C1267.31 413.975 1271.41 409.845 1276.45 409.845C1281.5 409.845 1285.59 413.975 1285.59 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 394.994C1271.82 400.098 1267.73 404.228 1262.68 404.228C1257.64 404.228 1253.54 400.098 1253.54 394.994C1253.54 389.891 1257.64 385.76 1262.68 385.76C1267.73 385.76 1271.82 389.891 1271.82 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 370.908C1258.05 376.011 1253.96 380.142 1248.91 380.142C1243.87 380.142 1239.77 376.011 1239.77 370.908C1239.77 365.804 1243.87 361.674 1248.91 361.674C1253.96 361.674 1258.05 365.804 1258.05 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 346.823C1244.28 351.927 1240.19 356.057 1235.14 356.057C1230.1 356.057 1226 351.927 1226 346.823C1226 341.72 1230.1 337.589 1235.14 337.589C1240.19 337.589 1244.28 341.72 1244.28 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 298.653C1216.74 303.756 1212.64 307.887 1207.6 307.887C1202.56 307.887 1198.46 303.756 1198.46 298.653C1198.46 293.549 1202.56 289.419 1207.6 289.419C1212.64 289.419 1216.74 293.549 1216.74 298.653Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.66 1454.73C1161.66 1459.83 1157.56 1463.96 1152.52 1463.96C1147.47 1463.96 1143.38 1459.83 1143.38 1454.73C1143.38 1449.63 1147.47 1445.5 1152.52 1445.5C1157.56 1445.5 1161.66 1449.63 1161.66 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.43 1430.64C1175.43 1435.75 1171.33 1439.88 1166.29 1439.88C1161.24 1439.88 1157.15 1435.75 1157.15 1430.64C1157.15 1425.54 1161.24 1421.41 1166.29 1421.41C1171.33 1421.41 1175.43 1425.54 1175.43 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 1406.56C1189.2 1411.66 1185.1 1415.79 1180.06 1415.79C1175.01 1415.79 1170.92 1411.66 1170.92 1406.56C1170.92 1401.45 1175.01 1397.32 1180.06 1397.32C1185.1 1397.32 1189.2 1401.45 1189.2 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 1382.47C1202.97 1387.58 1198.87 1391.71 1193.83 1391.71C1188.78 1391.71 1184.69 1387.58 1184.69 1382.47C1184.69 1377.37 1188.78 1373.24 1193.83 1373.24C1198.87 1373.24 1202.97 1377.37 1202.97 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 1358.39C1216.74 1363.49 1212.64 1367.62 1207.6 1367.62C1202.55 1367.62 1198.46 1363.49 1198.46 1358.39C1198.46 1353.29 1202.55 1349.16 1207.6 1349.16C1212.64 1349.16 1216.74 1353.29 1216.74 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 1334.31C1230.51 1339.41 1226.41 1343.54 1221.37 1343.54C1216.33 1343.54 1212.23 1339.41 1212.23 1334.31C1212.23 1329.2 1216.33 1325.07 1221.37 1325.07C1226.41 1325.07 1230.51 1329.2 1230.51 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 1310.22C1244.28 1315.32 1240.19 1319.45 1235.14 1319.45C1230.1 1319.45 1226 1315.32 1226 1310.22C1226 1305.12 1230.1 1300.98 1235.14 1300.98C1240.19 1300.98 1244.28 1305.12 1244.28 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 1286.13C1258.05 1291.24 1253.96 1295.37 1248.91 1295.37C1243.87 1295.37 1239.77 1291.24 1239.77 1286.13C1239.77 1281.03 1243.87 1276.9 1248.91 1276.9C1253.96 1276.9 1258.05 1281.03 1258.05 1286.13Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 1213.88C1299.37 1218.98 1295.27 1223.11 1290.23 1223.11C1285.18 1223.11 1281.08 1218.98 1281.08 1213.88C1281.08 1208.78 1285.18 1204.65 1290.23 1204.65C1295.27 1204.65 1299.37 1208.78 1299.37 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.86 1073.36C1460.23 1070.81 1465.83 1072.32 1468.35 1076.74C1470.88 1081.16 1469.38 1086.81 1465.01 1089.35C1460.64 1091.9 1455.05 1090.39 1452.52 1085.97C1449.99 1081.55 1451.49 1075.91 1455.86 1073.36Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 659.927C1450.84 665.03 1446.75 669.161 1441.7 669.161C1436.66 669.161 1432.56 665.03 1432.56 659.927C1432.56 654.823 1436.66 650.693 1441.7 650.693C1446.75 650.693 1450.84 654.823 1450.84 659.927Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.07 635.842C1437.07 640.946 1432.98 645.076 1427.93 645.076C1422.89 645.076 1418.79 640.946 1418.79 635.842C1418.79 630.739 1422.89 626.608 1427.93 626.608C1432.98 626.608 1437.07 630.739 1437.07 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 563.588C1395.76 568.691 1391.67 572.822 1386.62 572.822C1381.58 572.822 1377.48 568.691 1377.48 563.588C1377.48 558.484 1381.58 554.354 1386.62 554.354C1391.67 554.354 1395.76 558.484 1395.76 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 539.504C1381.99 544.608 1377.89 548.738 1372.85 548.738C1367.8 548.738 1363.71 544.608 1363.71 539.504C1363.71 534.401 1367.8 530.27 1372.85 530.27C1377.89 530.27 1381.99 534.401 1381.99 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 515.417C1368.22 520.52 1364.12 524.651 1359.08 524.651C1354.03 524.651 1349.94 520.52 1349.94 515.417C1349.94 510.313 1354.03 506.183 1359.08 506.183C1364.12 506.183 1368.22 510.313 1368.22 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 491.333C1354.45 496.436 1350.35 500.567 1345.31 500.567C1340.26 500.567 1336.17 496.436 1336.17 491.333C1336.17 486.229 1340.26 482.099 1345.31 482.099C1350.35 482.099 1354.45 486.229 1354.45 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 467.249C1340.68 472.352 1336.58 476.483 1331.54 476.483C1326.49 476.483 1322.4 472.352 1322.4 467.249C1322.4 462.145 1326.49 458.015 1331.54 458.015C1336.58 458.015 1340.68 462.145 1340.68 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 443.162C1326.91 448.266 1322.81 452.396 1317.77 452.396C1312.72 452.396 1308.62 448.265 1308.62 443.162C1308.62 438.059 1312.72 433.928 1317.77 433.928C1322.81 433.928 1326.91 438.059 1326.91 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 419.079C1313.14 424.182 1309.04 428.313 1303.99 428.313C1298.95 428.313 1294.85 424.182 1294.85 419.079C1294.85 413.975 1298.95 409.845 1303.99 409.845C1309.04 409.845 1313.14 413.975 1313.14 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 394.994C1299.37 400.098 1295.27 404.228 1290.23 404.228C1285.18 404.228 1281.08 400.098 1281.08 394.994C1281.08 389.891 1285.18 385.76 1290.23 385.76C1295.27 385.76 1299.37 389.891 1299.37 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 370.908C1285.59 376.011 1281.5 380.142 1276.45 380.142C1271.41 380.142 1267.31 376.011 1267.31 370.908C1267.31 365.804 1271.41 361.674 1276.45 361.674C1281.5 361.674 1285.59 365.804 1285.59 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 346.823C1271.82 351.927 1267.73 356.057 1262.68 356.057C1257.64 356.057 1253.54 351.927 1253.54 346.823C1253.54 341.72 1257.64 337.589 1262.68 337.589C1267.73 337.589 1271.82 341.72 1271.82 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.2 1454.73C1189.2 1459.83 1185.1 1463.96 1180.06 1463.96C1175.01 1463.96 1170.92 1459.83 1170.92 1454.73C1170.92 1449.63 1175.01 1445.5 1180.06 1445.5C1185.1 1445.5 1189.2 1449.63 1189.2 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 1430.64C1202.97 1435.75 1198.87 1439.88 1193.83 1439.88C1188.78 1439.88 1184.69 1435.75 1184.69 1430.64C1184.69 1425.54 1188.78 1421.41 1193.83 1421.41C1198.87 1421.41 1202.97 1425.54 1202.97 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.74 1406.56C1216.74 1411.66 1212.64 1415.79 1207.6 1415.79C1202.55 1415.79 1198.46 1411.66 1198.46 1406.56C1198.46 1401.45 1202.55 1397.32 1207.6 1397.32C1212.64 1397.32 1216.74 1401.45 1216.74 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 1382.47C1230.51 1387.58 1226.41 1391.71 1221.37 1391.71C1216.33 1391.71 1212.23 1387.58 1212.23 1382.47C1212.23 1377.37 1216.33 1373.24 1221.37 1373.24C1226.41 1373.24 1230.51 1377.37 1230.51 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 1358.39C1244.28 1363.49 1240.19 1367.62 1235.14 1367.62C1230.1 1367.62 1226 1363.49 1226 1358.39C1226 1353.29 1230.1 1349.16 1235.14 1349.16C1240.19 1349.16 1244.28 1353.29 1244.28 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 1334.31C1258.05 1339.41 1253.96 1343.54 1248.91 1343.54C1243.87 1343.54 1239.77 1339.41 1239.77 1334.31C1239.77 1329.2 1243.87 1325.07 1248.91 1325.07C1253.96 1325.07 1258.05 1329.2 1258.05 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 1310.22C1271.82 1315.32 1267.73 1319.45 1262.68 1319.45C1257.64 1319.45 1253.54 1315.32 1253.54 1310.22C1253.54 1305.12 1257.64 1300.98 1262.68 1300.98C1267.73 1300.98 1271.82 1305.12 1271.82 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 1237.96C1313.14 1243.07 1309.04 1247.2 1303.99 1247.2C1298.95 1247.2 1294.85 1243.07 1294.85 1237.96C1294.85 1232.86 1298.95 1228.73 1303.99 1228.73C1309.04 1228.73 1313.14 1232.86 1313.14 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.63 1049.27C1474 1046.73 1479.59 1048.24 1482.12 1052.66C1484.65 1057.08 1483.15 1062.72 1478.78 1065.27C1474.41 1067.82 1468.81 1066.31 1466.29 1061.89C1463.76 1057.47 1465.26 1051.82 1469.63 1049.27Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1213.88C1326.91 1218.98 1322.81 1223.11 1317.77 1223.11C1312.72 1223.11 1308.62 1218.98 1308.62 1213.88C1308.62 1208.78 1312.72 1204.65 1317.77 1204.65C1322.81 1204.65 1326.91 1208.78 1326.91 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.09 1049.27C1446.46 1046.72 1452.06 1048.24 1454.58 1052.65C1457.11 1057.07 1455.61 1062.72 1451.24 1065.27C1446.87 1067.82 1441.28 1066.3 1438.75 1061.89C1436.22 1057.47 1437.72 1051.82 1442.09 1049.27Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.61 635.842C1464.61 640.946 1460.52 645.076 1455.47 645.076C1450.43 645.076 1446.33 640.946 1446.33 635.842C1446.33 630.739 1450.43 626.608 1455.47 626.608C1460.52 626.608 1464.61 630.739 1464.61 635.842Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 611.758C1450.84 616.862 1446.75 620.992 1441.7 620.992C1436.66 620.992 1432.56 616.862 1432.56 611.758C1432.56 606.655 1436.66 602.525 1441.7 602.525C1446.75 602.525 1450.84 606.655 1450.84 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 563.588C1423.3 568.691 1419.21 572.822 1414.16 572.822C1409.12 572.822 1405.02 568.691 1405.02 563.588C1405.02 558.484 1409.12 554.354 1414.16 554.354C1419.21 554.354 1423.3 558.484 1423.3 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 539.504C1409.53 544.608 1405.44 548.738 1400.39 548.738C1395.35 548.738 1391.25 544.608 1391.25 539.504C1391.25 534.401 1395.35 530.27 1400.39 530.27C1405.44 530.27 1409.53 534.401 1409.53 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 515.417C1395.76 520.52 1391.67 524.651 1386.62 524.651C1381.58 524.651 1377.48 520.52 1377.48 515.417C1377.48 510.313 1381.58 506.183 1386.62 506.183C1391.67 506.183 1395.76 510.313 1395.76 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 491.333C1381.99 496.436 1377.89 500.567 1372.85 500.567C1367.8 500.567 1363.71 496.436 1363.71 491.333C1363.71 486.229 1367.8 482.099 1372.85 482.099C1377.89 482.099 1381.99 486.229 1381.99 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 467.249C1368.22 472.352 1364.12 476.483 1359.08 476.483C1354.03 476.483 1349.94 472.352 1349.94 467.249C1349.94 462.145 1354.03 458.015 1359.08 458.015C1364.12 458.015 1368.22 462.145 1368.22 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 443.162C1354.45 448.266 1350.35 452.396 1345.31 452.396C1340.26 452.396 1336.17 448.266 1336.17 443.162C1336.17 438.059 1340.26 433.928 1345.31 433.928C1350.35 433.928 1354.45 438.059 1354.45 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 419.079C1340.68 424.182 1336.58 428.313 1331.54 428.313C1326.49 428.313 1322.4 424.182 1322.4 419.079C1322.4 413.975 1326.49 409.845 1331.54 409.845C1336.58 409.845 1340.68 413.975 1340.68 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 394.994C1326.91 400.098 1322.81 404.228 1317.77 404.228C1312.72 404.228 1308.62 400.098 1308.62 394.994C1308.62 389.891 1312.72 385.76 1317.77 385.76C1322.81 385.76 1326.91 389.891 1326.91 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 370.908C1313.14 376.011 1309.04 380.142 1303.99 380.142C1298.95 380.142 1294.85 376.011 1294.85 370.908C1294.85 365.804 1298.95 361.674 1303.99 361.674C1309.04 361.674 1313.14 365.804 1313.14 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 346.823C1299.37 351.927 1295.27 356.057 1290.23 356.057C1285.18 356.057 1281.08 351.927 1281.08 346.823C1281.08 341.72 1285.18 337.589 1290.23 337.589C1295.27 337.589 1299.37 341.72 1299.37 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.51 1430.64C1230.51 1435.75 1226.41 1439.88 1221.37 1439.88C1216.33 1439.88 1212.23 1435.75 1212.23 1430.64C1212.23 1425.54 1216.33 1421.41 1221.37 1421.41C1226.41 1421.41 1230.51 1425.54 1230.51 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.28 1406.56C1244.28 1411.66 1240.19 1415.79 1235.14 1415.79C1230.1 1415.79 1226 1411.66 1226 1406.56C1226 1401.45 1230.1 1397.32 1235.14 1397.32C1240.19 1397.32 1244.28 1401.45 1244.28 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 1382.47C1258.05 1387.58 1253.96 1391.71 1248.91 1391.71C1243.87 1391.71 1239.77 1387.58 1239.77 1382.47C1239.77 1377.37 1243.87 1373.24 1248.91 1373.24C1253.96 1373.24 1258.05 1377.37 1258.05 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 1358.39C1271.82 1363.49 1267.73 1367.62 1262.68 1367.62C1257.64 1367.62 1253.54 1363.49 1253.54 1358.39C1253.54 1353.29 1257.64 1349.16 1262.68 1349.16C1267.73 1349.16 1271.82 1353.29 1271.82 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 1334.31C1285.59 1339.41 1281.5 1343.54 1276.45 1343.54C1271.41 1343.54 1267.31 1339.41 1267.31 1334.31C1267.31 1329.2 1271.41 1325.07 1276.45 1325.07C1281.5 1325.07 1285.59 1329.2 1285.59 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 1237.96C1340.68 1243.07 1336.58 1247.2 1331.54 1247.2C1326.49 1247.2 1322.4 1243.07 1322.4 1237.96C1322.4 1232.86 1326.49 1228.73 1331.54 1228.73C1336.58 1228.73 1340.68 1232.86 1340.68 1237.96Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.86 1025.19C1460.23 1022.64 1465.82 1024.15 1468.35 1028.57C1470.87 1032.99 1469.37 1038.63 1465 1041.18C1460.63 1043.73 1455.04 1042.22 1452.52 1037.8C1449.99 1033.38 1451.49 1027.73 1455.86 1025.19Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.38 611.758C1478.38 616.862 1474.29 620.992 1469.24 620.992C1464.2 620.992 1460.1 616.862 1460.1 611.758C1460.1 606.655 1464.2 602.525 1469.24 602.525C1474.29 602.525 1478.38 606.655 1478.38 611.758Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.12 587.673C1460.12 590.273 1458.04 592.373 1455.47 592.373C1452.91 592.373 1450.82 590.273 1450.82 587.673C1450.82 585.073 1452.91 582.973 1455.47 582.973C1458.04 582.973 1460.12 585.073 1460.12 587.673Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.07 539.504C1437.07 544.608 1432.98 548.738 1427.93 548.738C1422.89 548.738 1418.79 544.608 1418.79 539.504C1418.79 534.401 1422.89 530.27 1427.93 530.27C1432.98 530.27 1437.07 534.401 1437.07 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 515.417C1423.3 520.52 1419.21 524.651 1414.16 524.651C1409.12 524.651 1405.02 520.52 1405.02 515.417C1405.02 510.313 1409.12 506.183 1414.16 506.183C1419.21 506.183 1423.3 510.313 1423.3 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 491.333C1409.53 496.436 1405.44 500.567 1400.39 500.567C1395.35 500.567 1391.25 496.436 1391.25 491.333C1391.25 486.229 1395.35 482.099 1400.39 482.099C1405.44 482.099 1409.53 486.229 1409.53 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 467.249C1395.76 472.352 1391.67 476.483 1386.62 476.483C1381.58 476.483 1377.48 472.352 1377.48 467.249C1377.48 462.145 1381.58 458.015 1386.62 458.015C1391.67 458.015 1395.76 462.145 1395.76 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 443.162C1381.99 448.266 1377.89 452.396 1372.85 452.396C1367.8 452.396 1363.71 448.266 1363.71 443.162C1363.71 438.059 1367.8 433.928 1372.85 433.928C1377.89 433.928 1381.99 438.059 1381.99 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 419.079C1368.22 424.182 1364.12 428.313 1359.08 428.313C1354.03 428.313 1349.94 424.182 1349.94 419.079C1349.94 413.975 1354.03 409.845 1359.08 409.845C1364.12 409.845 1368.22 413.975 1368.22 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 394.994C1354.45 400.098 1350.35 404.228 1345.31 404.228C1340.26 404.228 1336.17 400.098 1336.17 394.994C1336.17 389.891 1340.26 385.76 1345.31 385.76C1350.35 385.76 1354.45 389.891 1354.45 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 370.908C1340.68 376.011 1336.58 380.142 1331.54 380.142C1326.49 380.142 1322.4 376.011 1322.4 370.908C1322.4 365.804 1326.49 361.674 1331.54 361.674C1336.58 361.674 1340.68 365.804 1340.68 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 346.823C1326.91 351.927 1322.81 356.057 1317.77 356.057C1312.72 356.057 1308.62 351.927 1308.62 346.823C1308.62 341.72 1312.72 337.589 1317.77 337.589C1322.81 337.589 1326.91 341.72 1326.91 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 322.739C1313.14 327.843 1309.04 331.973 1303.99 331.973C1298.95 331.973 1294.85 327.843 1294.85 322.739C1294.85 317.636 1298.95 313.505 1303.99 313.505C1309.04 313.505 1313.14 317.636 1313.14 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.05 1430.64C1258.05 1435.75 1253.96 1439.88 1248.91 1439.88C1243.87 1439.88 1239.77 1435.75 1239.77 1430.64C1239.77 1425.54 1243.87 1421.41 1248.91 1421.41C1253.96 1421.41 1258.05 1425.54 1258.05 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 1406.56C1271.82 1411.66 1267.73 1415.79 1262.68 1415.79C1257.64 1415.79 1253.54 1411.66 1253.54 1406.56C1253.54 1401.45 1257.64 1397.32 1262.68 1397.32C1267.73 1397.32 1271.82 1401.45 1271.82 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 1382.47C1285.59 1387.58 1281.5 1391.71 1276.45 1391.71C1271.41 1391.71 1267.31 1387.58 1267.31 1382.47C1267.31 1377.37 1271.41 1373.24 1276.45 1373.24C1281.5 1373.24 1285.59 1377.37 1285.59 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 1358.39C1299.37 1363.49 1295.27 1367.62 1290.23 1367.62C1285.18 1367.62 1281.08 1363.49 1281.08 1358.39C1281.08 1353.29 1285.18 1349.16 1290.23 1349.16C1295.27 1349.16 1299.37 1353.29 1299.37 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 1334.31C1313.14 1339.41 1309.04 1343.54 1303.99 1343.54C1298.95 1343.54 1294.85 1339.41 1294.85 1334.31C1294.85 1329.2 1298.95 1325.07 1303.99 1325.07C1309.04 1325.07 1313.14 1329.2 1313.14 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1310.22C1326.91 1315.32 1322.81 1319.45 1317.77 1319.45C1312.72 1319.45 1308.62 1315.32 1308.62 1310.22C1308.62 1305.12 1312.72 1300.98 1317.77 1300.98C1322.81 1300.98 1326.91 1305.12 1326.91 1310.22Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 515.417C1450.84 520.52 1446.75 524.651 1441.7 524.651C1436.66 524.651 1432.56 520.52 1432.56 515.417C1432.56 510.313 1436.66 506.183 1441.7 506.183C1446.75 506.183 1450.84 510.313 1450.84 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.07 491.333C1437.07 496.436 1432.98 500.567 1427.93 500.567C1422.89 500.567 1418.79 496.436 1418.79 491.333C1418.79 486.229 1422.89 482.099 1427.93 482.099C1432.98 482.099 1437.07 486.229 1437.07 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 467.249C1423.3 472.352 1419.21 476.483 1414.16 476.483C1409.12 476.483 1405.02 472.352 1405.02 467.249C1405.02 462.145 1409.12 458.015 1414.16 458.015C1419.21 458.015 1423.3 462.145 1423.3 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 443.162C1409.53 448.265 1405.44 452.396 1400.39 452.396C1395.35 452.396 1391.25 448.266 1391.25 443.162C1391.25 438.059 1395.35 433.928 1400.39 433.928C1405.44 433.928 1409.53 438.059 1409.53 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 419.079C1395.76 424.182 1391.67 428.313 1386.62 428.313C1381.58 428.313 1377.48 424.182 1377.48 419.079C1377.48 413.975 1381.58 409.845 1386.62 409.845C1391.67 409.845 1395.76 413.975 1395.76 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 394.994C1381.99 400.098 1377.89 404.228 1372.85 404.228C1367.8 404.228 1363.71 400.098 1363.71 394.994C1363.71 389.891 1367.8 385.76 1372.85 385.76C1377.89 385.76 1381.99 389.891 1381.99 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 370.908C1368.22 376.011 1364.12 380.142 1359.08 380.142C1354.03 380.142 1349.94 376.011 1349.94 370.908C1349.94 365.804 1354.03 361.674 1359.08 361.674C1364.12 361.674 1368.22 365.804 1368.22 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 346.823C1354.45 351.927 1350.35 356.057 1345.31 356.057C1340.26 356.057 1336.17 351.927 1336.17 346.823C1336.17 341.72 1340.26 337.589 1345.31 337.589C1350.35 337.589 1354.45 341.72 1354.45 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 322.739C1340.68 327.843 1336.58 331.973 1331.54 331.973C1326.49 331.973 1322.4 327.843 1322.4 322.739C1322.4 317.636 1326.49 313.505 1331.54 313.505C1336.58 313.505 1340.68 317.636 1340.68 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 226.398C1285.59 231.502 1281.5 235.632 1276.45 235.632C1271.41 235.632 1267.31 231.502 1267.31 226.398C1267.31 221.295 1271.41 217.164 1276.45 217.164C1281.5 217.164 1285.59 221.295 1285.59 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.82 1454.73C1271.82 1459.83 1267.73 1463.96 1262.68 1463.96C1257.64 1463.96 1253.54 1459.83 1253.54 1454.73C1253.54 1449.63 1257.64 1445.5 1262.68 1445.5C1267.73 1445.5 1271.82 1449.63 1271.82 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.59 1430.64C1285.59 1435.75 1281.5 1439.88 1276.45 1439.88C1271.41 1439.88 1267.31 1435.75 1267.31 1430.64C1267.31 1425.54 1271.41 1421.41 1276.45 1421.41C1281.5 1421.41 1285.59 1425.54 1285.59 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 1406.56C1299.37 1411.66 1295.27 1415.79 1290.23 1415.79C1285.18 1415.79 1281.08 1411.66 1281.08 1406.56C1281.08 1401.45 1285.18 1397.32 1290.23 1397.32C1295.27 1397.32 1299.37 1401.45 1299.37 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 1382.47C1313.14 1387.58 1309.04 1391.71 1303.99 1391.71C1298.95 1391.71 1294.85 1387.58 1294.85 1382.47C1294.85 1377.37 1298.95 1373.24 1303.99 1373.24C1309.04 1373.24 1313.14 1377.37 1313.14 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1358.39C1326.91 1363.49 1322.81 1367.62 1317.77 1367.62C1312.72 1367.62 1308.62 1363.49 1308.62 1358.39C1308.62 1353.29 1312.72 1349.16 1317.77 1349.16C1322.81 1349.16 1326.91 1353.29 1326.91 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 1334.31C1340.68 1339.41 1336.58 1343.54 1331.54 1343.54C1326.49 1343.54 1322.4 1339.41 1322.4 1334.31C1322.4 1329.2 1326.49 1325.07 1331.54 1325.07C1336.58 1325.07 1340.68 1329.2 1340.68 1334.31Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 1262.05C1381.99 1267.15 1377.89 1271.28 1372.85 1271.28C1367.8 1271.28 1363.71 1267.15 1363.71 1262.05C1363.71 1256.95 1367.8 1252.82 1372.85 1252.82C1377.89 1252.82 1381.99 1256.95 1381.99 1262.05Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.86 977.009C1460.23 974.461 1465.82 975.973 1468.35 980.391C1470.87 984.809 1469.37 990.456 1465 993.004C1460.63 995.552 1455.04 994.04 1452.51 989.622C1449.99 985.203 1451.49 979.557 1455.86 977.009Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 1213.88C1409.53 1218.98 1405.43 1223.11 1400.39 1223.11C1395.35 1223.11 1391.25 1218.98 1391.25 1213.88C1391.25 1208.78 1395.35 1204.65 1400.39 1204.65C1405.43 1204.65 1409.53 1208.78 1409.53 1213.88Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.78 977.006C1405.15 974.458 1410.74 975.969 1413.27 980.388C1415.79 984.806 1414.29 990.452 1409.92 993C1405.55 995.548 1399.96 994.037 1397.44 989.619C1394.91 985.2 1396.41 979.554 1400.78 977.006Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.93 563.588C1505.93 568.691 1501.83 572.822 1496.79 572.822C1491.74 572.822 1487.65 568.691 1487.65 563.588C1487.65 558.484 1491.74 554.354 1496.79 554.354C1501.83 554.354 1505.93 558.484 1505.93 563.588Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.38 515.417C1478.38 520.52 1474.29 524.651 1469.24 524.651C1464.2 524.651 1460.1 520.52 1460.1 515.417C1460.1 510.313 1464.2 506.183 1469.24 506.183C1474.29 506.183 1478.38 510.313 1478.38 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.61 491.333C1464.61 496.436 1460.52 500.567 1455.47 500.567C1450.43 500.567 1446.33 496.436 1446.33 491.333C1446.33 486.229 1450.43 482.099 1455.47 482.099C1460.52 482.099 1464.61 486.229 1464.61 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 467.249C1450.84 472.352 1446.75 476.483 1441.7 476.483C1436.66 476.483 1432.56 472.352 1432.56 467.249C1432.56 462.145 1436.66 458.015 1441.7 458.015C1446.75 458.015 1450.84 462.145 1450.84 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.07 443.162C1437.07 448.266 1432.98 452.396 1427.93 452.396C1422.89 452.396 1418.79 448.266 1418.79 443.162C1418.79 438.059 1422.89 433.928 1427.93 433.928C1432.98 433.928 1437.07 438.059 1437.07 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 419.079C1423.3 424.182 1419.21 428.313 1414.16 428.313C1409.12 428.313 1405.02 424.182 1405.02 419.079C1405.02 413.975 1409.12 409.845 1414.16 409.845C1419.21 409.845 1423.3 413.975 1423.3 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 394.994C1409.53 400.098 1405.44 404.228 1400.39 404.228C1395.35 404.228 1391.25 400.098 1391.25 394.994C1391.25 389.891 1395.35 385.76 1400.39 385.76C1405.44 385.76 1409.53 389.891 1409.53 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 370.908C1395.76 376.011 1391.67 380.142 1386.62 380.142C1381.58 380.142 1377.48 376.011 1377.48 370.908C1377.48 365.804 1381.58 361.674 1386.62 361.674C1391.67 361.674 1395.76 365.804 1395.76 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 346.823C1381.99 351.927 1377.89 356.057 1372.85 356.057C1367.8 356.057 1363.71 351.927 1363.71 346.823C1363.71 341.72 1367.8 337.589 1372.85 337.589C1377.89 337.589 1381.99 341.72 1381.99 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 322.739C1368.22 327.843 1364.12 331.973 1359.08 331.973C1354.03 331.973 1349.94 327.843 1349.94 322.739C1349.94 317.636 1354.03 313.505 1359.08 313.505C1364.12 313.505 1368.22 317.636 1368.22 322.739Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 226.398C1313.14 231.502 1309.04 235.632 1303.99 235.632C1298.95 235.632 1294.85 231.502 1294.85 226.398C1294.85 221.295 1298.95 217.164 1303.99 217.164C1309.04 217.164 1313.14 221.295 1313.14 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 1454.73C1299.37 1459.83 1295.27 1463.96 1290.23 1463.96C1285.18 1463.96 1281.08 1459.83 1281.08 1454.73C1281.08 1449.63 1285.18 1445.5 1290.23 1445.5C1295.27 1445.5 1299.37 1449.63 1299.37 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 1430.64C1313.14 1435.75 1309.04 1439.88 1303.99 1439.88C1298.95 1439.88 1294.85 1435.75 1294.85 1430.64C1294.85 1425.54 1298.95 1421.41 1303.99 1421.41C1309.04 1421.41 1313.14 1425.54 1313.14 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1406.56C1326.91 1411.66 1322.81 1415.79 1317.77 1415.79C1312.72 1415.79 1308.62 1411.66 1308.62 1406.56C1308.62 1401.45 1312.72 1397.32 1317.77 1397.32C1322.81 1397.32 1326.91 1401.45 1326.91 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 1382.47C1340.68 1387.58 1336.58 1391.71 1331.54 1391.71C1326.49 1391.71 1322.4 1387.58 1322.4 1382.47C1322.4 1377.37 1326.49 1373.24 1331.54 1373.24C1336.58 1373.24 1340.68 1377.37 1340.68 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 1358.39C1354.45 1363.49 1350.35 1367.62 1345.31 1367.62C1340.26 1367.62 1336.17 1363.49 1336.17 1358.39C1336.17 1353.29 1340.26 1349.16 1345.31 1349.16C1350.35 1349.16 1354.45 1353.29 1354.45 1358.39Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.7 539.504C1519.7 544.608 1515.6 548.738 1510.56 548.738C1505.51 548.738 1501.42 544.608 1501.42 539.504C1501.42 534.401 1505.51 530.27 1510.56 530.27C1515.6 530.27 1519.7 534.401 1519.7 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.93 515.417C1505.93 520.52 1501.83 524.651 1496.79 524.651C1491.74 524.651 1487.65 520.52 1487.65 515.417C1487.65 510.313 1491.74 506.183 1496.79 506.183C1501.83 506.183 1505.93 510.313 1505.93 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.15 491.333C1492.15 496.436 1488.06 500.567 1483.01 500.567C1477.97 500.567 1473.87 496.436 1473.87 491.333C1473.87 486.229 1477.97 482.099 1483.01 482.099C1488.06 482.099 1492.15 486.229 1492.15 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.38 467.249C1478.38 472.352 1474.29 476.483 1469.24 476.483C1464.2 476.483 1460.1 472.352 1460.1 467.249C1460.1 462.145 1464.2 458.015 1469.24 458.015C1474.29 458.015 1478.38 462.145 1478.38 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.61 443.162C1464.61 448.265 1460.52 452.396 1455.47 452.396C1450.43 452.396 1446.33 448.266 1446.33 443.162C1446.33 438.059 1450.43 433.928 1455.47 433.928C1460.52 433.928 1464.61 438.059 1464.61 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 419.079C1450.84 424.182 1446.75 428.313 1441.7 428.313C1436.66 428.313 1432.56 424.182 1432.56 419.079C1432.56 413.975 1436.66 409.845 1441.7 409.845C1446.75 409.845 1450.84 413.975 1450.84 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.07 394.994C1437.07 400.098 1432.98 404.228 1427.93 404.228C1422.89 404.228 1418.79 400.098 1418.79 394.994C1418.79 389.891 1422.89 385.76 1427.93 385.76C1432.98 385.76 1437.07 389.891 1437.07 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 370.908C1423.3 376.011 1419.21 380.142 1414.16 380.142C1409.12 380.142 1405.02 376.011 1405.02 370.908C1405.02 365.804 1409.12 361.674 1414.16 361.674C1419.21 361.674 1423.3 365.804 1423.3 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 226.398C1340.68 231.502 1336.58 235.632 1331.54 235.632C1326.49 235.632 1322.4 231.502 1322.4 226.398C1322.4 221.295 1326.49 217.164 1331.54 217.164C1336.58 217.164 1340.68 221.295 1340.68 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.14 1478.81C1313.14 1483.92 1309.04 1488.05 1303.99 1488.05C1298.95 1488.05 1294.85 1483.92 1294.85 1478.81C1294.85 1473.71 1298.95 1469.58 1303.99 1469.58C1309.04 1469.58 1313.14 1473.71 1313.14 1478.81Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1454.73C1326.91 1459.83 1322.81 1463.96 1317.77 1463.96C1312.72 1463.96 1308.62 1459.83 1308.62 1454.73C1308.62 1449.63 1312.72 1445.5 1317.77 1445.5C1322.81 1445.5 1326.91 1449.63 1326.91 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 1430.64C1340.68 1435.75 1336.58 1439.88 1331.54 1439.88C1326.49 1439.88 1322.4 1435.75 1322.4 1430.64C1322.4 1425.54 1326.49 1421.41 1331.54 1421.41C1336.58 1421.41 1340.68 1425.54 1340.68 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 1406.56C1354.45 1411.66 1350.35 1415.79 1345.31 1415.79C1340.26 1415.79 1336.17 1411.66 1336.17 1406.56C1336.17 1401.45 1340.26 1397.32 1345.31 1397.32C1350.35 1397.32 1354.45 1401.45 1354.45 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 1382.47C1368.22 1387.58 1364.12 1391.71 1359.08 1391.71C1354.03 1391.71 1349.94 1387.58 1349.94 1382.47C1349.94 1377.37 1354.03 1373.24 1359.08 1373.24C1364.12 1373.24 1368.22 1377.37 1368.22 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.24 539.504C1547.24 544.608 1543.14 548.738 1538.1 548.738C1533.05 548.738 1528.96 544.608 1528.96 539.504C1528.96 534.401 1533.05 530.27 1538.1 530.27C1543.14 530.27 1547.24 534.401 1547.24 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.47 515.417C1533.47 520.52 1529.37 524.651 1524.33 524.651C1519.28 524.651 1515.19 520.52 1515.19 515.417C1515.19 510.313 1519.28 506.183 1524.33 506.183C1529.37 506.183 1533.47 510.313 1533.47 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.7 491.333C1519.7 496.436 1515.6 500.567 1510.56 500.567C1505.51 500.567 1501.42 496.436 1501.42 491.333C1501.42 486.229 1505.51 482.099 1510.56 482.099C1515.6 482.099 1519.7 486.229 1519.7 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.93 467.249C1505.93 472.352 1501.83 476.483 1496.79 476.483C1491.74 476.483 1487.65 472.352 1487.65 467.249C1487.65 462.145 1491.74 458.015 1496.79 458.015C1501.83 458.015 1505.93 462.145 1505.93 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.15 443.162C1492.15 448.266 1488.06 452.396 1483.01 452.396C1477.97 452.396 1473.87 448.266 1473.87 443.162C1473.87 438.059 1477.97 433.928 1483.01 433.928C1488.06 433.928 1492.15 438.059 1492.15 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.38 419.079C1478.38 424.182 1474.29 428.313 1469.24 428.313C1464.2 428.313 1460.1 424.182 1460.1 419.079C1460.1 413.975 1464.2 409.845 1469.24 409.845C1474.29 409.845 1478.38 413.975 1478.38 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.61 394.994C1464.61 400.098 1460.52 404.228 1455.47 404.228C1450.43 404.228 1446.33 400.098 1446.33 394.994C1446.33 389.891 1450.43 385.76 1455.47 385.76C1460.52 385.76 1464.61 389.891 1464.61 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.84 370.908C1450.84 376.011 1446.75 380.142 1441.7 380.142C1436.66 380.142 1432.56 376.011 1432.56 370.908C1432.56 365.804 1436.66 361.674 1441.7 361.674C1446.75 361.674 1450.84 365.804 1450.84 370.908Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 226.398C1368.22 231.502 1364.12 235.632 1359.08 235.632C1354.03 235.632 1349.94 231.502 1349.94 226.398C1349.94 221.295 1354.03 217.164 1359.08 217.164C1364.12 217.164 1368.22 221.295 1368.22 226.398Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91 1502.9C1326.91 1508 1322.81 1512.13 1317.77 1512.13C1312.72 1512.13 1308.62 1508 1308.62 1502.9C1308.62 1497.8 1312.72 1493.67 1317.77 1493.67C1322.81 1493.67 1326.91 1497.8 1326.91 1502.9Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.68 1478.81C1340.68 1483.92 1336.58 1488.05 1331.54 1488.05C1326.49 1488.05 1322.4 1483.92 1322.4 1478.81C1322.4 1473.71 1326.49 1469.58 1331.54 1469.58C1336.58 1469.58 1340.68 1473.71 1340.68 1478.81Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 1454.73C1354.45 1459.83 1350.35 1463.96 1345.31 1463.96C1340.26 1463.96 1336.17 1459.83 1336.17 1454.73C1336.17 1449.63 1340.26 1445.5 1345.31 1445.5C1350.35 1445.5 1354.45 1449.63 1354.45 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 1430.64C1368.22 1435.75 1364.12 1439.88 1359.08 1439.88C1354.03 1439.88 1349.94 1435.75 1349.94 1430.64C1349.94 1425.54 1354.03 1421.41 1359.08 1421.41C1364.12 1421.41 1368.22 1425.54 1368.22 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 1406.56C1381.99 1411.66 1377.89 1415.79 1372.85 1415.79C1367.8 1415.79 1363.71 1411.66 1363.71 1406.56C1363.71 1401.45 1367.8 1397.32 1372.85 1397.32C1377.89 1397.32 1381.99 1401.45 1381.99 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 1382.47C1395.76 1387.58 1391.67 1391.71 1386.62 1391.71C1381.58 1391.71 1377.48 1387.58 1377.48 1382.47C1377.48 1377.37 1381.58 1373.24 1386.62 1373.24C1391.67 1373.24 1395.76 1377.37 1395.76 1382.47Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.78 539.504C1574.78 544.608 1570.69 548.738 1565.64 548.738C1560.6 548.738 1556.5 544.608 1556.5 539.504C1556.5 534.401 1560.6 530.27 1565.64 530.27C1570.69 530.27 1574.78 534.401 1574.78 539.504Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.01 515.417C1561.01 520.52 1556.91 524.651 1551.87 524.651C1546.83 524.651 1542.73 520.52 1542.73 515.417C1542.73 510.313 1546.83 506.183 1551.87 506.183C1556.91 506.183 1561.01 510.313 1561.01 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.24 491.333C1547.24 496.436 1543.14 500.567 1538.1 500.567C1533.05 500.567 1528.96 496.436 1528.96 491.333C1528.96 486.229 1533.05 482.099 1538.1 482.099C1543.14 482.099 1547.24 486.229 1547.24 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.47 467.249C1533.47 472.352 1529.37 476.483 1524.33 476.483C1519.28 476.483 1515.19 472.352 1515.19 467.249C1515.19 462.145 1519.28 458.015 1524.33 458.015C1529.37 458.015 1533.47 462.145 1533.47 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.7 443.162C1519.7 448.266 1515.6 452.396 1510.56 452.396C1505.51 452.396 1501.42 448.265 1501.42 443.162C1501.42 438.059 1505.51 433.928 1510.56 433.928C1515.6 433.928 1519.7 438.059 1519.7 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.93 419.079C1505.93 424.182 1501.83 428.313 1496.79 428.313C1491.74 428.313 1487.65 424.182 1487.65 419.079C1487.65 413.975 1491.74 409.845 1496.79 409.845C1501.83 409.845 1505.93 413.975 1505.93 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.15 394.994C1492.15 400.098 1488.06 404.228 1483.01 404.228C1477.97 404.228 1473.87 400.098 1473.87 394.994C1473.87 389.891 1477.97 385.76 1483.01 385.76C1488.06 385.76 1492.15 389.891 1492.15 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 1502.9C1354.45 1508 1350.35 1512.13 1345.31 1512.13C1340.26 1512.13 1336.17 1508 1336.17 1502.9C1336.17 1497.8 1340.26 1493.67 1345.31 1493.67C1350.35 1493.67 1354.45 1497.8 1354.45 1502.9Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.22 1478.81C1368.22 1483.92 1364.12 1488.05 1359.08 1488.05C1354.03 1488.05 1349.94 1483.92 1349.94 1478.81C1349.94 1473.71 1354.03 1469.58 1359.08 1469.58C1364.12 1469.58 1368.22 1473.71 1368.22 1478.81Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 1454.73C1381.99 1459.83 1377.89 1463.96 1372.85 1463.96C1367.8 1463.96 1363.71 1459.83 1363.71 1454.73C1363.71 1449.63 1367.8 1445.5 1372.85 1445.5C1377.89 1445.5 1381.99 1449.63 1381.99 1454.73Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.76 1430.64C1395.76 1435.75 1391.67 1439.88 1386.62 1439.88C1381.58 1439.88 1377.48 1435.75 1377.48 1430.64C1377.48 1425.54 1381.58 1421.41 1386.62 1421.41C1391.67 1421.41 1395.76 1425.54 1395.76 1430.64Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.53 1406.56C1409.53 1411.66 1405.43 1415.79 1400.39 1415.79C1395.35 1415.79 1391.25 1411.66 1391.25 1406.56C1391.25 1401.45 1395.35 1397.32 1400.39 1397.32C1405.43 1397.32 1409.53 1401.45 1409.53 1406.56Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.55 515.417C1588.55 520.52 1584.46 524.651 1579.41 524.651C1574.37 524.651 1570.27 520.52 1570.27 515.417C1570.27 510.313 1574.37 506.183 1579.41 506.183C1584.46 506.183 1588.55 510.313 1588.55 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.78 491.333C1574.78 496.436 1570.69 500.567 1565.64 500.567C1560.6 500.567 1556.5 496.436 1556.5 491.333C1556.5 486.229 1560.6 482.099 1565.64 482.099C1570.69 482.099 1574.78 486.229 1574.78 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.01 467.249C1561.01 472.352 1556.91 476.483 1551.87 476.483C1546.83 476.483 1542.73 472.352 1542.73 467.249C1542.73 462.145 1546.83 458.015 1551.87 458.015C1556.91 458.015 1561.01 462.145 1561.01 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.24 443.162C1547.24 448.266 1543.14 452.396 1538.1 452.396C1533.05 452.396 1528.96 448.266 1528.96 443.162C1528.96 438.059 1533.05 433.928 1538.1 433.928C1543.14 433.928 1547.24 438.059 1547.24 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.47 419.079C1533.47 424.182 1529.37 428.313 1524.33 428.313C1519.28 428.313 1515.19 424.182 1515.19 419.079C1515.19 413.975 1519.28 409.845 1524.33 409.845C1529.37 409.845 1533.47 413.975 1533.47 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.7 394.994C1519.7 400.098 1515.6 404.228 1510.56 404.228C1505.51 404.228 1501.42 400.098 1501.42 394.994C1501.42 389.891 1505.51 385.76 1510.56 385.76C1515.6 385.76 1519.7 389.891 1519.7 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.45 1551.07C1354.45 1556.17 1350.35 1560.3 1345.31 1560.3C1340.26 1560.3 1336.17 1556.17 1336.17 1551.07C1336.17 1545.96 1340.26 1541.83 1345.31 1541.83C1350.35 1541.83 1354.45 1545.96 1354.45 1551.07Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.99 1502.9C1381.99 1508 1377.89 1512.13 1372.85 1512.13C1367.8 1512.13 1363.71 1508 1363.71 1502.9C1363.71 1497.8 1367.8 1493.67 1372.85 1493.67C1377.89 1493.67 1381.99 1497.8 1381.99 1502.9Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.09 515.417C1616.09 520.52 1612 524.651 1606.95 524.651C1601.91 524.651 1597.81 520.52 1597.81 515.417C1597.81 510.313 1601.91 506.183 1606.95 506.183C1612 506.183 1616.09 510.313 1616.09 515.417Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.32 491.333C1602.32 496.436 1598.23 500.567 1593.18 500.567C1588.14 500.567 1584.04 496.436 1584.04 491.333C1584.04 486.229 1588.14 482.099 1593.18 482.099C1598.23 482.099 1602.32 486.229 1602.32 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.55 467.249C1588.55 472.352 1584.46 476.483 1579.41 476.483C1574.37 476.483 1570.27 472.352 1570.27 467.249C1570.27 462.145 1574.37 458.015 1579.41 458.015C1584.46 458.015 1588.55 462.145 1588.55 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.78 443.162C1574.78 448.266 1570.69 452.396 1565.64 452.396C1560.6 452.396 1556.5 448.266 1556.5 443.162C1556.5 438.059 1560.6 433.928 1565.64 433.928C1570.69 433.928 1574.78 438.059 1574.78 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.01 419.079C1561.01 424.182 1556.91 428.313 1551.87 428.313C1546.83 428.313 1542.73 424.182 1542.73 419.079C1542.73 413.975 1546.83 409.845 1551.87 409.845C1556.91 409.845 1561.01 413.975 1561.01 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.09 467.249C1616.09 472.352 1612 476.483 1606.95 476.483C1601.91 476.483 1597.81 472.352 1597.81 467.249C1597.81 462.145 1601.91 458.015 1606.95 458.015C1612 458.015 1616.09 462.145 1616.09 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.32 443.162C1602.32 448.266 1598.23 452.396 1593.18 452.396C1588.14 452.396 1584.04 448.266 1584.04 443.162C1584.04 438.059 1588.14 433.928 1593.18 433.928C1598.23 433.928 1602.32 438.059 1602.32 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.55 419.079C1588.55 424.182 1584.46 428.313 1579.41 428.313C1574.37 428.313 1570.27 424.182 1570.27 419.079C1570.27 413.975 1574.37 409.845 1579.41 409.845C1584.46 409.845 1588.55 413.975 1588.55 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.78 394.994C1574.78 400.098 1570.69 404.228 1565.64 404.228C1560.6 404.228 1556.5 400.098 1556.5 394.994C1556.5 389.891 1560.6 385.76 1565.64 385.76C1570.69 385.76 1574.78 389.891 1574.78 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.63 467.249C1643.63 472.352 1639.54 476.483 1634.49 476.483C1629.45 476.483 1625.35 472.352 1625.35 467.249C1625.35 462.145 1629.45 458.015 1634.49 458.015C1639.54 458.015 1643.63 462.145 1643.63 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.86 443.162C1629.86 448.266 1625.77 452.396 1620.72 452.396C1615.68 452.396 1611.58 448.266 1611.58 443.162C1611.58 438.059 1615.68 433.928 1620.72 433.928C1625.77 433.928 1629.86 438.059 1629.86 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.09 419.079C1616.09 424.182 1612 428.313 1606.95 428.313C1601.91 428.313 1597.81 424.182 1597.81 419.079C1597.81 413.975 1601.91 409.845 1606.95 409.845C1612 409.845 1616.09 413.975 1616.09 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.32 394.994C1602.32 400.098 1598.23 404.228 1593.18 404.228C1588.14 404.228 1584.04 400.098 1584.04 394.994C1584.04 389.891 1588.14 385.76 1593.18 385.76C1598.23 385.76 1602.32 389.891 1602.32 394.994Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.95 491.333C1684.95 496.436 1680.85 500.567 1675.81 500.567C1670.76 500.567 1666.67 496.436 1666.67 491.333C1666.67 486.229 1670.76 482.099 1675.81 482.099C1680.85 482.099 1684.95 486.229 1684.95 491.333Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.18 467.249C1671.18 472.352 1667.08 476.483 1662.04 476.483C1656.99 476.483 1652.9 472.352 1652.9 467.249C1652.9 462.145 1656.99 458.015 1662.04 458.015C1667.08 458.015 1671.18 462.145 1671.18 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.41 443.162C1657.41 448.265 1653.31 452.396 1648.27 452.396C1643.22 452.396 1639.12 448.266 1639.12 443.162C1639.12 438.059 1643.22 433.928 1648.27 433.928C1653.31 433.928 1657.41 438.059 1657.41 443.162Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.63 419.079C1643.63 424.182 1639.54 428.313 1634.49 428.313C1629.45 428.313 1625.35 424.182 1625.35 419.079C1625.35 413.975 1629.45 409.845 1634.49 409.845C1639.54 409.845 1643.63 413.975 1643.63 419.079Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.72 467.249C1698.72 472.352 1694.62 476.483 1689.58 476.483C1684.53 476.483 1680.44 472.352 1680.44 467.249C1680.44 462.145 1684.53 458.015 1689.58 458.015C1694.62 458.015 1698.72 462.145 1698.72 467.249Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.86 346.823C1629.86 351.927 1625.77 356.057 1620.72 356.057C1615.68 356.057 1611.58 351.927 1611.58 346.823C1611.58 341.72 1615.68 337.589 1620.72 337.589C1625.77 337.589 1629.86 341.72 1629.86 346.823Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.24 1599.24C1547.24 1604.34 1543.14 1608.47 1538.1 1608.47C1533.05 1608.47 1528.96 1604.34 1528.96 1599.24C1528.96 1594.13 1533.05 1590 1538.1 1590C1543.14 1590 1547.24 1594.13 1547.24 1599.24Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.01 1575.15C1561.01 1580.26 1556.91 1584.39 1551.87 1584.39C1546.83 1584.39 1542.73 1580.26 1542.73 1575.15C1542.73 1570.05 1546.83 1565.92 1551.87 1565.92C1556.91 1565.92 1561.01 1570.05 1561.01 1575.15Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.78 1551.07C1574.78 1556.17 1570.69 1560.3 1565.64 1560.3C1560.6 1560.3 1556.5 1556.17 1556.5 1551.07C1556.5 1545.96 1560.6 1541.83 1565.64 1541.83C1570.69 1541.83 1574.78 1545.96 1574.78 1551.07Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.55 1526.98C1588.55 1532.09 1584.46 1536.22 1579.41 1536.22C1574.37 1536.22 1570.27 1532.09 1570.27 1526.98C1570.27 1521.88 1574.37 1517.75 1579.41 1517.75C1584.46 1517.75 1588.55 1521.88 1588.55 1526.98Z",
    stroke: "#7B7B7B",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f23a2a4367868f7bb04903aad30d02a8.svg";
export { ForwardRef as ReactComponent };